const bg = {
  errors: {
    missingPermission: "Нямате право за това действие ({{permission}}).",
  },
  common: {
    scrollLeft: "Превърти наляво",
    scrollRight: "Превърти надясно",
    unsavedTitle: "Незапазени промени",
    unsavedDesc: "Имате незапазени промени. Да затворите ли без запазване?",
    unsavedLeave: "Затвори",
    unsavedStay: "Остани",
    appName: "UnrealSoft",
    installBannerKicker: "PWA",
    installBannerTitle: "Инсталирай UnrealSoft",
    installBannerDesc: "Добави приложението на началния екран за бърз достъп.",
    installBannerCta: "Инсталирай приложението",
    restaurantSystem: "Система за управление на ресторанти",
    logout: "Изход",
    fullscreen: "Цял екран",
    exitFullscreen: "Изход от цял екран",
    language: "Език",
    chooseLanguage: "Изберете език",
    theme: "Тема",
    chooseTheme: "Изберете тема",
    themeLight: "Светла",
    themeDark: "Тъмна",
    newVersionTitle: "Налична е нова версия",
    newVersionMessage: "Моля, презаредете приложението, за да я получите.",
    newVersionReload: "Презареди",
    qrTitle: "QR код",
    qrSubtitle: "Сканирайте, за да отворите ресторанта",
    backoffice: "Backoffice",
    cancel: "Отказ",
    confirm: "Потвърди",
    back: "Назад",
    close: "Затвори",
    save: "Запази",
    delete: "Изтрий",
    edit: "Редактирай",
    add: "Добави",
    search: "Търси",
    loading: "Зареждане...",
    error: "Грешка",
    forbidden: "Нямате права за тази операция",
    success: "Успешно",
    warning: "Внимание",
    info: "Информация",
    yes: "Да",
    no: "Не",
    ok: "OK",
    total: "Общо",
    date: "Дата",
    refresh: "Обнови",
    apply: "Приложи",
    clear: "Изчисти",
    filters: "Филтри",
    noData: "Няма данни",
    product: "Продукт",
    today: "Днес",
    yesterday: "Вчера",
    print: "Печат",
    options: "Опции",
    quantity: "Количество",
    price: "Цена",
    amount: "Сума",
    status: "Статус",
    comment: "Коментар",
    details: "Детайли",
    view: "Виж",
    min: "мин",
    selected: "Избрани",
    select: "Избери",
    max: "Макс",
    totalRecords: "Общо {{count}} записа",
    totalReports: "Общо {{count}} отчета",
    securedJwt: "Защитено с JWT • Anti-brute-force активен",
    callPhone: "Обади се на {{phone}}",
  },

  login: {
    welcomeKicker: "ДОБРЕ ДОШЛИ",
    eyebrow: "Ресторантска система",
    heroHeadline: "Управление на ресторанта, събрано на едно място.",
    feature1: "Поръчки, сметки и продажби в реално време",
    feature2: "Справки и анализ на приходите",
    feature3: "Конфигурация на меню, маси и оператори",
    title: "Вход в системата",
    subtitle: "Моля, въведете вашите данни за достъп.",
    usernameLabel: "Потребител",
    usernamePlaceholder: "admin",
    usernameRequired: "Въведете потребител",
    usernameMin: "Минимум 3 символа",
    passwordLabel: "Парола",
    passwordPlaceholder: "••••••••",
    passwordRequired: "Въведете парола",
    passwordMin: "Паролата трябва да е поне 3 символа",
    loginButton: "Вход",
    loginSuccess: "Успешен вход",
    loginSuccessDesc: "Добре дошли обратно!",
    loginFailed: "Неуспешен вход",
    loginFailedDesc: "Проверете потребителското име и паролата.",
    heroDescription:
      "Управлявай всички процеси в твоя ресторант лесно и бързо.",
    activeSession: "Активна сесия",
    activeSessionDesc:
      "Има активна сесия с този потребител. Сигурни ли сте, че искате да я прекратите?",
    terminateAndLogin: "Прекрати и Влез",
    insufficientLicenses: "Недостатъчен брой лицензи",
    selectUserToLogout:
      "Моля, изберете потребител, който да излезе от системата:",
    forceLogout: "Изход и влез",
    lastActivity: "Последна активност:",
  },

  dashboard: {
    greeting: "Здравейте, {{name}}",
    subtitle: "Изберете модул и продължете към съответната функционалност.",
  },

  modules: {
    pageTitle: "Модули",
    welcomeKicker: "Добре дошли",
    ordering: "Маркиране",
    orderingDesc:
      "Създавайте поръчки, маркирайте продукти по маси и управлявайте сметки в реално време",
    configuration: "Конфигурация",
    configurationDesc:
      "Конфигурирайте монитори, фискални принтери и системни настройки на заведението",
    monitors: "Монитори",
    monitorsDesc:
      "Наблюдавайте активни поръчки по станции и управлявайте статуса им в реално време",
    reports: "Справки",
    reportsDesc:
      "Преглеждайте история на маси, персонални и заведенски отчети, сторно и разделени сметки",
    reservations: "Резервации",
    reservationsDesc:
      "Планирайте и управлявайте резервации на маси, графици и наличност по дати",
    inventory: "Складова база",
    inventoryDesc:
      "Следете складови наличности, управлявайте доставки и контролирайте движението на стоки",
    discounts: "Отстъпки",
    discountsDesc:
      "Създавайте и управлявайте отстъпки, промоции и клиентски програми за лоялност",
    delivery: "Доставки",
    deliveryDesc:
      "Организирайте доставки, проследявайте куриери и управлявайте поръчки за доставка",
    changelog: "История на промените",
    changelogDesc:
      "Преглед на всички версии, нови функции, подобрения и поправки на системата",
    monitoring: "Мониторинг",
    monitoringDesc:
      "Одит на действията и фискални проблеми — служебен достъп за администратора",
    noRoles: "Нямате добавени роли",
    noRolesDesc:
      "За да имате достъп до модулите, трябва да ви бъдат добавени роли/права. Моля, свържете се с администратор.",
    comingSoonKicker: "Очаквайте скоро",
    comingSoonTitle: "{{module}} още се разработва",
    comingSoonDesc:
      "Работим по модула. Следете за актуализации — ще уведомим, щом бъде наличен.",
    comingSoonCta: "Разбрах",
    accessOn: "Достъп активен",
    revokeAccess: "Изход от ограничен достъп",
    rolesLabel: "Роли",
    accessModal: {
      title: "Организационен код",
      subtitle: "Въведете организационния код",
      clear: "Изчисти",
      backspace: "Назад",
      submit: "Вход",
      close: "Затвори",
    },
  },

  navbar: {
    reportsAndAnalysis: "Справки и анализи",
    configurationSubtitle: "Конфигурация на системата",
    monitorsSubtitle: "Наблюдение на поръчки",
    deliverySubtitle: "Управление на доставки",
    discountsSubtitle: "Управление на отстъпки",
    inventorySubtitle: "Складова база",
    reservationsSubtitle: "Управление на резервации",
  },

  sidebar: {
    dashboard: "Табло",
    sales: "Продажби",
    settings: "Настройки",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
  },

  ordering: {
    // Нова маса без интернет (`NewTableModal`): текстът СЛУЖИ и за
    // разпознаване — под него се показва редът какво може да направи управител.
    tableCheckOffline:
      "Няма връзка с облака — масата не е създадена. Провери интернета и опитай пак.",
    tableCheckOfflineHint:
      "Ако интернетът е спрял, управител може да превключи обекта на работа срещу касата.",
    // Сървърът е отговорил, но проверката за свободно име е счупена: масата се
    // създава въпреки това — заето име се отказва от самото създаване.
    tableCheckSkipped:
      "Не е проверено дали името е свободно ({{reason}}) — масата е създадена; заето име щеше да бъде отказано.",
    // Преименуване на маса (`RenameTableModal`): проверката за свободно име е
    // пропаднала. НЕ е отказ — „Запази" остава активно.
    renameCheckOffline:
      "Няма връзка с облака — не е проверено дали името е свободно. „Запази“ пак работи: заето име се отказва при самото преименуване.",
    renameCheckFailed:
      "Проверката за свободно име не мина: {{reason}}. „Запази“ пак работи.",
    // Бързо закриване без облак: номерът на новата маса е сметнат от масите на
    // ТОЗИ екран, не от BE-то.
    nextTableNameOffline:
      "Няма връзка с облака — номерът е избран от масите на този екран: {{name}}. Провери с колегите, преди да го обявиш.",
    nextTableNameLocal:
      "Номерът е избран от масите на този екран ({{name}}): {{reason}}",
    // Поръчка, тръгнала към облака, който не отговори. Не се повтаря сама —
    // затова текстът праща човека да погледне масата.
    orderCloudUnreachable:
      "Няма връзка с облака. Не е сигурно дали поръчката е стигнала — виж масата, преди да я пуснеш пак.",
    tableKicker: "Маса",
    loadingMenu: "Зареждане на меню...",
    searchProduct: "Търси продукт...",
    noProductsFound: "Няма намерени продукти",
    searchTable: "Търси маса, сметка или сервитьор...",
    cardNoReceiptTag: "Карта — без бон",
    tableClosing: "Закрива се",
    // Подсказката на етикета с името на гостите върху картата на масата
    seatedReservationTag: "Настанена резервация — {{name}}",
    seatedReservation: "Резервация",
    noTablesFound: "Няма намерени сметки",
    noTablesFoundHint: "Опитай с друга дума или изчисти търсенето.",
    noOpenTables: "Все още няма отворени сметки",
    noOpenTablesHint:
      "Създай нова маса от бутона отдолу, за да започнеш поръчка.",
    info: "Инфо",
    modify: "Промени",
    order: "Поръчай",
    newTable: "Нова маса",
    guestCount: {
      title: "Брой гости",
      quickPick: "Бърз избор",
      keyboardHint: "Натиснете цифра за бърз избор, ↑ ↓ за промяна.",
      confirm_one: "Потвърди · {{count}} гост",
      confirm_other: "Потвърди · {{count}} гости",
      saveError: "Броят гости не е записан",
    },
    closeTable: "Закрий",
    cancelItem: "Сторно",
    split: "Раздели",
    clients: "Клиенти",
    billDiscountClient: "Клиент",
    billDiscountBase: "Основа",
    billDiscountLabel: "Отстъпка",
    billSurchargeLabel: "Надбавка",
    discounts: "Отстъпки",
    lockedPriceNoDiscount:
      "На този продукт не може да се приложи отстъпка — заключена цена.",
    customPrice: "Промяна на цена",
    preliminaryBill: "Предварителна сметка",
    preliminaryBillPrinting: "Печат на предварителна сметка…",
    preliminaryBillSuccess: "Предварителната сметка е отпечатана.",
    preliminaryBillError: "Грешка при печат на предварителната сметка.",
    report: "Отчет",
    operations: "Фискални операции",
    invoicing: "Фактуриране",
    restore: "Възстановяване",
    selectTableToView:
      "Създайте нова маса от бутона отдолу, за да започнете нова поръчка.",
    noTableSelected: "Няма избрана маса",
    noTableSelectedHint:
      "Избери маса отляво, за да видиш поръчаните продукти, или създай нова от бутона отдолу.",
    noOrdersForTable: "Няма поръчки за тази маса",
    noOrdersForTableHint:
      "Добави продукти от менюто, за да започнеш поръчка на тази маса.",
    tableNumber: "Номер на маса",
    tableCreatedSuccess: 'Маса "{{name}}" е създадена и продуктите са добавени',
    tableJoinedSuccess: 'Маса "{{name}}" е отворена и продуктите са добавени',
    productsAddedSuccess: "Продуктите са добавени към масата",
    selectProductsWarning: "Моля, изберете продукти за поръчка",
    home: "Начало",
    modifiers: "Модификатори:",
    addonRequired: "изберете",
    addonRecommended: "препоръчани",
    addonOptional: "по избор",
    itemComment: "Коментар",
    itemCommentPlaceholder: "Допълнителна бележка към продукта",
    orderPreview: "Преглед на поръчката",
    summarized: "Обобщено",
    orderComment: "Коментар към поръчката:",
    commentPlaceholder: "Въведете коментар...",
    reservationNotice: {
      blockedTitle: "Масата е към настанена резервация",
      linkedTable: "Маса {{table}} е към настанената резервация на {{guest}} — сметката е на маса {{billTable}}. Поръчвай там.",
      understood: "Разбрах",
      title: "Масата има резервация",
      question: "{{notice}}. Продължаваш ли?",
      continue: "Продължи",
      seated: "Маса {{table}} е заета от резервацията на {{guest}} (настанени {{time}})",
      upcoming_one: "Маса {{table}} е резервирана за {{time}} — {{guest}}, {{count}} гост",
      upcoming_other: "Маса {{table}} е резервирана за {{time}} — {{guest}}, {{count}} гости",
      // „Отказ" при бързото отваряне → предложение за следващия свободен номер
      openInstead: "Маса {{reserved}} е резервирана. Да отворим ли маса {{free}}?",
      openTable: "Отвори маса {{name}}",
      noFreeTable: "Няма свободна маса без резервация — отвори ръчно",
      searchingFreeTable: "Търся свободна маса без резервация…",
    },
    tableAlreadyExists: 'Маса "{{name}}" вече съществува',
    pleaseChooseDifferentName: "Моля, изберете друго име за масата",
    add: "Добави",
    options: "Опции",
    // Влачене между „Опции" и лентата под масите (TableFooterBar)
    optionsDragHint: "Задръж бутон и го довлечи където искаш в лентата долу — и между основните. Обратно пак с влачене.",
    optionsDropHere: "Пусни тук, за да върнеш бутона в „Опции“",
    optionsEmpty: "Всички бутони са в лентата. Довлечи бутон тук, за да го върнеш.",
    footerLayoutSaveError: "Подредбата на лентата не се записа",
    // Гласова поръчка (микрофонът до търсачката на масите)
    voiceOrder: "Гласова поръчка",
    voiceListening: "Говорете…",
    voiceHold: "Задръжте и говорете",
    voiceListeningHint:
      "Например: „Отвори маса 1 и добави 2 пъти салата цезар с 2 коли“",
    voiceTranscribing: "Разпознаване на речта…",
    voiceProcessing: "Разпознаване на поръчката…",
    voiceNotSupported:
      "Този браузър не дава достъп до микрофона. Отворете приложението през https:// в актуален браузър.",
    voiceNoSpeech: "Не чух нищо. Опитайте отново.",
    voiceMicDenied:
      "Няма достъп до микрофона — разрешете го от настройките на браузъра.",
    voiceMicUnavailable:
      "Микрофонът не е достъпен — проверете дали друго приложение не го ползва.",
    voiceErrAudioTooLarge: "Записът е твърде дълъг — опитайте с по-кратка поръчка.",
    voiceErrUnsupportedAudio:
      "Форматът на записа не се поддържа от този браузър.",
    voiceParseError: "Неуспешно разпознаване на поръчката. Опитайте отново.",
    // Кодовете идват от BE-то (502 → detail.code); непознат код пада към
    // voiceParseError. Виж cloudTS-restaurant-be/docs/cross-repo-contract.md.
    voiceErrTooLong:
      "Поръчката е твърде дълга — разделете я на няколко по-къси.",
    voiceErrUnreadable: "Неразбираем отговор от модела. Опитайте отново.",
    voiceErrEmpty: "Празен отговор от модела. Опитайте отново.",
    voiceErrRefused: "Заявката беше отказана от модела. Опитайте отново.",
    voiceErrUpstream:
      "Услугата за разпознаване е недостъпна в момента. Опитайте отново.",
    voiceErrNotConfigured:
      "Гласовите поръчки не са настроени. Обърнете се към администратор.",
    voiceNoItems: "Не са разпознати продукти в казаното.",
    // „Настани резервацията на …" по глас (voice/useVoiceSeat.tsx).
    voiceSeatNotFound: "Няма резервация за настаняване на име „{{name}}“",
    voiceSeatNotAllowed: "Нямаш право да настаняваш резервации",
    voiceRetry: "Отново",
    voiceContinue: "Продължи",
    voiceChooseHint:
      "Казаното съвпада с няколко възможности — изберете кое имате предвид.",
    voiceNeedsConfig: "Изберете задължителните добавки",
    voiceTable: "Маса",
    voiceTableNew: "нова маса",
    voiceTableExisting: "допоръчка към отворената маса",
    voiceTablePlaceholder: "напишете маса…",
    voiceNoMatch: "няма съвпадение в менюто",
    voiceConfirm: "Поръчай",
    voiceCancel: "Отказ",
    voiceSuccess: "Поръчката за маса „{{name}}“ е изпратена.",
    itemServed: "Продуктът е маркиран като сервиран",
    itemUnserved: "Сервирането е отменено",
    itemServedError: "Грешка при маркиране на продукта като сервиран",
    servedStatus: "Сервирано",
    statusLegend: "Легенда на статусите",
    statusNotStarted: "Незапочнато",
    statusInProgress: "В процес",
    statusCooked: "Сготвено",
    statusIssued: "Издадено",
    closeTableSuccess: "Сметката е затворена успешно.",
    closeTableError: "Грешка при затваряне на сметката.",
    renameTable: "Смяна на маса",
    renameTableTitle: "Преименуване на маса",
    renameTableSubtitle: "Ново име на масата",
    renameTableSuccess: 'Масата е преименувана на "{{name}}"',
    renameTableError: "Грешка при преименуване на масата",
    transferBill: "Смяна на сервитьор",
    transferBillTitle: "Прехвърляне на сметка на друг сервитьор",
    transferBillSubtitle: "Сервитьори: {{count}}",
    transferBillConfirm: "Прехвърли",
    transferBillSuccess: "Сметката е прехвърлена успешно",
    transferBillError: "Грешка при прехвърляне на сметката",
    transferAllBills: "Прехвърли всичките ми {{count}} маси",
    transferAllBillsSuccess: "Прехвърлени са {{count}} маси",
    transferAllBillsError: "Грешка при прехвърляне на масите",
    discardItemsConfirmTitle: "Излизане от поръчката",
    discardItemsConfirmContent:
      "Сигурни ли сте? Маркираните продукти ще бъдат премахнати.",
    productsShortCount: "{{count}} прод.",
    itemsShortCount: "{{count}} арт.",
    orderSheetTitle: "Поръчка",
    modifyDone: "Добави · {{price}}",
    modifyOrder: "Поръчай · {{price}}",
    reorderUnavailable: "Продуктът не е наличен в менюто",
    allCategories: "Всички категории",
    noGroup: "Без група",
    emptyOrder: "Изберете продукти отляво, за да започнете поръчка.",
    emptyOrderShort: "Все още няма продукти.",
    allRows: "Всички",
    sortName: "АБВ",
    sortPlu: "КОД",
    allStations: "Всички станции",
    viewTiles: "Плочки",
    viewTable: "Таблица",
    keyboard: "Клавиатура",
    hideKeyboard: "Скрий",
    space: "Интервал",
    clearSearch: "Изчисти",
    backspace: "Изтрий знак",
    searchKicker: "Търси",
    searchHint: "въведи име или код",
    kbBds: "БДС",
    kbPhonetic: "Фонетична",
    kbLatin: "ABC",
    previewStations: "Станции",
    previewGroups: "Групи",
  },

  codeKeypad: {
    title: "Въведете код",
    enterCode: "Въведете код",
    invalidCode: "Невалиден код",
    codeVerified: "Кодът е верифициран успешно",
    submit: "Вход",
    kicker: "Вход с личен код",
    clear: "Изчисти",
    venue: "Заведение",
    online: "Онлайн",
    hint: "Може да въвеждате и от клавиатурата",
  },

  logoutConfirm: {
    title: "Потвърждение за изход",
    subtitle: "Моля, въведете паролата си за потвърждение",
    passwordPlaceholder: "Парола",
    invalidPassword: "Невалидна парола",
    verificationError: "Грешка при верификация на паролата",
  },

  closeTable: {
    table: "Маса:",
    operator: "Оператор:",
    paymentMethod: "Метод на плащане:",
    selectMethod: "Изберете метод:",
    notSelected: "Не е избран",
    noMethodsTitle: "Няма налични методи на плащане",
    noMethodsDescription:
      "Добавете и активирайте методи от Конфигурация → Методи на плащане.",
    selectPaymentWarning: "Моля, изберете метод на плащане",
    sumMismatch: "Сумата трябва да е {{total}} Въведена сума: {{entered}}.",
    totalChanged:
      "Сметката е променена — новата сума е {{total}}. Провери и потвърди отново.",
    closeSuccess: "Сметката беше успешно закрита",
    closeError: "Грешка при закриване на сметката",
    alreadyClosed: "Сметката вече е закрита",
    printerError: "Сметката е закрита, но принтерът върна грешка",
    printerTimeout: "Сметката е закрита, но принтерът не отговори навреме",
    closeButton: "Закриване",
    // Изходът от закриване във фон — модалът вече е затворен, затова
    // известието казва за коя маса е (payment/backgroundBillClose.ts).
    paymentFailed: "Неуспешно плащане — маса {{table}}: {{text}}",
    stillClosing: "Тази маса още се закрива — изчакайте бона.",
    tableNotice: "Маса {{table}} — {{text}}",
    paymentDistribution: "Разпределение на плащането:",
    cash: "В брой",
    card: "С карта",
    mixedTotal: "Общо: {{entered}} / {{total}}",
    totalToPay: "Общо за плащане:",
    banknotes: "Банкноти:",
    received: "Получено:",
    remaining: "Остава за доплащане",
    amountBeforeDiscount: "Сума без отстъпка",
    amountBeforeSurcharge: "Сума без надбавка",
    clientDiscount: "Отстъпка на клиента ({{percent}})",
    clientSurcharge: "Надбавка на клиента ({{percent}})",
    change: "Ресто за връщане",
    exactAmount: "Точно",
    cardTerminalHint: "Плащане чрез терминал за карти.",
  },

  cancelItem: {
    titleAssortments: "Сторно на асортименти",
    titleRecipes: "Сторно на рецепти",
    subtitle: "Маса {{name}} · Сметка №{{id}} · общо {{total}} €",
    ofQuantity: "от {{max}}",
    confirmButton: "Сторнирай",
    defective: "Брак",
    selectAll: "Избери всичко",
    reasonLabel: "Причина",
    reasonWrongMark: "Грешно маркирано",
    reasonCustomerRefused: "Отказ от клиент",
    reasonOrderChanged: "Промяна на поръчката",
    reasonOther: "Друго",
    reasonPlaceholder: "Опиши причината...",
    // Пропаднало сторно: прозорецът ОСТАВА отворен със селекцията.
    failed:
      "Сторното не мина. Прозорецът остава отворен — виж сметката и опитай пак.",
    failedReason:
      "Сторното не мина: {{reason}}. Виж сметката — кредитното известие може и да е излязло.",
  },

  splitBill: {
    title: "Раздели сметка",
    subtitle: "Маса {{name}} · {{total}} €",
    sumLabel: "Сума:",
    modeByProducts: "По продукти",
    modeEqual: "По равно",
    modifiersLabel: "Модификатори:",
    addonsLabel: "Добавки:",
    selectedProducts: "Избрани продукти: {{count}}",
    selectAll: "Избери всичко",
    splitButton: "Раздели",
    cancelButton: "Отказ",
    splitError: "Грешка при разделяне на сметка",
    transferWaiterTitle: "Прехвърли към сервитьор",
    transferWaiterSubtitle: "Сервитьори: {{count}}",
    transferWaiterSearch: "Търси сервитьор...",
    transferWaiterNone: "Няма намерени сервитьори",
    transferWaiterSkip: "Прескочи",
    transferWaiterConfirm: "Прехвърли",
    transferWaiterCurrent: "Текущ",
    transferWaiterResponsibility: "Отговорността за {{total}} EUR се прехвърля",
    transferWaiterFrom: "От",
    transferWaiterTo: "На",
    transferWaiterNoTarget: "избери сервитьор",
    transferWaiterTablesOne: "1 маса",
    transferWaiterTables: "{{count}} маси",
    transferWaiterConfirmTo: "Прехвърли на {{name}}",
    splitAndPayButton: "Раздели и плати",
    splitAndPayTitle: "Раздели и плати",
    splitAndPaySubtitle: "От сметка #{{name}}",
    splitAndPaySuccess: "Сметката е разделена и платена успешно",
    splitAndPayError: "Грешка при разделяне и плащане",
    billChanged:
      "Сметката е променена — провери избраните продукти и опитай отново.",
  },

  confirmSplit: {
    title: "Масата е заета",
    transferQuestion:
      "Желаете ли да прехвърлите избраните продукти към вече отворената маса?",
    transferButton: "Прехвърли",
    occupiedByOtherWaiter: "Маса „{{name}}“ вече е заета от друг сервитьор.",
    noTransferPermission:
      "Нямате право да прехвърляте разделени продукти към друг сервитьор.",
    understoodButton: "Разбрах",
  },
  duplicateTableName: {
    title: "Масата ще се дублира",
    transferMessage:
      "Сервитьорът, към когото прехвърляте, вече има отворена маса „{{name}}“.",
    restoreMessage: "Вече има отворена маса „{{name}}“.",
    transferAllMessage:
      "Сервитьорът, към когото прехвърляте, вече има отворени маси с някои от вашите имена.",
    transferAllQuestion:
      "Ако продължите, ще има по две отворени маси с едно и също име.",
    question:
      "Ако продължите, ще има две отворени маси с име „{{name}}“.",
    confirm: "Продължи",
  },

  itemDiscounts: {
    title: "Отстъпки",
    subtitle: "Маса {{name}} · {{total}} €",
    emptyBill: "В тази сметка няма продукти.",
    generalTitle: "Обща отстъпка",
    generalHint: "Важи за избраните редове без собствена отстъпка",
    ownPercentCount_one: "{{count}} ред е със собствена отстъпка и не се променя",
    ownPercentCount_other: "{{count}} реда са със собствена отстъпка и не се променят",
    none: "Без",
    selectAll: "Избери всички",
    discountedOfTotal: "{{discounted}} от {{total}} с отстъпка",
    removeAll: "Премахни всички",
    forThisRow: "За този ред",
    followGeneral: "Обща · {{percent}}%",
    ownSuffix: "ред",
    currentPercentTitle: "Сега: −{{percent}}%",
    discountLabel: "Отстъпка",
    customPriceHint: "променена цена",
    applySuccess: "Отстъпките са записани",
  },

  customPrice: {
    title: "Промяна на цена",
    subtitle: "Натиснете молива до продукт или добавка и въведете нова цена",
    emptyBill: "В тази сметка няма продукти.",
    changedCount: "Променени цени: {{count}}",
    invalidRows: "Невалидна цена на {{count}} реда — празно или 0.",
    restore: "Върни цената от менюто",
    applySuccess: "Цените са променени",
  },

  clients: {
    title: "Клиенти с отстъпки",
    total: "Общо: {{count}}",
    noClients: "Няма намерени клиенти",
    onAccountBadge: "По сметка",
    select: "Избери",
    searchPlaceholder: "Търси по име или карта...",
    applySuccess: "Отстъпката е приложена успешно",
    applySurchargeSuccess: "Надбавката е приложена успешно",
    removeDiscount: "Премахнете приложената отстъпка ({{discount}})",
    removeDiscountNamed: "Премахни отстъпка - {{name}} ({{discount}})",
    removeSurcharge: "Премахнете приложената надбавка ({{discount}})",
    removeSurchargeNamed: "Премахни надбавка - {{name}} ({{discount}})",
    removeSuccess: "Отстъпката е премахната успешно",
    removeSurchargeSuccess: "Надбавката е премахната успешно",
    active: "Активен",
    inactive: "Неактивен",
    from: "От",
    to: "До",
    monday: "Пон",
    tuesday: "Вто",
    wednesday: "Сря",
    thursday: "Чет",
    friday: "Пет",
    saturday: "Съб",
    sunday: "Нед",
    // Лентата „закачен клиент" (масите + модалът за закриване)
    bannerDiscountAssortments: "отстъпка {{percent}} на всички асортименти",
    bannerDiscountRecipes: "отстъпка {{percent}} на всички рецепти",
    bannerSurchargeAssortments: "надбавка {{percent}} на всички асортименти",
    bannerSurchargeRecipes: "надбавка {{percent}} на всички рецепти",
    // Част от редовете са с друг процент (отстъпка по ред / промяна на цена)
    bannerDiscountPartialAssortments:
      "отстъпка {{percent}} на {{count}} от {{total}} асортимента",
    bannerDiscountPartialRecipes:
      "отстъпка {{percent}} на {{count}} от {{total}} рецепти",
    bannerSurchargePartialAssortments:
      "надбавка {{percent}} на {{count}} от {{total}} асортимента",
    bannerSurchargePartialRecipes:
      "надбавка {{percent}} на {{count}} от {{total}} рецепти",
    bannerNoDiscount: "без отстъпка",
    bannerSaved: "Спестени",
    bannerSurcharged: "Надбавка",
  },

  reportType: {
    selectType: "Изберете вид отчет",
    personal: "Персонален отчет",
    establishment: "Отчет на заведението",
  },

  invoicing: {
    selectBillTitle: "Избор на сметка",
    selectBillSubtitle:
      "Списък с всички нефактурирани затворени сметки. Избери една или няколко за да продължиш.",
    selectBillSubtitleWindow:
      "Нефактурирани затворени сметки от последните {{days}} дни. Избери една или няколко за да продължиш.",
    searchPlaceholder: "Търси по име на маса, сервитьор или плащане",
    selectAll: "Избери всички",
    selectRow: "Избери сметка",
    colId: "Час",
    colTable: "Маса",
    colWaiter: "Сервитьор",
    colPayment: "Плащане",
    colTotal: "Сума",
    confirm: "Избор",
    confirmWithCount: "Избор ({{count}})",
    selectedCount: "Избрани сметки: {{count}}",
    emptyAll: "Няма нефактурирани затворени сметки.",
    emptyFiltered: "Няма сметки, отговарящи на търсенето.",
    loadError: "Грешка при зареждане на сметките",
    needDefaultCompany: "Първо създайте текуща фирма в Конфигурации → Фирми.",
    warnAlreadyInvoiced: "Фактурата вече е издадена",
    warnOnlyClosed: "Само затворени сметки могат да се фактурират",
    warnCashNoReceipt:
      "Сметката е закрита в брой без касова бележка и не подлежи на фактуриране",
    warnWindowExpired: "Изтекъл срок за фактуриране ({{days}} дни)",
  },

  invoicesReport: {
    title: "Справка по фактури",
    listKicker: "Списък фактури",
    resultOne: "{{count}} фактура",
    results: "{{count}} фактури",
    searchPlaceholder: "Търси по Фактура №, Получател или ЕИК",
    typeTax: "Данъчна",
    typeSimplified: "Опростена",
    clearFilters: "Изчисти филтри",
    cancelledOnly: "Само анулирани",
    empty: "Няма издадени фактури в избрания период.",
    view: "Виж",
    colNumber: "Фактура №",
    colDate: "Дата",
    colTime: "Час",
    colType: "Тип",
    colCustomer: "Получател",
    colEik: "ЕИК",
    colTaxable: "Облагаема",
    colNonTaxable: "Необлагаема",
    colVatRate: "ДДС %",
    colVat: "ДДС",
    colGrand: "Общо",
    colView: "Действия",
    kpiCount: "Фактури",
    kpiTaxable: "Облагаема",
    kpiNonTaxable: "Необлагаема",
    kpiVat: "ДДС",
    kpiGrand: "Общо",
    cardRevenueTitle: "Общ оборот от фактури",
    cardRevenueCountLabel: "Брой",
    cardRevenueAvgLabel: "Среден размер",
    cardVatTitle: "Разбивка облагаема / ДДС / необлагаема",
  },

  invoicePreview: {
    title: "Фактура № {{number}}",
    subtitle: "Издадена на {{date}}",
    recipient: "Получател",
    supplier: "Изпълнител",
    editCustomer: "Редакция на получател",
    editCustomerSubtitle:
      "Само данните на получателя — суми, редове, номер и дати не се променят.",
    editCustomerSuccess: "Получателят е обновен",
    editCustomerError: "Грешка при запис на получателя",
    titleOriginal: "ФАКТУРА ОРИГИНАЛ",
    titleDuplicate: "ФАКТУРА ДУБЛИКАТ",
    titleSimplified: "ОПРОСТЕНА ФАКТУРА",
    docNumber: "Номер",
    docDate: "Дата",
    supplyDate: "Дата на дан. събитие",
    supplyPlace: "Място на сделката",
    colDescription: "Вид стока / услуга",
    colVatRate: "ДДС %",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    colTotal: "Сума",
    totalWords: "Обща стойност словом",
    sumTotal: "Всичко сума",
    sumTaxable: "Дан. основа",
    sumNonTaxable: "Необлагаема сума",
    sumVat: "ДДС",
    sumGrand: "Обща стойност (EUR)",
    goodsReceived: "Стоката / услугата получена:",
    receivedAt: "На дата",
    receivedBy: "От",
    paymentMethod: "Начин на плащане",
    noteLabel: "Коментар",
    preparedBy: "Съставил",
    print: "Печат",
    printDuplicate: "Печат на дубликат",
    printPos: "Печат (POS)",
    printPosConfirmTitle: "Печат на фактура",
    printPosConfirmDescription: "Печат на фактурата през POS принтер?",
    printPosSuccess: "Фактурата е изпратена към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
    cancel: "Анулирай",
    cancelConfirmTitle: "Потвърждение за анулиране",
    cancelConfirmContent:
      "Сигурни ли сте, че искате да анулирате фактура с № {{number}}?",
    cancelSuccess: "Фактурата е анулирана",
    cancelError: "Грешка при анулиране на фактурата",
    cancelledBadge: "АНУЛИРАНА",
  },

  invoiceCreate: {
    title: "Издаване на фактура",
    subtitle: "Документ върху {{count}} избрани сметки",
    secDocument: "Документ",
    secCustomer: "Клиент",
    secReceiving: "Получаване",
    secItems: "Артикули",
    secTotals: "Обобщение",
    fieldNumber: "Номер",
    numberHint: "автоматично +1 от последно издадена",
    fieldType: "Тип",
    typeTax: "Данъчна фактура",
    typeSimplified: "Опростена фактура",
    fieldIssueDate: "Дата на издаване",
    fieldSupplyDate: "Дата на сделката",
    fieldSupplyPlace: "Място на сделката",
    fieldPaymentMethod: "Начин на плащане",
    optional: "по желание",
    fieldName: "Име на фирмата",
    fieldVat: "ДДС №",
    fieldCity: "Населено място",
    fieldAddress: "Адрес",
    fieldMol: "МОЛ",
    fieldPickCompany: "Изберете фирма",
    fieldPickCompanyPh: "Търси по име или ЕИК",
    fieldCustomerEik: "ЕИК №",
    phCustomerEik: "9 или 13 цифри",
    phCustomerCity: "Напр. София",
    phCustomerName: 'Напр. "Тест ООД"',
    phCustomerAddress: "Седалище и адрес на управление",
    phCustomerMol: "Имена на лицето",
    noCustomers: "Все още няма запазени клиенти",
    noCustomersForQuery: "Няма съвпадения",
    noDefaultCompany: "Все още няма зададена текуща фирма",
    lookupTitle: "Извлечи данни от Търговски регистър",
    lookupInvalidEik: "Първо въведете валиден ЕИК",
    lookupSuccess: "Данните са попълнени от Търговски регистър",
    lookupFailed: "Неуспешно извличане. Опитайте отново или въведете ръчно.",
    fieldReceivedBy: "Получил",
    fieldReceivedByPh: "Имена на лицето",
    fieldReceivedAt: "Дата на получаване",
    colName: "Наименование",
    colUnit: "Ед.",
    colVat: "ДДС %",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    colVatAmount: "Сума на ДДС",
    colTotal: "Сума",
    colGross: "Сума с ДДС",
    noLines: "Няма артикули.",
    totalSum: "Всичко сума",
    totalTaxable: "Дан. основа",
    totalNonTaxable: "Необлагаема сума",
    totalVat: "ДДС",
    totalGrand: "Обща стойност",
    totalWords: "Обща стойност словом",
    note: "Забележка",
    noteOneBill: "Сметка: {{id}}",
    noteManyBills: "Сметки: {{ids}}",
    actionEdit: "Промяна",
    actionDelete: "Изтриване",
    actionSummarize: "Обобщаване",
    actionAdd: "Нов ред",
    save: "Запис",
    editLineTitle: "Редакция на ред",
    editLineSubtitle:
      "Промяна на наименование, мярка, ДДС, количество и ед. цена. Сумата се изчислява автоматично.",
    newLineTitle: "Нов ред",
    newLineSubtitle:
      "Добавете артикул ръчно. Само наименованието е задължително.",
    addLine: "Добави",
    summarizeTitle: "Обобщаване на сметката",
    summarizeSubtitle:
      "Изберете как да бъдат показани артикулите в готовата фактура.",
    summarizePerItem: "По име и цена",
    summarizePerItemDesc:
      "Всеки артикул на отделен ред — както е поръчан от клиента.",
    summarizeSingle: "Всичко на един ред",
    summarizeSingleDesc:
      'Един ред "Консумация" с количество 1 и общата сума на сметката.',
    summarizeApply: "Приложи",
    summarizedName: "Консумация",
    deleteConfirmTitle: "Изтриване на ред",
    deleteConfirmDesc: 'Сигурни ли сте, че искате да изтриете "{{name}}"?',
    deleteConfirmOk: "Изтрий",
    mismatchOneBill: "сметката",
    mismatchManyBills: "сметките",
    mismatchTitle: "Тотала на фактурата е различен от сумата на {{context}}",
    mismatchBody: "Желаете ли да продължите със записа?",
    mismatchBillsTotal: "Сума на сметката(те)",
    mismatchInvoiceTotal: "Тотал на фактурата",
    errInvoiceNumber: "Въведете валиден номер на фактурата",
    errDates: "Изберете дати на издаване и сделката",
    errPaymentMethod: "Изберете начин на плащане",
    errCustomerEik: "Невалиден ЕИК на клиента",
    errCustomerVat: "ДДС № трябва да е във формат BG + 9 или 10 цифри",
    errCustomerFields: "Попълнете име на фирмата, населено място и адрес",
    errNoLines: "Добавете поне един артикул",
    saveSuccess: "Фактурата е записана успешно",
    saveError: "Грешка при запис на фактурата",
  },

  operations: {
    selectType: "Изберете вид операция",
    xReport: "X отчет (без нулиране)",
    zReport: "Z отчет (с нулиране)",
    // Отчет от фискалната памет за период — друг документ, не X с дати.
    fmReport: "Справка отчети за дата",
    fmReportDetail: "Вид на отчета",
    fmReportShort: "Съкратен",
    fmReportFull: "Подробен",
    fmReportShortHint: "Сумите за периода в един кратък отчет.",
    fmReportFullHint:
      "По един блок за всеки Z отчет в периода — за дълъг период това са метри хартия.",
    fmReportPeriod: "Период на отчета",
    fmPresetLastMonth: "Предходен месец",
    fmPresetThisMonth: "Този месец",
    fmPresetPeriod: "Период",
    fmPresetLastMonthHint:
      "От {{from}} до {{to}}. Месечният отчет се пуска до {{deadlineDay}}-о число на следващия месец.",
    fmPresetThisMonthHint: "От {{from}} до днес ({{to}}).",
    fmPeriodFrom: "От",
    fmPeriodTo: "До",
    fmPeriodLongSpanHint:
      "Без ограничение. Подробен отчет над {{days}} дни иска потвърждение преди печат.",
    // Дълъг подробен отчет — въпрос към оператора, не забрана.
    fmLongPeriodTitle: "Дълъг подробен отчет",
    fmLongPeriodMessage:
      "Избраният период е {{days}} дни. Подробният отчет печата по един блок за всеки Z отчет в него — това са метри хартия и няколко минути печат.",
    fmLongPeriodQuestion:
      "Да отпечатаме ли въпреки това? Ако ви трябват само сумите за периода, изберете „Съкратен“.",
    fmLongPeriodConfirm: "Печатай",
    fmReportPeriodRequired: "Изберете период",
    fmReportInvalidPeriod: "Крайната дата е преди началната",
    fmReportFuturePeriod: "Периодът е в бъдещето",
    fmReportSuccess: "Отчетът за периода е отпечатан",
    xReportSuccess: "X отчетът е отпечатан",
    zReportSuccess: "Z отчетът е отпечатан",
    cashIn: "Служебно въвеждане",
    cashOut: "Служебно извеждане",
    enterAmount: "Въведете сума",
    amountRequired: "Моля, въведете сума по-голяма от 0",
    cashInSuccess: "Служебното въвеждане е успешно",
    cashOutSuccess: "Служебното извеждане е успешно",
    error: "Грешка при изпълнение на операцията",
  },

  generateReport: {
    title: "Генериране на отчет",
    establishmentTitle: "Генериране на отчет на заведението",
    selectUser: "Изберете потребител:",
    selectUserWarning: "Моля, изберете потребител",
    reportDate: "Дата на отчет:",
    selectDate: "Изберете дата",
    previewReport: "Преглед на отчет",
    // В режим „със склад" продаваемото е рецепта → същият чекбокс, друго име.
    showSoldAssortments: "Покажи продадените асортименти",
    showSoldRecipes: "Покажи продадените рецепти",
    loadUsersError: "Грешка при зареждане на потребителите",
    previewError: "Грешка при преглед на отчета",
    establishmentPreviewError: "Грешка при преглед на отчета на заведението",
    reportCreated: "Отчетът е създаден успешно",
    establishmentReportCreated: "Отчетът на заведението е създаден успешно",
    generateError: "Грешка при генериране на отчета",
    establishmentGenerateError:
      "Грешка при генериране на отчета на заведението",
    resetReport: "Нулиране на отчета",
    resetFromReport: "Нулиране от отчета?",
    confirmAgain: "Потвърдете още веднъж?",
    resetButton: "Нулирай",
    noUsersAvailable: "Няма потребители с неотчетени сметки",
    resetConfirmDescription:
      "Тази операция ще нулира всички неотчетени сметки и ще генерира нов отчет. Действието не може да бъде отменено.",
    resetConfirmEstablishmentDescription:
      "Тази операция ще генерира отчет на заведението от всички персонални отчети за избраната дата. Действието не може да бъде отменено.",
    resetConfirmEstablishmentWithPersonalDescription:
      "Тази операция ще генерира всички персонални отчети и отчет на заведението за избраната дата. Действието не може да бъде отменено.",
    unreportedUsersTitle: "Има неприключени отчети на тези сервитьори:",
    unreportedUsersTitleSingle: "Има неприключен отчет на този сервитьор:",
    zReportConfirmTitle: "Нулиране на дневен финансов отчет",
    zReportConfirmDescription:
      "Нулиране на дневния финансов отчет (Z-отчет)? Тази операция изпраща Z-отчет към фискалното устройство.",
    printPosConfirmTitle: "Печат на отчет",
    printPosConfirmDescription: "Печат на отчет през POS принтер?",
  },

  personalReport: {
    title: "Персонален отчет № {{number}} / {{date}} г.",
    testRestaurant: "Тестов Ресторант",
    turnoverByPayment: "Обороти по видове плащания",
    paymentType: "Вид плащане",
    bills: "Сметки",
    alone: "Сам",
    inBrigade: "В бригада",
    compliment: "Комплимент",
    deposit: "Депозит",
    cashPayment: "В брой",
    cardPayment: "Карта",
    cancelledByStation: "Сторнирани асортименти по станции",
    bar: "Бар",
    qty: "Кол.",
    firstLastOrder: "Първа / последна поръчка",
    cashDescription: "Опис на парите в брой",
    coins: "центове",
    firstLastBill: "Първа / последна сметка",
    amountToReport: "Сума за отчитане:",
    accepted: "Приел:",
    created: "Създал:",
    dateLabel: "Дата:",
    printPos: "Принтирай (POS)",
    printPosSuccess: "Отчетът е изпратен към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
  },

  establishmentReport: {
    title: "Отчет на заведението № {{number}} / {{date}} г.",
    includedPersonalReports: "Включени персонални отчети: {{count}}",
    turnoverByPayment: "Обороти по видове плащания",
    paymentType: "Вид плащане",
    bills: "Сметки",
    amount: "Сума",
    cashPayment: "В брой",
    cardPayment: "Карта",
    otherPayment: "Друго",
    firstLastOrder: "Първа / последна поръчка",
    firstLastBill: "Първа / последна сметка",
    stationBreakdown: "Разбивка по станции",
    station: "Станция",
    totalBills: "Общо сметки",
    totalAmount: "Обща сума",
    userBreakdown: "Разбивка по потребители",
    user: "Потребител",
    reports: "Отчети",
    cancelledByStation: "Анулирани продукти по станции",
    totalForStation: "Общо за {{name}}",
    // В режим „със склад" продаваемото е рецепта → същата секция, друго име.
    soldAssortments: "Продадени асортименти",
    soldRecipes: "Продадени рецепти",
    assortment: "Асортимент",
    recipe: "Рецепта",
    printPos: "Принтирай (POS)",
    printPosSuccess: "Отчетът е изпратен към POS принтера",
    printPosError: "Грешка при печат на POS принтера",
    resetWillFinalizePersonalReports:
      "Нулирането на <b>Отчета на заведението</b> ще приключи всички <b>Персонални отчети</b> за деня",
  },

  reports: {
    billsHistory: "Справка сметки",
    splitBills: "Разделени маси",
    cancellations: "Сторно",
    personalReports: "Персонални отчети",
    establishmentReports: "Отчети на заведението",
  },

  billsHistory: {
    title: "История на маси",
    table: "Маса",
    statusCol: "Статус",
    open: "Отворена",
    closed: "Затворена",
    openedAt: "Отворена",
    closedAt: "Затворена",
    duration: "Продължителност",
    hours: "ч",
    minutes: "мин",
    orders: "Поръчки",
    cancelledItems: "Сторнирани",
    cancelledLabel: "Сторно: {{count}}",
    payment: "Плащане",
    cashLabel: "Брой: {{amount}}",
    cardLabel: "Карта: {{amount}}",
    tables: "Маси",
    totalAmount: "Обща сума",
    statusFilter: "Статус",
    openFilter: "Отворени",
    closedFilter: "Затворени",
    waiterFilter: "Сервитьор",
    paymentMethodFilter: "Метод на плащане",
    fromDate: "От дата",
    toDate: "До дата",
    noData: "Няма данни за маси",
  },

  billsSplits: {
    title: "Разделени маси",
    dateCol: "Дата",
    fromTable: "От маса",
    toTable: "Към маса",
    products: "Продукти",
    totalSplits: "Общо разделяния",
    transferredProducts: "Прехвърлени продукти",
    fromTableFilter: "От маса (ID)",
    toTableFilter: "Към маса (ID)",
    noData: "Няма данни за разделени маси",
  },

  cancellationsReport: {
    title: "Справка за сторнирани продукти",
    bill: "Сметка",
    product: "Продукт",
    qtyCol: "Кол-во",
    unitPrice: "Цена (единична)",
    reason: "Причина",
    statusCol: "Статус",
    defective: "✓ Брак",
    cancelled: "Сторно",
    totalCancelled: "Общо сторнирани",
    defectiveItems: "Бракувани артикули",
    billIdFilter: "ID на сметка",
    selectUsers: "Избери потребители",
    defectiveOnly: "Само бракувани продукти",
    noData: "Няма сторнирани продукти",
  },

  personalReportsPage: {
    title: "Персонални отчети",
    allUsers: "Всички потребители",
    userCol: "Потребител",
    billsCol: "Сметки",
    cashCol: "В брой",
    cardCol: "Карта",
    totalCol: "Обща сума",
    noData: "Няма намерени отчети",
  },

  establishmentReportsPage: {
    title: "Отчети на заведението",
    personalReportsCol: "Персонални отчети",
    billsCol: "Сметки",
    cashCol: "В брой",
    cardCol: "Карта",
    totalCol: "Обща сума",
    noData: "Няма намерени отчети",
  },

  billDetails: {
    tableTitle: "Маса {{name}}",
    openedAt: "Отворена:",
    closedAt: "Затворена:",
    noOrders: "Няма поръчки",
    fromTable: "от маса {{name}}",
    split: "Разделена",
    commentLabel: "Коментар:",
    totalOrders: "Общо поръчки: {{orders}} | Продукти: {{items}}",
    cancelledCount: "Сторно: {{count}}",
  },

  configuration: {
    title: "Конфигурация",
    monitors: "Монитори",
    devices: "Устройства",
  },

  // Общото странично меню на модулите със страници по право (Конфигурация, Резервации)
  moduleSidebar: {
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    collapse: "Свий",
    backToModules: "Към модулите",
  },

  configSidebar: {
    monitors: "Монитори",
    devices: "Устройства",
    ordering: "Маркиране",
    paymentMethods: "Видове плащания",
    companies: "Фирми",
    workingHours: "Работно време",
    configurationLabel: "Модул Конфигурация",
    sectionMain: "Настройки",
  },

  workingHours: {
    sectionKicker: "Седмица",
    sectionTitle: "Работно време по дни",
    days: {
      monday: "Понеделник",
      tuesday: "Вторник",
      wednesday: "Сряда",
      thursday: "Четвъртък",
      friday: "Петък",
      saturday: "Събота",
      sunday: "Неделя",
    },
    open: "Работи",
    closed: "Почивен",
    closedDay: "Почивен ден",
    opensAt: "Отваря",
    closesAt: "Затваря",
    hintClosed: "Почивен ден — не се приемат резервации",
    hintAfterMidnight: "Затваря в {{time}} на следващия ден",
    errors: {
      sameTime: "Отварянето и затварянето не може да са в един и същи час",
      overlapsNextDay: "Затварянето след полунощ трябва да е преди отварянето на следващия ден",
    },
    save: "Запази",
    discard: "Откажи промените",
    saveSuccess: "Работното време е запазено",
    saveError: "Грешка при запис на работното време",
    guide: {
      link: "Как работи?",
      text: "Работното време задава часовете по подразбиране в справките и часовете, в които се приемат резервации.",
      modalTitle: "Как работи работното време",
      modalSubtitle: "Примери с три дни от една седмица",
      tab: {
        reports: "Справки",
        reservations: "Резервации",
      },
      lead: {
        reports: "Справката за един ден е от отварянето до затварянето на деня.",
        reservations: "Резервация може да започва от отварянето до 15 минути преди затварянето.",
      },
      columnDay: "Ден",
      columnHours: "Работно време",
      columnResult: {
        reports: "Период в справката",
        reservations: "Час за резервация",
      },
      afterMidnight: "затваря след полунощ",
      result: {
        reports: {
          tuesday: "вт 10:00 → вт 22:00",
          friday: "пт 12:00 → сб 02:00",
          monday: "пн 00:00 → пн 23:59",
        },
        reservations: {
          tuesday: "от 10:00 до 21:45",
          friday: "от 12:00 до 01:45",
          monday: "Не се приемат",
        },
      },
      goodToKnow: "Добре е да знаеш",
      notes: {
        reports: {
          afterMidnight: {
            title: "Сметка след полунощ",
            text: "Петък работи до 02:00. Сметка, платена в събота в 01:30, влиза в справката за петък, а не за събота.",
          },
          closedAfterMidnight: {
            title: "Почивен ден след ден, който работи до късно",
            text: "Неделя работи до 03:00, а понеделник е почивен ден. Справката за понеделник е от 03:00 до 23:59 — сметките до 03:00 остават в неделя.",
          },
          notSet: {
            title: "Без запазено работно време",
            text: "Докато работното време не е запазено, денят в справките е от 06:00 до 05:59 на следващия ден.",
          },
        },
        reservations: {
          lastSlot: {
            title: "Последен час",
            text: "Сряда работи 10:00–22:00. Часовете за резервация са през 15 минути, а последният е 21:45.",
          },
          afterMidnight: {
            title: "Ден, който работи след полунощ",
            text: "Петък работи до 02:00. Когато избереш петък, виждаш всички часове от 12 до 01 наведнъж. Ако избереш час след полунощ (например 01:15), датата горе сама минава на събота — резервацията е за събота в 01:15.",
          },
          closed: {
            title: "Почивен ден",
            text: "Понеделник е почивен ден. Формата показва „Почивен ден — не се приемат резервации“ и не записва.",
          },
          schedule: {
            title: "„Таблица на резервациите“",
            text: "Таблицата за деня показва часовете от отварянето до затварянето. Сряда 10:00–22:00 → от 10:00 до 22:00. Петък 12:00–02:00 → от 12:00 до 02:00 на един екран, без да сменяш деня.",
          },
          notSet: {
            title: "Без запазено работно време",
            text: "Докато работното време не е запазено, резервации се приемат от 11:00 до 22:45 всеки ден.",
          },
        },
      },
      close: "Затвори",
    },
  },

  reservationsSidebar: {
    reservations: "Резервации",
    table: "Таблица на резервациите",
    restaurantSchema: "Схема на заведението",
    tablesConfig: "Конфигурация на маси",
    moduleLabel: "Модул Резервации",
  },

  nonFiscalDisplay: {
    // Оптимизация с база
    cleanupTitle: "Оптимизация с база",
    cleanupDesc: "Изтрива безвъзвратно закритите в брой сметки без касова бележка",
    cleanupRun: "Стартирай",
    cleanupHint:
      "Изтрива безвъзвратно и заедно с историята. Номерата на останалите сметки се пренареждат без дупки, а касите зачистват своята история (настройките на принтерите остават).",
    cleanupConfirmContent:
      "Тази операция ще изтрие безвъзвратно всички закрити в брой сметки без касова бележка заедно с историята им, ще пренареди номерата на останалите без дупки и ще зачисти историята на всяка каса — издадените бонове, картовите плащания и офлайн събитията. Настройките на принтерите остават. Сторно на бон отпреди оптимизацията след това няма да е възможно. Направете резервно копие на базата преди да продължите. Сигурни ли сте?",
    cleanupConfirmOk: "Да, продължи",
    cleanupConfirmCancel: "Отказ",
    cleanupNoBills: "Няма сметки за изтриване",
    cleanupSuccess: "Изтрити сметки: {{count}}",
    cleanupError: "Грешка при почистване на базата",
    // Кодовете идват от BE (`detail`), текстовете живеят само тук.
    cleanupErrors: {
      cleanup_failed:
        "Почистването не бе извършено. Нищо не е изтрито — виж лога на сървъра.",
      cleanup_requires_fiscal_restaurant:
        "Почистването е достъпно само за ресторант с фискален принтер.",
      cleanup_no_restaurant_in_token:
        "Не е намерен идентификатор на ресторант — влезте отново.",
      cleanup_requires_access:
        "Само мениджър с пълен достъп може да извърши почистване.",
      cleanup_no_session: "Не е намерен токен на сесията — влезте отново.",
      cleanup_no_tills:
        "Не всички каси се обаждат в момента. Оптимизацията изисква връзка с всяка каса — нищо не е изтрито.",
      cleanup_till_unreachable:
        "Каса отказа или не отговори. Възможно е да работи в локален режим или да държи незавършено плащане — проверете я и опитайте отново.",
      cleanup_renumber_failed:
        "Сметките са изтрити и касите са зачистени, но номерата не бяха пренаредени. Пуснете оптимизацията отново.",
    },
    // Локален режим: операцията минава през облака и през всяка каса.
    cleanupOfflineHint:
      "Терминалът работи в локален режим. Оптимизацията е възможна само при връзка с облака.",
    cleanupResultTitle: "Резултат от оптимизацията",
    cleanupResultClose: "Затвори",
    cleanupDeletedBills: "Изтрити сметки",
    cleanupDeletedReports: "Изтрити отчети",
    cleanupRecalculated: "Преизчислени отчети",
    cleanupRemaining: "Оставащи сметки",
    cleanupNewMaxBillId: "Последен номер на сметка",
    cleanupMessage: "Съобщение",
  },

  orderingSettings: {
    sectionTablesKicker: "Маси",
    sectionTablesTitle: "Номерация, ред и видимост на масите",
    sectionOrdersKicker: "Поръчки",
    sectionOrdersTitle: "Поведение след „Поръчай“",
    sectionNotificationsKicker: "Известия",
    sectionNotificationsTitle: "Съобщения в Маркиране",
    sectionCatalogKicker: "Каталог",
    sectionCatalogTitle: "Изглед и подредба на продуктите",
    sectionMaintenanceKicker: "Поддръжка",
    sectionMaintenanceTitle: "База данни",
    sharedNumberingName: "Обща номерация на масите",
    sharedNumberingDesc: "Дали номерата на масите са уникални за целия ресторант",
    optionSharedNumberingOff: "Изключена",
    hintSharedNumberingOff:
      "Всеки сервитьор има собствена номерация — двама могат едновременно да имат маса „1“",
    optionSharedNumberingOn: "Включена",
    hintSharedNumberingOn:
      "Номерата са уникални за целия ресторант — заета маса „1“ дава грешка и на другите сервитьори",
    tableOrderName: "Ред на масите в списъка",
    tableOrderDesc: "Как са подредени отворените маси",
    optionTableOrderChronological: "Хронологично",
    hintTableOrderChronological:
      "По време на отваряне — най-старата маса е първа, новата отива най-отдолу",
    optionTableOrderAlphanumeric: "По номер и име",
    hintTableOrderAlphanumeric:
      "Първо масите с номер по големина (1, 2, 10, 33), после именуваните по азбучен ред",
    nonFiscalName: "Нефинализирани маси",
    nonFiscalDesc: "Кога се виждат сметки, които още не са фискализирани",
    optionNonFiscalNever: "Не",
    hintNonFiscalNever: "Сметките изчезват",
    optionNonFiscalAlways: "Винаги",
    hintNonFiscalAlways: "Сметките стоят докато не се фискализира",
    optionNonFiscalOnDemand: "При необходимост",
    hintNonFiscalOnDemand: "Динамично показване и скриване с команда ALT + F1",
    quickCloseName: "Закриване веднага след поръчка",
    quickCloseDesc: "Какво се случва с масата след „Поръчай“",
    optionQuickCloseOff: "Изключено",
    hintQuickCloseOff:
      "Нова маса иска номер, а поръчката се записва без да се закрива",
    optionQuickCloseOn: "Включено",
    hintQuickCloseOn:
      "Нова маса взима автоматично най-малкия свободен номер, а след „Поръчай“ се отваря „Закрий“",
    successNotificationsName: "Съобщения за успешно действие",
    successNotificationsDesc: "Зелените „Успешно…“ съобщения след всяко действие",
    optionSuccessNotificationsOff: "Изключени",
    hintSuccessNotificationsOff:
      "Зелените съобщения „Успешно…“ в „Маркиране“ не се показват — грешките и предупрежденията остават",
    optionSuccessNotificationsOn: "Включени",
    hintSuccessNotificationsOn:
      "След всяко успешно действие (добавени продукти, запазен клиент, закрита маса…) излиза кратко съобщение",
    catalogFilterName: "Лентата над каталога",
    catalogFilterDesc:
      "Кой филтър е в лентата над продуктите; другият отива в панела вдясно, над поръчката",
    optionFilterGroups: "Групите",
    hintFilterGroups:
      "Горе: групите (Бургери, Салати, Грил…). Вдясно над поръчката: станциите (Скара, Бар…)",
    optionFilterStations: "Станциите",
    hintFilterStations:
      "Горе: станциите (Скара, Бар…). Вдясно над поръчката: групите (Бургери, Салати, Грил…)",
    illustrationGroups: "Групи",
    illustrationStations: "Станции",
    illustrationCatalog: "Каталог",
    illustrationOrder: "Поръчка",
    colorByNameAssortments: "Оцветяване на асортиментите",
    colorByNameRecipes: "Оцветяване на рецептите",
    colorByDesc: "Откъде идва цветът на редовете и картите",
    optionColorGroup: "По група",
    hintColorGroupAssortments: "Всеки асортимент носи цвета на групата си",
    hintColorGroupRecipes: "Всяка рецепта носи цвета на групата си",
    optionColorStation: "По станция",
    hintColorStationAssortments: "Всеки асортимент носи цвета на станцията си",
    hintColorStationRecipes: "Всяка рецепта носи цвета на станцията си",
    optionColorNone: "Без оцветяване",
    hintColorNone: "Редовете и картите са без цветен фон",
    searchFieldName: "Търсачка над каталога",
    searchFieldDesc: "Показва или скрива търсачката на компютър; на телефон и таблет я има винаги",
    optionSearchFieldOff: "Скрита",
    hintSearchFieldOff:
      "Търси се направо с клавиатурата — написаното изскача върху каталога и изчезва след секунда",
    optionSearchFieldOn: "Показана",
    hintSearchFieldOn:
      "Полето стои над каталога и в него се пише; − и + в него пак променят бройката на избрания продукт",
    searchScopeName: "Търсене при избрана група",
    searchScopeDesc:
      "Къде търси търсачката, когато в каталога е отворена група (напр. „Напитки“) — важи и за редактора на обедно меню. Без избрана група се търси винаги в цялото меню",
    optionSearchScopeMenu: "В цялото меню",
    hintSearchScopeMenu:
      "Напр. в „Напитки“ пишете „лимон“ → излизат „Лимонада“ и „Пиле с лимон“ (Скара)",
    optionSearchScopeGroup: "Само в групата",
    hintSearchScopeGroup:
      "Напр. в „Напитки“ пишете „лимон“ → излиза само „Лимонада“ и оставате в „Напитки“",
    guestCountName: "Въвеждане на брой гости",
    guestCountDesc: "Дали и кога „Маркиране“ пита колко са гостите на масата",
    optionGuestCountOff: "Не",
    hintGuestCountOff: "Броят гости не се въвежда",
    optionGuestCountNewTable: "При нова маса",
    hintGuestCountNewTable:
      "Модал „Брой гости“ преди модала „Нова маса“. Без въведен брой масата не се отваря",
    optionGuestCountClose: "При закриване",
    hintGuestCountClose:
      "Модал „Брой гости“ преди модала „Закрий“. Без въведен брой масата не се закрива",
    illustrationTableFlow: "Поток на масата",
    saveSuccess: "Настройката е запазена успешно",
    saveError: "Грешка при запазване на настройката",
  },

  monitorsConfig: {
    title: "Монитори",
    shpicker: "Шпикер",
    shpickerHint: "Този потребител е шпикер — екранът обединява сготвеното от всички станции и го издава към сервитьорите.",
    stepVisibility: "Видимост",
    visibilityCookedOnly: "Само сготвени",
    visibilityCookedOnlyDesc: "Показва редовете от „Сготвено\" нататък",
    visibilityAll: "Всички статуси",
    visibilityAllDesc: "Вижда и незапочнато/в процес със статусите им",
    stepColorBy: "Оцветяване",
    colorByShort: "Оцветяване",
    colorByTable: "По маси",
    colorByTableDesc: "Редовете на една маса са в общ цвят",
    colorByWaiter: "По сервитьор",
    colorByWaiterDesc: "Редовете на един сервитьор са в общ цвят",
    colorByNone: "Без",
    colorByNoneDesc: "Без цветово групиране",
    name: "Име",
    stations: "Станции",
    actions: "Действия",
    noMonitors: "Няма конфигурирани монитори",
    addMonitor: "Добави монитор",
    editMonitor: "Редактирай монитор",
    deleteMonitor: "Изтрий монитор",
    deleteConfirm: "Сигурни ли сте?",
    assignUsers: "Потребители",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",
    configuredMonitors: "Конфигурирани монитори",
    monitors: "Монитори",
    deleteSuccess: "Конфигурацията на монитора е изтрита успешно",
    deleteError: "Грешка при изтриване на конфигурацията",
    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете конфигурацията на монитор "{{name}}"?',
    editSuccess: "Конфигурацията на монитора е обновена успешно",
    editError: "Грешка при редакция на конфигурацията",
    editTitle: "Редакция на монитор",
    editConfirmTitle: "Потвърждение за редакция",
    editConfirmContent: "Сигурни ли сте, че искате да запазите промените?",
    saveChanges: "Запази промените",
    selectMonitorPlaceholder: "Изберете монитор",
    noStations: "Няма налични станции",
    monitorConfig: "Конфигурация на монитор",
    selectUserAndStation: "Моля изберете потребител и поне една станция",
    saveSuccess: "Конфигурацията на монитора е запазена успешно",
    saveError: "Грешка при запазване на конфигурацията",
    saveConfig: "Запази конфигурация",
    selected: "Избрани: {{count}}",
    aggregatedQuantities: "Групирани количества",
    // Redesign keys
    configKicker: "Нов монитор",
    configKickerShpicker: "Нов шпикер",
    configTitle: "Свържи потребител със станции",
    listKicker: "Списък монитори",
    listKickerShpickers: "Списък шпикери",
    shpickers: "Шпикери",
    addShpicker: "Добави шпикер",
    noShpickers: "Няма конфигурирани шпикери",
    // Номерата се слагат динамично в MonitorFormModal (шпикер добавя стъпка).
    stepUser: "Потребител",
    stepScreen: "Екран",
    stepStations: "Станции",
    stepView: "Изглед",
    stepOptions: "Опции",
    screenSingle: "Един екран",
    screenSingleDesc: "Всички станции на общ екран",
    screenSplit: "Разделен на 2",
    screenSplitDesc: "Лява и дясна половина със свои станции",
    leftHalf: "Лява част",
    rightHalf: "Дясна част",
    leftHalfShort: "Л",
    rightHalfShort: "Д",
    selectBothHalves:
      "При разделен екран изберете станции и за двете половини",
    aggregatedShort: "Групиране",
    completeFullQuantity: "Изпълняване на цялото количество",
    completeFullQuantityShort: "Цяло количество",
    viewShort: "Изглед",
    viewGrid: "Решетка",
    viewList: "Списък",
    viewGridDesc: "Продуктите се подреждат в колони",
    viewListDesc: "Продуктите се подреждат в един списък",
  },

  devices: {
    name: "Име",
    uniqueNumber: "Уникален номер",
    type: "Тип",
    actions: "Действия",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",
    users: "Достъпи & Работни точки",
    connectedClients: "FiscalAPI",
    connectedClientsCount: "{{count}} връзки",
    connectedClientsConflict:
      "Две инсталации печатат на този принтер — един бон ще излезе два пъти.",
    connectedClientsUnknown:
      "Няма данни. Старите версии на FiscalAPI не се обявяват — обнови ги, за да се вижда кой компютър печата тук.",
    connectedClientsStale: "не е на връзка",
    fiscalapiDownload: "Свали последната версия на FiscalAPI",
    fiscalapiUpdateButton: "Обнови до v{{version}}",
    fiscalapiUpdateStarted:
      "Ъпдейтът тръгна — инсталацията ще се рестартира до минути и новата версия ще се покаже тук.",
    fiscalapiUpdateFailed: "Ъпдейтът не тръгна",
    deleteSuccess: "Устройството е изтрито успешно",
    deleteError: "Грешка при изтриване на устройство",
    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете устройство "{{name}}"?',
    editSuccess: "Устройството е обновено успешно",
    editError: "Грешка при редакция на устройство",
    editConfirmTitle: "Потвърждение за редакция",
    editConfirmContent: "Сигурни ли сте, че искате да запазите промените?",
    saveChanges: "Запази промените",
    pickerSearch: "Търси по име",
    pickerWorkpointsCount_one: "{{count}} работна точка",
    pickerWorkpointsCount_other: "{{count}} работни точки",
    pickerUsersCount_one: "{{count}} потребител",
    pickerUsersCount_other: "{{count}} потребители",
    createSuccess: "Устройството е създадено успешно",
    createError: "Грешка при създаване на устройство",
    addDevice: "Добави устройство",
    copySuccess: "Connection string копиран",
    typeFiscal: "Фискален принтер",
    typePos: "POS принтер",
    typePaymentTerminal: "Терминал за плащане",
    // Redesign
    // Трите секции на страницата — по една на тип устройство.
    posSectionKicker: "Печат на поръчки",
    fiscalSectionKicker: "Фискализация",
    terminalSectionKicker: "Плащане с карта",
    posDevices: "ПОС устройства",
    fiscalDevices: "Фискални принтери",
    terminalDevices: "Терминали за плащане",
    addPosDevice: "Добави ПОС устройство",
    addFiscalDevice: "Добави фискален принтер",
    addTerminalDevice: "Добави терминал",
    noPosDevices: "Няма конфигурирани ПОС устройства",
    noFiscalDevices: "Няма конфигурирани фискални принтери",
    noTerminalDevices: "Няма конфигурирани терминали за плащане",
    deactivateWarning_one: "При запазване ще бъде премахнат достъпът на:",
    deactivateWarning_other: "При запазване ще бъдат премахнати {{summary}}:",
    deactivateUndo: "Отмени",
    deactivateWarningAnd: " и ",
    orgUrlCopied: "Адресът е копиран",
    noStations: "Няма налични станции",
    printLanguage: "Език на печат",
    printLanguagePlaceholder: "Български (по подразбиране)",
    noLanguages: "Няма налични езици",
    summarizeReceipt: "Обобщени касови бележки",
    summarizeReceiptHint:
      "Еднаквите продукти от сметката излизат на фискалния бон като един ред с общо количество.",
    summarizeReceiptOff: "Изключено",
    summarizeReceiptOn: "Включено",
    summarizeReceiptExampleWater: "Минерална вода",
    summarizeReceiptExampleCola: "Кола",
    summarizeReceiptExampleCoffee: "Кафе",
    summarizeReceiptExampleCoffeeMilk: "Кафе + мляко",
    summarizeReceiptActive: "Активно",
    summarizeReceiptLines_one: "{{count}} ред",
    summarizeReceiptLines_other: "{{count}} реда",
    nonFiscalCopy: "Нефискално копие на ПОС",
    nonFiscalCopyHint:
      "След всяка успешна касова бележка ПОС принтерът на същата каса печата нефискално копие — удобно при доставка, за да се види дали всичко е вътре. Без ПОС принтер копие не излиза.",
    paymentMethods: "Методи на плащане",
    stations: "Станции",
    stationsCount_one: "{{count}} станция",
    stationsCount_other: "{{count}} станции",
    usersCount_one: "{{count}} потребител",
    usersCount_other: "{{count}} потребителя",
    searchPlaceholder: "Търси по име, GUID или потребител",
    noPaymentMethodsForDevice: "—",
    // Модалът на терминал за плащане (създаване и редакция) — TerminalModal.
    terminalModal: {
      kickerEdit: "Редакция на устройство · Терминал за плащане",
      kickerCreate: "Ново устройство · Терминал за плащане",
      accountsTitle: "Картови плащания",
      accountsDesc:
        "Работните точки и потребители, закачени към този терминал. Един акаунт може да е закачен само към един терминал.",
      accountsDescShort: "Акаунтите, закачени към този терминал.",
      takenNote_one:
        "{{count}} акаунт вече е закачен към {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другия терминал.",
      takenNote_other:
        "{{count}} акаунта вече са закачени към {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другия терминал.",
      takenWhereMany: "други терминали",
      summaryAccounts: "Картови плащания:",
      summaryCount_one: "{{count}} акаунт",
      summaryCount_other: "{{count}} акаунта",
    },
    // Модалът на фискален принтер (създаване и редакция) — FiscalPrinterModal.
    fiscalModal: {
      kickerEdit: "Редакция на устройство · Фискален принтер",
      kickerCreate: "Ново устройство · Фискален принтер",
      accountsTitle: "Касови бележки",
      accountsDesc:
        "Касовите бележки на избраните работни точки и потребители се издават от това устройство. Един акаунт фискализира само на едно устройство.",
      accountsDescShort: "Касовите бележки на избраните акаунти се издават тук.",
      inactiveBannerTitle: "Устройството е изключено.",
      inactiveBannerText:
        "При запазване всички закачени работни точки и потребители се премахват и стават свободни за други фискални устройства.",
      takenNote_one:
        "{{count}} акаунт вече фискализира на {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другото устройство.",
      takenNote_other:
        "{{count}} акаунта вече фискализират на {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другото устройство.",
      takenWhereMany: "други фискални устройства",
      methodsTitle: "Методи на плащане",
      methodsDesc:
        "Избери слот на устройството или „БЕЗ ФИСКАЛИЗИРАНЕ“ за всеки метод. „Не се ползва“ = методът не се ползва на това устройство.",
      methodsDescShort: "Слот на устройството или „БЕЗ ФИСКАЛИЗИРАНЕ“ за всеки метод.",
      methodLabel: "Метод",
      slotLabel: "Слот на устройството",
      fiscalizedPill: "Фискализирани: {{count}}",
      notUsed: "Не се ползва",
      hintSlot: "Фискален · {{slot}}",
      hintNoFiscal: "Без касов бон",
      hintNotUsed: "Не се ползва тук",
      receiptTitle: "Касова бележка",
      receiptDescShort: "Обобщаване на редовете и нефискално копие на ПОС.",
      tabAccounts: "Акаунти",
      tabMethods: "Плащане",
      tabReceipt: "Бележка",
      tabOff: "изкл.",
      summaryReceipts: "Касови бележки:",
      summaryMethods: "Методи:",
      summaryOff: "изключени",
      summaryAccounts_one: "{{count}} акаунт",
      summaryAccounts_other: "{{count}} акаунта",
      summaryFiscalized: "{{count}} фискализирани",
    },
    // Модалът на POS принтер (създаване и редакция) — PosPrinterModal.
    posModal: {
      kickerEdit: "Редакция на устройство · POS принтер",
      kickerCreate: "Ново устройство · POS принтер",
      namePlaceholder: "Име, напр. Бар",
      editName: "Промени името",
      nameAria: "Име на принтера",
      close: "Затвори",
      cancel: "Отказ",
      docsTitle: "Документи от касата",
      docsDesc:
        "Документите на избраните работни точки и потребители излизат на този принтер. Един акаунт печата само на един POS принтер.",
      docsDescShort: "Бележките на избраните акаунти излизат тук.",
      kitchenDescShort: "Поръчките от избраните станции излизат тук като кухненски билети.",
      tabDocuments: "Документи",
      tabKitchen: "Кухня",
      tabOff: "изкл.",
      active: "Активно",
      inactive: "Неактивно",
      inactiveBannerTitle: "Документите са изключени.",
      inactiveBannerText:
        "При запазване всички закачени работни точки и потребители се премахват и стават свободни за други POS принтери. Кухненските билети продължават да се печатат.",
      accountsLabel: "Работни точки и потребители",
      selectedPill_one: "{{count}} избран",
      selectedPill_other: "{{count}} избрани",
      allPill: "Всички · {{count}}",
      allAccounts: "Всички акаунти",
      allAccountsNote: "Печатат всички <b>{{count}}</b> свободни работни точки и потребители.",
      searchPlaceholder: "Търси работна точка или потребител",
      filterAll: "Всички",
      filterWorkpoints: "Работни точки",
      filterUsers: "Потребители",
      filterSelected: "Избрани",
      workpoint: "Работна точка",
      user: "Потребител",
      noAccounts: "Няма намерени акаунти",
      shownOf: "Показани {{shown}} от {{total}}",
      selectShown: "Избери показаните",
      clear: "Изчисти",
      takenNote_one:
        "{{count}} акаунт вече печата документи на {{where}} и не може да се избере тук. За да го преместите, първо го премахнете от другия принтер.",
      takenNote_other:
        "{{count}} акаунта вече печатат документи на {{where}} и не могат да се изберат тук. За да ги преместите, първо ги премахнете от другия принтер.",
      takenWhereMany: "други POS принтери",
      kitchenTitle: "Кухненски билети",
      kitchenDesc:
        "Поръчаните продукти от избраните станции излизат на този принтер като кухненски билети — независимо кой акаунт е направил поръчката.",
      kitchenExampleTitle: "Пример за билет",
      examplePrinterNamed: "Принтер „{{name}}“",
      exampleThisPrinter: "Този принтер",
      exampleListens: "{{printer}} слуша <b>{{stations}}</b>.",
      exampleNoStations: "{{printer}} не слуша станции — не печата кухненски билети.",
      exampleSplit: "Поръчка с продукти и за двата принтера се разделя на два билета — по един на всеки.",
      exampleSingle: "Поръчка с продукти от тези станции излиза тук като кухненски билет — независимо кой акаунт поръчва.",
      exampleListAnd: " и ",
      exampleListMore: "{{list}} и още {{count}}",
      ticketTitle: "КУХНЕНСКИ БИЛЕТ",
      ticketMeta: "Маса 12 · Мария · 12:41",
      ticketItem1: "Мохито",
      ticketMod1: "+ без захар",
      ticketItem2: "Свинска пържола",
      ticketMod2: "+ добре изпечена",
      ticketEmpty: "Няма избрани станции — не се печатат билети.",
      stationsLabel: "Станции",
      stationsSelected: "Избрани: {{count}}",
      selectAll: "Избери всички",
      removeAll: "Махни всички",
      stationsNote:
        "Една станция може да печата на няколко принтера. Станциите не зависят от акаунтите и от техния статус.",
      languageLabel: "Език на кухненския билет",
      languageNote:
        "Имената на продукти, модификатори и станции на билета. Не влияе на документите от касата.",
      summaryDocs: "Документи:",
      summaryKitchen: "Кухненски билети:",
      summaryDocsOff: "изключени",
      summaryDocsAll: "всички свободни акаунти ({{count}})",
      summaryDocsCount_one: "{{count}} акаунт",
      summaryDocsCount_other: "{{count}} акаунта",
      summaryNoStations: "няма станции",
    },
  },

  devicePaymentMethods: {
    noFiscalOption: "БЕЗ ФИСКАЛИЗИРАНЕ",
    duplicateValuesError:
      "Два различни метода не могат да имат еднаква стойност за устройство.",
    invalidValueError: "Стойностите не могат да са празни.",
    duplicateMethodsError: "Един метод не може да присъства повече от веднъж.",
    noPaymentMethods: "Няма налични методи на плащане",
    viewButton: "Виж",
    viewTitle: "Методи на плащане за устройство",
    viewEmpty: "Няма зададени методи на плащане за това устройство.",
    colMethod: "Метод",
    colSlot: "Стойност",
  },

  paymentMethodsConfig: {
    title: "Видове плащания",
    listKicker: "Списък видове плащания",
    addMethod: "Добави вид плащане",
    searchPlaceholder: "Търси по име",
    colName: "Име",
    colSystem: "Тип",
    colSortIndex: "Подредба",
    colActions: "Действия",
    badgeSystem: "Системен",
    badgeCustom: "Потребителски",
    systemTooltip:
      "Системните видове плащане не могат да бъдат изтривани, но могат да се пренареждат",
    noMethods: "Няма добавени видове плащане",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",

    createTitle: "Нов вид плащане",
    createSubtitle: "Добавете потребителски вид плащане",
    editTitle: "Редакция на вид плащане",

    fieldNameBg: "Име на български",
    fieldNameBgPlaceholder: "Вид плащане",
    fieldNameEn: "Име на английски",
    fieldNameEnPlaceholder: "Вид плащане",
    fieldSortIndex: "Подредба",

    save: "Запази",
    create: "Създай",

    createSuccess: "Видът плащане е създаден успешно",
    editSuccess: "Видът плащане е обновен успешно",
    deleteSuccess: "Видът плащане е изтрит успешно",
    createError: "Грешка при създаване",
    editError: "Грешка при редакция",
    deleteError: "Грешка при изтриване",

    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent: 'Сигурни ли сте, че искате да изтриете "{{name}}"?',

    enterNameBgWarning: "Моля въведете име на български",
    enterNameEnWarning: "Моля въведете име на английски",
  },

  restaurantSchema: {
    title: "Схема на заведението",
    subtitle: "Визуална подредба на масите и зоните по райони",
    loadError: "Схемата не се зареди",
    loadErrorHint: "Провери връзката и презареди страницата.",
    offlineHint:
      "Схемата се пази в облака — редакцията е възможна, щом интернетът се върне.",
    empty: {
      title: "Начертай заведението си",
      description:
        "Започни с район — зала, тераса или бар. В него подреждаш масите и обектите, а после ги избираш направо от схемата при маркиране.",
      cta: "Създай първия район",
    },
    counts: {
      tables_one: "{{count}} маса",
      tables_other: "{{count}} маси",
      seats_one: "{{count}} място",
      seats_other: "{{count}} места",
      objects_one: "{{count}} обект",
      objects_other: "{{count}} обекта",
    },
    kinds: {
      table: "Маса",
      bar: "Бар",
      wall: "Стена",
      plant: "Растение",
      entrance: "Вход",
      stage: "Сцена",
      dj: "DJ",
    },
    toolbar: {
      undo: "Отмени (⌘Z)",
      redo: "Повтори (⇧⌘Z)",
      saving: "Запазва се…",
      saved: "Запазено",
      rotateDrag: "Хвани и завърти (Shift — през 15°)",
      duplicate: "Дублирай (⌘D)",
      delete: "Изтрий (Del)",
      duplicateShort: "Дублирай",
      deleteShort: "Изтрий",
    },
    canvas: {
      emptyTitle: "Районът е празен",
      emptyHint: "Добави маса или плъзни обект от лентата отдолу.",
      zoomOut: "Намали",
      zoomIn: "Увеличи",
      fit: "Побери схемата",
      tableTitle: "Маса {{name}} · {{seats}}",
    },
    addBar: {
      dragHint: "Плъзни върху схемата",
      hint: "Плъзни обект върху схемата",
    },
    inspector: {
      rotation: "Завъртане",
      size: "Размер",
      tableSubtitle: "{{shape}} · {{seats}}",
      objectSubtitle: "Размер: {{size}}",
      seatsHint: "Плотът расте с броя места; размерът го уголемява или смалява.",
    },
    table: {
      title: "Маса {{name}}",
      number: "Номер на масата",
      numberPlaceholder: "напр. 12",
      nameTrailingStar: "Името на масата не може да завършва на „*“ (запазено е за офлайн режима)",
      nameTaken: "Вече има маса с този номер",
      seats: "Брой места",
      shape: "Форма",
      size: "Размер на масата",
    },
    tableSizes: {
      small: "Малка",
      medium: "Средна",
      large: "Голяма",
      xl: "XL",
    },
    tableShapes: {
      round: "Кръгла",
      square: "Квадратна",
      rectangle: "Правоъгълна",
    },
    tableCreate: {
      title: "Нова маса",
      subtitle: "Номер, брой места, форма и размер.",
      submit: "Създай",
      addAnother: "Остави прозореца отворен за следващата маса",
      addAnotherHint: "След „Създай“ номерът се сменя със следващия свободен и можеш веднага да добавиш още една.",
      createdSoFar_one: "Създадена в тази серия: {{names}}",
      createdSoFar_other: "Създадени в тази серия ({{count}}): {{names}}",
      preview: "Преглед",
      numberHint: "Следващият свободен номер. Използва се и в Маркиране.",
      numberHintTyped: "Номерът се използва и в Маркиране.",
      placementHint: "Позицията и завъртането се задават директно върху схемата.",
    },
    summary: {
      tables: "Маси",
      seats: "Места",
      hint: "Избери маса от схемата или от списъка, за да промениш свойствата ѝ.",
    },
    list: {
      tables: "Маси",
      objects: "Обекти",
      empty: "Още няма маси в този район.",
    },
    regionTabs: {
      newRegion: "Нов район",
    },
    region: {
      name: "Име на района",
      namePlaceholder: "напр. Зала, Тераса",
    },
    regionCreate: {
      title: "Нов район",
      subtitle: "Зона от заведението с отделна схема.",
      submit: "Създай",
    },
    regionSettings: {
      title: "Редакция на района",
      button: "Редакция на район",
      subtitle: "Име на района и изтриване.",
      deleteTitle: "Изтриване на района",
      deleteBlocked:
        "Районът съдържа {{tables}} и {{objects}} — за да го изтриеш, първо ги премахни.",
      deleteEmpty: "Районът е празен. Ще поискаме потвърждение.",
      delete: "Изтрий…",
    },
    regionDelete: {
      title: "Изтриване на „{{name}}“",
      description: "Районът ще бъде изтрит.",
      confirm: "Изтрий",
    },
    sizes: {
      small: "Малък",
      medium: "Среден",
      large: "Голям",
      xl: "XL",
    },
    messages: {
      regionCreated: "Районът е създаден",
      tableCreated: "Маса {{name}} е създадена",
      regionSaved: "Районът е запазен",
      regionDeleted: "Районът е изтрит",
      saveError: "Промяната не можа да се запише",
      deleteError: "Изтриването не успя",
      noRoom: "Няма място — маса {{name}} е твърде близо. Първо раздалечи масите.",
    },
  },
  tablesConfig: {
    title: "Конфигурация на маси",
    subtitle: "Номер и брой места на масите по райони — без схема",
    offlineHint:
      "Масите се пазят в облака — промените са възможни, щом интернетът се върне.",
    empty: {
      title: "Първо създай район",
      description:
        "Масите стоят в райони — зала, тераса или бар. Създай първия и добави масите само с номер и брой места.",
      cta: "Създай район",
    },
    listEmpty: "Още няма маси в този район. Добави първата от „Нови маси“.",
    searchPlaceholder: "Търси по номер…",
    clearSearch: "Изчисти търсенето",
    seatsLess: "Едно място по-малко",
    seatsMore: "Едно място повече",
    grid: {
      kicker: "Маси · {{region}}",
      selectAll: "Избери всички",
      filterAll: "Всички",
      selectTable: "Избери маса {{name}}",
      newTable: "Нова маса",
      noMatches: "Няма маси, които отговарят на търсенето.",
    },
    newTables: {
      kicker: "Нови маси",
      title: "Добави в „{{region}}“",
      single: "Една маса",
      series: "Серия номера",
      number: "Номер",
      numbers: "Номера от – до",
      from: "От",
      to: "До",
      seats: "Места на маса",
      add: "Добави маса",
      addMany_one: "Добави {{count}} маса",
      addMany_other: "Добави {{count}} маси",
      seriesInvalid: "Въведи числа от – до, като „до“ не е по-малко от „от“",
      seriesTooMany: "Най-много {{max}} маси наведнъж",
      seriesNothingFree: "Всички номера в този диапазон са заети",
      seriesSkippedHint_one: "{{count}} зает номер ще бъде пропуснат",
      seriesSkippedHint_other: "{{count}} заети номера ще бъдат пропуснати",
      placementHint:
        "Масата се нарежда сама в района. Мястото ѝ може да се промени в „<link>Схема на заведението</link>“.",
    },
    edit: {
      title: "Маса {{name}}",
      seats: "Места",
      region: "Район",
      save: "Запази",
      delete: "Изтрий масата",
      close: "Затвори",
    },
    bulk: {
      title_one: "Избрана {{count}} маса",
      title_other: "Избрани {{count}} маси",
      seats: "Места на всички",
      apply: "Приложи",
      moveTo: "Премести в район",
      chooseRegion: "Избери район…",
      move: "Премести",
      delete: "Изтрий избраните",
      cancel: "Откажи избора",
      edit: "Редактирай",
    },
    delete: {
      title: "Изтриване на маса {{name}}",
      description:
        "Масата изчезва и от схемата, и от резервациите. Маса с резервация или отворена сметка не може да се изтрие.",
      titleMany: "Изтриване на {{count}} маси",
      descriptionMany:
        "Маси {{names}} изчезват и от схемата, и от резервациите. Масите с резервация или отворена сметка се пропускат.",
      confirm: "Изтрий",
    },
    messages: {
      created: "Маса {{name}} е добавена",
      seriesCreated_one: "Добавена е {{count}} маса",
      seriesCreated_other: "Добавени са {{count}} маси",
      seriesSkipped: "Пропуснати заети номера: {{names}}",
      seatsApplied_one: "Местата са сменени на {{count}} маса",
      seatsApplied_other: "Местата са сменени на {{count}} маси",
      moved: "Маса {{name}} е преместена в „{{region}}“",
      movedMany_one: "{{count}} маса е преместена в „{{region}}“",
      movedMany_other: "{{count}} маси са преместени в „{{region}}“",
      deleted: "Маса {{name}} е изтрита",
      deletedMany_one: "Изтрита е {{count}} маса",
      deletedMany_other: "Изтрити са {{count}} маси",
      deleteSkippedInUse: "Не са изтрити (резервация или отворена сметка): {{names}}",
      notFitted: "Масата не се събра в района — може да се подреди в „Схема на заведението“",
      saveError: "Промяната не можа да се запише",
      deleteError: "Изтриването не успя",
    },
  },
  companiesConfig: {
    title: "Фирми",
    listKicker: "Списък фирми",
    addCompany: "Добави фирма",
    searchPlaceholder: "Търси по име, обект или ЕИК",
    colName: "Име",
    colEik: "ЕИК",
    colVat: "ДДС №",
    colActions: "Действия",
    badgeDefault: "Текуща",
    noCompanies: "Няма добавени фирми",
    loadingError: "Грешка при зареждане",
    loadingErrorDesc: "Моля, опитайте отново по-късно",

    createTitle: "Нова фирма",
    createSubtitle: "Въведете данните за фактуриране",
    editTitle: "Редакция на фирма",
    editSubtitle: "Редактирайте данните за фактуриране",

    secBasic: "Основни данни",
    secIdentity: "Идентификация и контакти",
    secStatus: "Статус",
    secNumbering: "Номерация на документи",
    secBanks: "Банкови сметки",

    fieldName: "Име на фирмата",
    fieldNamePlaceholder: 'Напр. "Тест ООД"',
    fieldObjectName: "Име на обекта",
    fieldObjectNamePlaceholder: 'Напр. "Тест обект"',
    fieldAddress: "Адрес",
    fieldAddressPlaceholder: "Седалище и адрес на управление",
    fieldMol: "МОЛ",
    fieldMolPlaceholder: "Материално отговорно лице",
    fieldEik: "ЕИК / БУЛСТАТ",
    fieldEikHint: "9 или 13 цифри",
    fieldEikValid: "Валиден ЕИК — контролната сума излиза",
    fieldVatFromEik: "Попълни BG{{eik}}",
    fieldVat: "ДДС №",
    fieldVatHint: "Формат BG + 9 или 10 цифри (по желание)",
    fieldPhone: "Телефон",
    fieldEmail: "E-mail",

    fieldDefault: "Това е текущата фирма",
    fieldDefaultDesc:
      "Документите ще се издават с тези данни. Само една фирма може да е текуща.",

    fieldLastInvoice: "Последен номер на фактура",
    fieldLastInvoicePlaceholder: "Напр. 0000000034",
    fieldLastInvoiceHint:
      "Последният ВЕЧЕ издаден номер. 0 = още няма издадена фактура.",
    fieldLastProforma: "Последна проформа",
    fieldLastProformaHint: "Формат: П-2026-0001",
    numberingNextKicker: "Следващ документ",
    numberingNextInvoice: "Фактура №",
    numberingNextUnknown:
      "Попълнете последния издаден номер, за да се види с кой номер тръгва следващата фактура.",

    addBank: "Добави банка",
    noBanks: "Все още няма добавени банкови сметки",
    bankIndex: "Банка #{{index}}",
    bankName: "Име на банка",
    bankAddDraft: "Нова банкова сметка",
    bankEditDraft: "Редакция на банкова сметка",
    bankConfirm: "Запази банка",
    bankMakeDefault: "Направи по подразбиране",
    draftDirtyBlock:
      "Първо запазете или откажете текущата банкова сметка преди да продължите.",

    save: "Запази",
    create: "Създай",

    createSuccess: "Фирмата е създадена успешно",
    editSuccess: "Фирмата е обновена успешно",
    deleteSuccess: "Фирмата е изтрита успешно",
    createError: "Грешка при създаване",
    editError: "Грешка при редакция",
    deleteError: "Грешка при изтриване",

    deleteConfirmTitle: "Потвърждение за изтриване",
    deleteConfirmContent:
      'Сигурни ли сте, че искате да изтриете фирма "{{name}}"?',

    errRequired: "Полето е задължително",
    errInvalidEik: "Невалиден ЕИК/БУЛСТАТ",
    errInvalidVat: "Очакван формат: BG + 9 или 10 цифри",
    errInvalidEmail: "Невалиден e-mail",
    errInvalidBic: "Невалиден BIC код",
    errInvalidIban: "Невалиден IBAN",
    errInvalidInvoiceNumber: "Невалиден номер",
    errInvalidProforma: "Очакван формат: П-2026-0001",
  },

  monitors: {
    title: "Монитори",
    shpickerBadge: "Шпикер",
    selectStation: "Изберете станция",
    connected: "Свързан",
    disconnected: "Изключен",
    connecting: "Свързване...",
    noOrders: "Няма поръчки",
    unfulfilled: "Неизпълнени",
    fulfilled: "Изпълнени",
    noAssignedStations: "Няма назначени станции",
    contactAdmin:
      "Свържете се с администратор за да ви бъдат назначени станции",
    inProgress: "В процес",
    complete: "Изпълни",
    return: "Върни",
    noActiveOrders: "Няма активни поръчки",
    newOrdersWillAppear: "Новите поръчки ще се появят автоматично",
    // Мъртъв канал изглежда точно като спокойна кухня — затова празният екран
    // казва КОЯ от двете е (docs/edge.md §5.3).
    noConnection: "Няма връзка",
    noConnectionHint:
      "Екранът не е свързан — нови поръчки НЕ пристигат. Извикай отговорник.",
    soundOn: "Включи звука",
    soundOff: "Изключи звука",
    selected: "Избрани: {{count}}",
    minuteShort: "м",
    hourShort: "ч",
    pcs: "бр.",
    navUp: "Един продукт нагоре",
    navDown: "Един продукт надолу",
    navUp2: "Два продукта нагоре",
    navDown2: "Два продукта надолу",
    colStatus: "Статус",
    colTable: "Маса",
    colProduct: "Артикул",
    colElapsed: "Време",
    colQty: "Кол.",
    colTotal: "Общо",
    colOperator: "Оператор",
    colOrderTime: "Поръчано",
    additionToProduct: "(към {{product}})",
    additionToProductFromStation: "(към {{product}} от {{station}})",
    stationPartDone: "готово ✓",
    stationPartInProgress: "в процес",
    stationPartWaiting: "чака",
  },

  inventoryPage: {
    moduleLabel: "Модул Складова база",
    backToModules: "Към модулите",
    collapse: "Свий",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    delivery: "Доставка",
    refresh: "Опресни",
    // Таблица доставки
    newDelivery: "Нова доставка",
    colDate: "Дата",
    colInvoice: "Фактура №",
    colSupplier: "Доставчик",
    colWarehouse: "Склад",
    colProducts: "Продукти",
    colValue: "Стойност",
    colType: "Тип",
    colQty: "Количество",
    colUnitPrice: "Ед. цена",
    colBatch: "Партида",
    colExpiry: "Срок",
    stxRestockLabel: "Заприходяване",
    colProductName: "Продукт",
    colPackaging: "Разфасовка",
    colNet: "Нето",
    lotSource: "Източник",
    lotSource_delivery: "Доставка",
    lotSource_stocktake: "Инвентаризация",
    lotSource_transfer: "Прехвърляне",
    lotSource_substitution: "Замяна",
    lotSource_writeoff: "Изписване",
    lotSource_scrap: "Бракуване",
    lotSource_report: "Разнасяне на отчет",
    colGross: "Бруто",
    colUnit: "Мерна единица",
    filterApply: "Приложи",
    filterReset: "Нулирай",
    filterSearch: "Търсене във филтрите",
    filterSelectAll: "Избери всички",
    sectionConfig: "Настройки",
    settings: "Конфигурации",
    settingsVatSection: "Регистрация по ДДС",
    settingsWhSection: "Склад по подразбиране",
    settingsWhHint:
      "Складът, който модулът ползва по подразбиране (за справки и нови операции).",
    settingsWhQuestion: "Склад по подразбиране:",
    productWarehousesSection: "Склад по продукт",
    productWarehousesHint:
      "Продукти, които стоят в определен склад (например лимоните — в кухнята). При разнасяне на отчет и при брак от сторно те се изписват оттам, а не от склада на станцията на рецептата.",
    productWarehousesEmpty:
      "Няма продукти със свой склад — всичко се изписва от склада на станцията на рецептата.",
    productWarehouseInvalid: "Складът вече не е на този ресторант",
    productWarehouseRemove: "Махни склада на {{product}}",
    productWarehouseAddQuestion: "Добави продукт:",
    productWarehouseProductPh: "Изберете продукт",
    productWarehouseAdd: "Добави",
    productWarehouseSaved: "Складът на продукта е запазен",
    productWarehouseRemoved: "Складът на продукта е махнат",
    settingsVatQuestion: "Фирмата регистрирана ли е по ДДС?",
    settingsVatHint:
      "Определя как се изчисляват сумите бруто и нето в складовия модул.",
    settingsVatYes: "Да, регистрирана",
    settingsVatNo: "Не",
    settingsSaved: "Настройките са запазени",
    errScrapReason: "Изберете причина за бракуването",
    fieldScrapReasonPh: "Изберете причина",
    kpiDeliveries: "Доставки",
    kpiValue: "Обща стойност",
    kpiProducts: "Продукти",
    products: "Продукти",
    noWarehouse: "Изберете склад, за да видите доставките.",
    noDeliveries: "Все още няма заприходени доставки за този склад.",
    noLines: "Няма продукти в тази доставка.",
    // Модал нова доставка
    fieldDate: "Дата на доставка",
    fieldInvoice: "Фактура №",
    fieldInvoicePh: "Въведете номер",
    fieldSupplier: "Доставчик",
    fieldSupplierPh: "Изберете доставчик",
    productAdd: "Нов продукт",
    productAddTitle: "Нов складов продукт",
    productAddHint:
      "Продуктът се записва в общия справочник на организацията.",
    productName: "Име",
    productNamePh: "Име на продукта",
    productNameRequired: "Името е задължително",
    productExportCode: "Код за експорт",
    productGroup: "Група",
    productGroupPh: "Изберете група",
    productUnit: "Мерна единица",
    productUnitPh: "Изберете единица",
    productUnitRequired: "Мерната единица е задължителна",
    productVat: "ДДС",
    productVatPh: "Изберете ДДС",
    productVatRequired: "ДДС е задължително",
    productMinQuantity: "Минимално количество",
    productWastePct: "Фира",
    productPackagings: "Разфасовки",
    productPackagingsPh: "Изберете разфасовки",
    productPackagingsHint:
      "Разфасовките, в които се доставя продуктът (напр. каса, стек).",
    productTrackBatch: "Следене на партида",
    productTrackExpiry: "Следене на срок на годност",
    productSaved: "Продуктът е записан",
    supplierAdd: "Нов доставчик",
    supplierAddTitle: "Нов доставчик",
    supplierAddHint:
      "Доставчикът се записва в общия справочник на организацията.",
    supplierName: "Име",
    supplierNamePh: "Име на доставчика",
    supplierNameRequired: "Името е задължително",
    supplierEik: "ЕИК",
    supplierEikPh: "напр. 123456786",
    supplierEikInvalid: "Невалиден ЕИК (9 или 13 цифри с контролна цифра)",
    supplierVatNumber: "ДДС номер",
    supplierVatNumberPh: "напр. BG123456786",
    supplierVatNumberInvalid: "Невалиден ДДС номер (BG + 9 или 10 цифри)",
    supplierVatNumberHint:
      "Без ДДС номер доставката не начислява ДДС — брутото остава равно на нетото.",
    supplierSaved: "Доставчикът е записан",
    fieldTemplate: "От минала доставка",
    fieldTemplatePh: "Изберете доставка като шаблон",
    templateOptionProducts: "{{count}} прод.",
    // Работен лист „Нова доставка" (страница)
    backToDeliveries: "Към доставките",
    wsSaveChanges: "Запази промените",
    wsSearchPh: "Добавете продукт — просто започнете да пишете, напр. „домати“",
    wsClearRowHint: "Премахни реда от доставката",
    wsNoMatch: "Няма съвпадение",
    wsLastPrice: "посл. цена",
    wsSoldWithoutStock: "−{{qty}} продадени без наличност",
    wsSoldWithoutStockHint: "Продадено е повече, отколкото е имало в склада. Доставка с по-късна дата от продажбите влиза цяла (минусът се отписва); доставка с датата на продажбите го покрива.",
    wsPricesFromSupplier: "Цени и посл. доставка от: {{name}}",
    wsResultsCount_one: "{{count}} резултат",
    wsResultsCount_other: "{{count}} резултата",
    wsAddedTag: "Добавен",
    wsNoLastDelivery: "без предишна доставка",
    wsNoSupplierDelivery: "няма доставка от този доставчик",
    wsEmptyTitle: "Няма добавени продукти",
    wsEmptyHint:
      "Намерете продукт с търсачката горе и натиснете Enter — редът се добавя тук, а фокусът отива направо в „Количество“.",
    wsEmptyKbdType: "пишете отвсякъде",
    wsEmptyKbdEnter: "добавя продукта",
    wsEmptyKbdEsc: "връща в търсачката",
    wsUnitTotals: "Общо количества",
    // Работен лист „Изписване" (страници създаване/редакция)
    backToWriteoffs: "Към изписванията",
    woSearchPh:
      "Добавете продукт или рецепта — просто започнете да пишете, напр. „домати“",
    woEmptyTitle: "Няма добавени редове",
    unitPortions: "порции",
    woEmptyHint:
      "Намерете продукт или рецепта с търсачката горе и натиснете Enter — редът се добавя тук, а фокусът отива направо в „Количество“.",
    draftRestoreTitle: "Незавършена доставка",
    draftRestoreTitleBy: "Незавършена доставка от {{name}}",
    draftRestoreSavedAt: "Запазена на",
    draftRestoreTotal: "Общо",
    draftRestoreQuestion: "Искате ли да продължите откъдето спряхте?",
    draftRestoreContinue: "Продължи",
    draftRestoreStartOver: "Започни наново",
    fieldWarehouse: "Склад",
    fieldWarehousePh: "Изберете склад",
    fieldProduct: "Продукт",
    fieldProductPh: "Изберете продукт",
    productOptStock: "Наличност",
    productOptLastDelivery: "Посл. доставка",
    fieldUnitPrice: "Ед. цена",
    fieldNote: "Бележка",
    fieldNotePh: "Незадължителна бележка към доставката",
    addRow: "Добави ред",
    total: "Общо",
    // Основа + ДДС в „Общо" (само при фирма, регистрирана по ДДС)
    totalBase: "Основа",
    totalVat: "ДДС",
    colComment: "Коментар",
    colUser: "Потребител",
    cancel: "Отказ",
    submit: "Заприходи",
    created: "Доставката е заприходена",
    errWarehouse: "Изберете склад",
    errNoWarehouses:
      "Няма създаден склад. Създайте склад в организацията, преди да записвате движения.",
    errDate: "Изберете дата",
    errNoLines: "Добавете поне един валиден ред",
    errCreate: "Грешка при заприходяване",
    // Изписвания
    writeoff: "Изписване",
    newWriteoff: "Ново изписване",
    noWriteoffs: "Все още няма изписвания за този склад.",
    kpiWriteoffs: "Изписвания",
    colReason: "Причина",
    colNote: "Бележка",
    colAvailable: "Наличност",
    fieldReason: "Причина",
    fieldReasonPh: "Свободен текст",
    fieldComment: "Коментар",
    fieldCommentPh: "Незадължителен коментар",
    recipe: "Рецепта",
    selectRecipe: "Изберете рецепта",
    splitToProducts: "Раздели на продукти",
    revertToRecipe: "Върни в рецепта",
    confirmContinue: "Продължи",
    editDeliveryTitle: "Редакция на доставка",
    editWriteoffTitle: "Редакция на изписване",
    editSubmitWriteoff: "Редактирай изписване",
    edit: "Редакция",
    delete: "Анулирай",
    confirmDeleteTitle: "Анулиране на записа?",
    confirmDeleteBody:
      "Записът ще бъде анулиран и наличността преизчислена. Действието е необратимо.",
    deleted: "Записът е анулиран",
    errDelete: "Грешка при анулиране",
    errLoad: "Грешка при зареждане",
    confirmLeaveTitle: "Незапазени промени",
    confirmLeaveBody:
      "Имате незапазени промени. Да напуснете ли без запазване?",
    confirmLeave: "Напусни",
    confirmDeleteRowTitle: "Премахване на реда?",
    confirmDeleteRowBody: "Този ред ще бъде премахнат.",
    confirmSplitTitle: "Разделяне на рецептата?",
    confirmSplitBody: "Редът ще се замени с продуктите на рецептата.",
    confirmRevertTitle: "Връщане в рецепта?",
    confirmRevertBody:
      "Разделените продукти ще се съберат обратно в един ред-рецепта.",
    notePh: "Бележка",
    portionsPh: "Порции",
    recipeGroupLabel: "Рецепта",
    recipeEmpty: "Рецептата няма съставки",
    fifo: "FIFO (първа влязла)",
    fieldWriteoffDate: "Дата на изписване",
    batchShort: "Партида",
    noBatch: "Без партида",
    remainShort: "Остатък",
    expiryShort: "Срок",
    noExpiry: "без срок на годност",
    writeoffSubmit: "Изпиши",
    writeoffCreated: "Изписването е записано",
    errWriteoff: "Грешка при изписване",
    errStock: "Не може да се изпише повече от наличното: {{products}}",
    // Бракуване (scrap) — 1:1 с изписването, различен тип + причина за брак
    scrap: "Бракуване",
    scrapReasonExpired: "Изтекъл срок",
    scrapReasonSpoiled: "Развалена стока",
    scrapReasonBroken: "Счупен/разсипан",
    scrapReasonMismatch: "Несъответствие",
    scrapReasonVoidMarking: "Брак от Маркиране",
    docScrapTitle: "Документ за бракуване",
    docScrapSubtitle: "Бракуване №{{id}}",
    docScrapHeading: "Бракуване на стока",
    // Прехвърляне между складове (transfer)
    // Прехвърляне — списък и работен лист (0.0.155)
    backToTransfers: "Към прехвърлянията",
    trxNotePh: "Незадължителна бележка",
    trxDirection: "Направление",
    trxRemains: "Остава {{warehouse}}",
    trxBecomes: "Става {{warehouse}}",
    trxLastPrice: "посл. цена {{price}}",
    trxNoPrice: "няма доставна цена",
    transfer: "Прехвърляне",
    newTransfer: "Ново прехвърляне",
    editTransferTitle: "Редакция на прехвърляне",
    transferSubmit: "Прехвърли",
    editSubmitTransfer: "Редактирай прехвърляне",
    transferCreated: "Прехвърлянето е записано",
    errTransfer: "Грешка при прехвърляне",
    noTransfers: "Все още няма прехвърляния за този склад.",
    kpiTransfers: "Прехвърляния",
    colFromWarehouse: "От склад",
    colToWarehouse: "Към склад",
    fieldFromWarehouse: "От склад",
    fieldFromWarehousePh: "Склад-източник",
    fieldToWarehouse: "Към склад",
    fieldToWarehousePh: "Склад-цел",
    errFromWarehouse: "Изберете склад-източник",
    errToWarehouse: "Изберете склад-цел",
    errSameWarehouse: "Източник и цел трябва да са различни складове",
    docTransferTitle: "Документ за прехвърляне",
    docTransferSubtitle: "Прехвърляне №{{id}}",
    docTransferHeading: "Прехвърляне между складове",
    errRecipe: "Грешка при зареждане на рецептата",
    // Разпределяне по складове + документ
    // Подсказки какво липсва, за да е активен бутонът „Заприходи"
    issueQty: "Въведете количество за: {{products}}",
    issuePrice: "Въведете ед. цена за: {{products}}",
    issueWarehouse: "Изберете склад на реда за: {{products}}",
    issueBatch: "Попълнете партида за „{{product}}“ (задължителна)",
    issueExpiry: "Попълнете срок на годност за „{{product}}“ (задължителен)",
    issueBatchFor: "Попълнете партида (задължителна) за: {{products}}",
    issueExpiryFor: "Попълнете срок на годност (задължителен) за: {{products}}",
    issueEmpty: "Добавете поне един продукт с количество, цена и склад",
    // Инвентаризация
    stocktake: "Инвентаризация",
    sectionOperations: "Операции",
    sectionReports: "Справки",
    stocktakeSubmit: "Потвърди инвентаризацията",
    newStocktake: "Нова инвентаризация",
    editStocktakeTitle: "Редакция на инвентаризация",
    editSubmitStocktake: "Запази промените",
    stocktakeCreated: "Инвентаризацията е записана",
    errStocktake: "Грешка при инвентаризация",
    errNoCounts: "Въведете поне един преброен продукт",
    colSystem: "Търсено",
    colCounted: "Намерено",
    colDiff: "Разлика",
    colStatus: "Статус",
    statusEqual: "равен",
    statusSurplus: "излишък",
    statusShortage: "липса",
    statusSubstitute: "заместване",
    kpiSurplus: "Излишък",
    kpiShortage: "Липси",
    hideZeroStock: "Скрий без наличност",
    stockAsOfField: "Към дата",
    stockAsOfNow: "Към днес",
    stockAsOfNote: "Количества към края на {{date}} · стойности по текущи цени",
    stockGrossCurrentPrices: "Бруто по текущи цени",
    showZeroStock: "Покажи всички",
    stocktakeReasonPh: "Бележка / причина (по избор)",
    noProducts: "Няма продукти в този склад",
    noStocktakes: "Няма инвентаризации за периода",
    colSurplus: "Излишък",
    colShortage: "Липси",
    colNetValue: "Нетна стойност",
    // Справка „Наличности"
    stockReport: "Наличности",
    searchStockPh: "Търси по продукт, категория, фира…",
    colCategory: "Категория",
    colGroup: "Група",
    stockLotsSubtitle: "Хронология на движенията",
    stockLotsEmpty: "Няма движения за този продукт.",
    colMinQty: "Мин. наличност",
    colWaste: "Фира",
    colAvgPrice: "Ср. цена (бруто)",
    colLastPrice: "Последна доставна цена",
    // Съкратеният вариант — за таблици с много колони (Излишък от продажби)
    colLastPriceShort: "Посл. доставна цена",
    underMin: "Под минимума",
    nearMin: "До 20% над минимума",
    overMin: "Над 20% над минимума",
    kpiStocktakes: "Инвентаризации",
    // Инвентаризация — списък и работен лист (0.0.152)
    backToStocktakes: "Към инвентаризациите",
    groupByWarehouse: "Групирай по склад",
    groupStocktakesCount_one: "{{count}} инвентаризация",
    groupStocktakesCount_other: "{{count}} инвентаризации",
    fieldStocktakeDate: "Дата",
    colUnitShort: "Ед.",
    fieldStocktakeReason: "Бележка / причина (по избор)",
    stxSearchPh: "Търси продукт за преброяване…",
    stxCountedTag: "преброен",
    stxDraftTitle: "Незавършена инвентаризация",
    stxDraftTitleBy: "Незавършена инвентаризация от {{name}}",
    // Взаимозамени (секцията вдясно от таблицата)
    subPanelTitle: "Взаимозамени",
    subPanelPairs_one: "{{count}} двойка",
    subPanelPairs_other: "{{count}} двойки",
    subCoefficient: "Коеф.",
    subApply: "Замени",
    subRevert: "Отмени",
    subChipHint: "Участва във взаимозамяна",
    subNoSurplusLeft:
      "Излишъкът на този продукт вече е използван от друга замяна",
    // Взаимозаменяеми продукти
    interchange: "Взаимозаменяеми продукти",
    newInterchange: "Ново правило",
    newInterchangeTitle: "Създаване на взаимозаменяеми продукти",
    editInterchangeTitle: "Редакция на правило",
    backToInterchangeables: "Към взаимозаменяемите",
    interchangeSubmit: "Запази правилото",
    interchangeGroupProducts: "Продукти в групата",
    interchangeProductsSubtitle:
      "Всички изброени продукти могат да заместват един друг",
    interchangeAddProductPh: "Добавете продукт към групата…",
    interchangePairExample:
      "Числата са спрямо първия продукт; всяка друга двойка се получава от тях — напр.",
    interchangeHowApplies: "Как ще се прилага",
    interchangeCoef: "Коефициент",
    interchangeCoefHelp:
      "Коефициент = колко базови единици на групата е 1 единица от продукта (1:1 за равностойни, напр. 1 пюре = 0.7 сок). Приоритет = кой се ползва пръв при покриване; празно → продуктът с най-стара доставка.",
    interchangeSortIndex: "Приоритет",
    interchangeSortPh: "напр. 1",
    interchangeNeedTwo: "Групата трябва да съдържа поне 2 продукта",
    interchangeHintCol: "Коментар",
    interchangeHintPh: "Незадължителен коментар за групата",
    interchangeHint:
      "При липса на някой от продуктите в групата системата предлага изписване от останалите по показаните съотношения — при разнасяне на отчет и при инвентаризация.",
    interchangeSearchPh: "Продукт или коментар…",
    noInterchange: "Все още няма групи взаимозаменяеми продукти.",
    interchangeBadCoef: "Коефициентът трябва да е положително число",
    interchangeSaved: "Групата е записана",
    back: "Назад",
    substitutionsReport: "Взаимозаменени продукти",
    noSubstitutions: "Няма замени за периода.",
    subSearchPh: "Търси по продукт или тип…",
    // Справка „Анулирани дейности" (soft delete следа)
    deletedReport: "Анулирани дейности",
    deletedColWhen: "Анулирано на",
    deletedColDocDate: "Дата на документа",
    deletedColBy: "Анулирано от",
    deletedKpiCount: "Анулирани записи",
    deletedSearchPh: "Търси по вид, продукт или потребител…",
    noDeleted: "Няма анулирани дейности за периода.",
    deletedSubtitle: "Анулирано от {{who}} на {{when}}",
    deletedType_delivery: "Доставка",
    deletedType_writeoff: "Изписване",
    deletedType_scrap: "Бракуване",
    deletedType_stocktake: "Инвентаризация",
    deletedType_transfer: "Прехвърляне",
    deletedType_substitution: "Замяна",
    deletedType_report: "Разнасяне на отчет",
    deletedNetValue: "Нетна стойност",
    deletedRestore: "Възстанови",
    deletedRestoreTitle: "Възстановяване на записа?",
    deletedRestoreBody:
      "Записът ще се върне в нормалните списъци, а количествата му ще се приложат отново върху наличността.",
    deletedRestored: "Записът е възстановен",
    errRestore: "Грешка при възстановяване",
    colSubCount: "Брой замени",
    subSourceStocktake: "При инвентаризация",
    subColFrom: "От (донор)",
    subColTo: "На (получател)",
    subWrittenOff: "Изписано",
    subCovered: "Покрито",
    // Страница „Излишък от продажби" (бивш „Недостиг" — недостиг от разнесени отчети)
    negativeReport: "Излишък от продажби",
    negSearchPh: "Продукт, склад или категория…",
    noNegative: "Няма продукти с отрицателна наличност.",
    kpiNegCount: "Продукти в недостиг",
    kpiNegNet: "Стойност нето",
    kpiNegGross: "Стойност бруто",
    shortageTotal: "Общо непокрит излишък",
    shortageProductsCount_one: "{{count}} продукт",
    shortageProductsCount_other: "{{count}} продукта",
    shortageRowDelivery: "Доставка",
    colDeficitQty: "Количество",
    shortageBreakdownSubtitle: "Натрупан от отчети",
    shortageBreakdownHint:
      "Доставка покрива само отчети СЛЕД датата ѝ. За да занулиш по-стар недостиг, върни доставка със задна дата — на/преди отчета, който го е причинил.",
    compensateBackdated: "Компенсирай със задна дата",
    errSave: "Грешка при запис",
    docStocktakeTitle: "Документ за инвентаризация",
    docStocktakeSubtitle: "Инвентаризация №{{id}}",
    docStocktakeHeading: "Инвентаризация",
    docTitle: "Документ за доставка",
    docSubtitle: "Доставка №{{id}}",
    docHeading: "Заприходяване",
    docWriteoffTitle: "Документ за изписване",
    docWriteoffSubtitle: "Изписване №{{id}}",
    docWriteoffHeading: "Изписване на стока",
    // ─── Разнасяне на отчети ───────────────────────────────────────────────
    posting: "Разнасяне на отчети",
    soldProducts: "Продадени продукти",
    soldRecipes: "Продадени рецепти",
    newPosting: "Ново разнасяне",
    editPostingTitle: "Редакция на разнасяне",
    backToPostings: "Към разнасянията",
    kpiPostings: "Разнасяния",
    kpiPostedProducts: "Изписани продукти",
    kpiCompensations: "Компенсации",
    colReportNo: "Отчет №",
    colDateTime: "Дата и час",
    periodTotal: "Общо за периода",
    postingColSold: "Продадени",
    postingSoldRecipes: "рецепти",
    postingSoldProducts: "продукта",
    postingColCompensations: "Компенсации",
    postingSubsBadge: "{{count}} зам.",
    postingPickReport: "Изберете отчет",
    postingNoPending: "Няма неразнесени отчети",
    postingReportOption: "Отчет №{{number}} · {{date}}",
    postingPickSubtitle_one: "{{count}} неразнесен отчет на заведението",
    postingPickSubtitle_other: "{{count}} неразнесени отчета на заведението",
    postingPickBills_one: "{{count}} сметка",
    postingPickBills_other: "{{count}} сметки",
    postingPickTurnover: "Оборот",
    postingProductTag: "Продукт",
    postingRecipeTag: "Рецепта",
    postingColWarehouse: "Склад",
    postingWhSourceProduct: "Склад на продукта (Конфигурации → Склад по продукт)",
    postingWhSourceStation: "Склад на станцията на рецептата",
    postingAlwaysFrom: "Винаги от {{warehouse}}",
    postingAlwaysFromTitle: "{{product}} — винаги от {{warehouse}}?",
    postingAlwaysFromBody:
      "При следващите разнасяния и при брак от сторно продуктът ще се изписва от {{warehouse}}, а не от склада на станцията на рецептата.",
    postingAlwaysFromUndo: "Промяна или махане — в Конфигурации → Склад по продукт.",
    postingColAvail: "Наличност",
    postingColToWriteoff: "За изписване",
    colQtyShort: "К-во",
    postingColItem: "Артикул",
    postingTotalWriteoff: "Общо изписване",
    postingPerWarehouse: "по складове",
    postingCovered: "покрито",
    postingRemoveSub: "Премахни замяната (връща наличността на минус)",
    postingShortageSummary_one: "{{count}} продукт не достига",
    postingShortageSummary_other: "{{count}} продукта не достигат",
    postingNoShortage: "Всички продукти са налични",
    postingSplitMismatch: "Разпределеното не съвпада с нужното количество",
    postingCompTitle: "Компенсиране на липси",
    postingCompMarked: "{{applied}} от {{total}} отбелязани",
    postingCompSelectAll: "избери всички",
    postingCompApplied_one: "{{count}} компенсиран",
    postingCompApplied_other: "{{count}} компенсирани",
    postingSoldTitle: "Продадено",
    postingReportShort: "Отчет №{{number}}",
    postingSoldPositions_one: "{{count}} позиция",
    postingSoldPositions_other: "{{count}} позиции",
    postingSoldTotalQty: "{{qty}} бр",
    postingSoldShow: "Покажи продаденото",
    postingSoldHide: "Скрий продаденото",
    postingSoldStationWarehouse: "→ склад {{name}}",
    postingSoldStationNoWarehouse: "без склад",
    // Разбивката при отчета (под избраната карта / „Сервитьори и станции ▸")
    postingBreakdownTitle: "Сервитьори и станции",
    postingBreakdownWaiters: "Сервитьори",
    postingBreakdownStations: "Станции",
    postingBreakdownStationsCount_one: "{{count}} станция",
    postingBreakdownStationsCount_other: "{{count}} станции",
    postingWriteoffTitle: "Изписване от склад",
    postingWriteoffProducts_one: "{{count}} продукт",
    postingWriteoffProducts_other: "{{count}} продукта",
    postingShortBadge_one: "{{count}} липса",
    postingShortBadge_other: "{{count}} липси",
    postingSaveEdit: "Запази промените",
    postingEditNone: "Няма разнесени отчети за избрания период",
    postingPosted: "Отчетът е разнесен",
    postingUpdated: "Промените са запазени",
    postingErr: "Грешка при разнасяне на отчета",
    postingNoRecipes: "Отчетът няма продадени артикули",
    postingMissingWarehouse: "Изберете склад за: {{names}}",
    postingPickWarehouse: "Изберете",
    postingNoWarehouseHint:
      "Изберете склад — или задайте складове на станциите (Организация → Меню → Станции) или „Склад по продукт“ (Конфигурации)",
    postingConfirmTitle: "Затваряне на деня",
    postingConfirmEditTitle: "Запазване на промените",
    postingConfirmBody:
      "Има продукти с недостиг — те ще се изпишат с отрицателна наличност. Да продължим?",
    postingConfirmBodyOk:
      "Да разнесем ли отчета и да изпишем количествата от склада?",
    postingConfirmOk: "Разнеси отчета",
    postingDocTitle: "Документ разнасяне",
    postingDocSubtitle: "Разнасяне №{{id}}",
    postingDocHeading: "Разнасяне на отчет",
    // Справки: продадени продукти / рецепти
    soldColName: "Наименование",
    soldColSold: "Продадено (бр)",
    soldColTotalQty: "Общо количество",
    soldColAvgPrice: "Ср. цена (бруто)",
    soldColIngredients: "Съставки",
    soldSearchPh: "Търси по име…",
    // „Последна продажба" (само рецепти): колона, ред в картата, хедър на панела, Excel
    soldColLastSold: "Последна продажба",
    soldLastSoldLine: "последна продажба {{date}}",
    // Под търсачката — какво отваря клик на ред
    soldOpenHintRecipe: "Натиснете рецепта — продажбите по дни и по отчети",
    soldOpenHintProduct: "Натиснете продукт — складовата карта за периода",
    // Постоянното съобщение над таблицата (sold/SoldPostedOnlyNotice)
    soldPostedOnlyNotice:
      "Тук се броят само продажбите от разнесени отчети. Днешните се появяват, след като се направи отчетът на заведението и се разнесе.",
    soldPendingReports_one: "Чака разнасяне: {{count}} отчет",
    soldPendingReports_other: "Чакат разнасяне: {{count}} отчета",
    soldPostAction: "Разнеси",
    noSold:
      "Няма разнесени продажби за избрания период (справката показва само разнесени отчети)",
    soldKpiCount: "Брой",
    soldKpiQty: "Общо количество",
    soldKpiRevenue: "Оборот",
    close: "Затвори",
    print: "Принтирай",
    docEdit: "Редактирай",
    docDelete: "Анулирай",
    navDeliveryPayments: "Плащане на доставки",
    navPostedReports: "Разнесени отчети",
    navDeliveriesReport: "Доставки",
    navWriteoffsReport: "Изписвания",
    navStocktakesReport: "Инвентаризации",
    navTransfersReport: "Прехвърляния",
    closeMenu: "Затвори менюто",
    openMenu: "Отвори менюто",
    kickerReport: "Справка",
    exportExcel: "Експорт в Excel",
    viewDocument: "Преглед на документа",
    rowMenu: "Още действия",
    showMore: "Покажи още ({{count}})",
    pdfHint: "В прозореца за печат изберете „Запази като PDF“",
    statusPosted: "Разнесен",
    statusAnnulled: "Анулиран",
    statusAnnulledStamp: "АНУЛИРАН",
    annulledBanner: "Анулиран на {{date}}",
    annulReason: "Причина",
    annulReasonPh: "напр. грешна рецептура",
    annulledToast: "Документ №{{number}} е анулиран",
    segAll: "Всички",
    segPosted: "Разнесени",
    segAnnulled: "Анулирани",
    colDocument: "Документ",
    colReport: "Отчет",
    colWrittenOff: "Изписани",
    colSubstitutions: "Замествания",
    kpiValueGross: "Обща стойност · бруто",
    periodTotalActive: "Общо за периода · без анулирани",
    postedNoDocs: "Няма документи за избрания период.",
    postedSearchPh: "Търсене по документ, отчет, потребител…",
    filterPostedBy: "Разнесъл",
    filterNoMatch: "Няма съвпадения",
    filterClear: "Изчисти",
    filterDone: "Готово",
    filterClearAll: "Изчисти всички",
    periodCustom: "Период",
    periodApply: "Приложи",
    periodPickStart: "Изберете начална дата",
    period_today: "Днес",
    period_yesterday: "Вчера",
    period_last7: "Последните 7 дни",
    period_last30: "Последните 30 дни",
    period_thisMonth: "Този месец",
    period_lastMonth: "Миналия месец",
    period_thisYear: "Тази година",
    prevMonth: "Предишен месец",
    nextMonth: "Следващ месец",
    month0: "Януари",
    month1: "Февруари",
    month2: "Март",
    month3: "Април",
    month4: "Май",
    month5: "Юни",
    month6: "Юли",
    month7: "Август",
    month8: "Септември",
    month9: "Октомври",
    month10: "Ноември",
    month11: "Декември",
    weekday_mon: "Пн",
    weekday_tue: "Вт",
    weekday_wed: "Ср",
    weekday_thu: "Чт",
    weekday_fri: "Пт",
    weekday_sat: "Сб",
    weekday_sun: "Нд",
    postingPendingSubtitle_one: "{{count}} неразнесен отчет · най-старият е най-отгоре",
    postingPendingSubtitle_other: "{{count}} неразнесени отчета · най-старият е най-отгоре",
    postingGoPosted: "Разнесени отчети →",
    postingAllPostedTitle: "Всички отчети са разнесени",
    postingAllPostedText: "Новите отчети ще се появят тук след затваряне на деня.",
    postingViewPosted: "Виж разнесените отчети",
    postingPendingList: "Неразнесени отчети",
    postingAgeToday: "Днес",
    postingAgeYesterday: "Вчера",
    postingAgeDays_one: "{{count}} ден",
    postingAgeDays_other: "{{count}} дни",
    postingAgeLate_one: "Закъснял · {{count}} ден",
    postingAgeLate_other: "Закъснял · {{count}} дни",
    postingReportTitle: "Отчет №{{number}}",
    postingCardNumber: "№{{number}}",
    postingMetaClosed: "затворен {{time}}",
    postingMetaTurnover: "оборот {{amount}}",
    postingMetaWaiters_one: "{{count}} сервитьор",
    postingMetaWaiters_other: "{{count}} сервитьора",
    postingStatusShort_one: "{{count}} продукт с недостиг",
    postingStatusShort_other: "{{count}} продукта с недостиг",
    postingStatusWithSub: "{{count}} със заместител",
    postingStatusAllAvailable: "Всичко е налично",
    postingStatusNoWarehouse_one: "{{count}} продукт без склад",
    postingStatusNoWarehouse_other: "{{count}} продукта без склад",
    // кратките — в тясната карта на чакащ отчет (пълните са в подсказката)
    postingStatusNoWarehouseShort: "{{count}} без склад",
    postingStatusShortShort: "{{count}} с недостиг",
    postingStatusAllAvailableShort: "Налично",
    postingStatusReturned: "Върнат след анулиране на №{{number}}",
    postingCorrectsAnnulled: "Коригира анулиран №{{number}}",
    postingChipShort_one: "{{count}} продукт не достига",
    postingChipShort_other: "{{count}} продукта не достигат",
    postingChipSubstituted: "{{count}} заместени",
    postingRemaining_one: "{{count}} продукт ще остане на минус",
    postingRemaining_other: "{{count}} продукта ще останат на минус",
    postingSubmitReport: "Разнеси Отчет №{{number}}",
    postingShortConfirmTitle: "Разнасяне с недостиг",
    postingShortConfirmBody: "Тези продукти ще се изпишат с отрицателна наличност. Да продължим?",
    postingShortConfirmOk: "Разнеси отчета",
    postingPostedToast: "Отчет №{{number}} е разнесен",
    postingViewDocument: "Виж документа",
    postingLeaveBody: "Избраните замени за този отчет ще се загубят.",
    postingSubsTitle: "Замяна с взаимозаменяеми продукти",
    postingSubsHint: "Разпределете липсващото количество между един или няколко заместителя.",
    postingAvailableShort: "налични",
    postingMissing: "Липсват {{qty}}",
    postingCoveredLabel: "Покрито",
    postingSubQty: "Количество от {{name}}",
    postingInsteadOf: "⇄ вместо {{name}}",
    postingCoveredNote: "⇄ {{qty}} {{unit}} покрити със заместител",
    postingColAfter: "След",
    postingPositions_one: "{{count}} позиция",
    postingPositions_other: "{{count}} позиции",
    postingDocTitleNo: "Документ разнасяне №{{number}}",
    postingRepost: "Коригирай и разнеси повторно",
    postingRepostHint: "Анулира и отваря отчета наново",
    postingRepostTitle: "Корекция на документ №{{number}}",
    postingRepostText: "Изписаните количества се връщат в склада, а Отчет №{{report}} се отваря за ново разнасяне с досегашните замени.",
    postingRepostConfirm: "Анулирай и коригирай",
    postingAnnulTitle: "Анулиране на документ №{{number}}",
    postingAnnulText: "Изписаните количества се връщат в склада, а Отчет №{{report}} се връща в „Разнасяне на отчети“.",
    printShort: "Печат",
    chipSearch: "Търсене: „{{q}}“",
    colDocType: "Тип",
    colLinks: "Връзки",
    colNoteNo: "Стокова №",
    colPayment: "Плащане",
    deliveriesNone: "Няма доставки за този филтър.",
    deliveriesResult_one: "{{count}} доставка",
    deliveriesResult_other: "{{count}} доставки",
    deliveriesSearchPh: "Търсене по номер, доставчик, продукт, потребител…",
    deliveriesSumHint: "(стоковите по фактура не се сумират)",
    deliveryAnnulTitle: "Анулиране на доставка",
    deliveryAnnulText: "Количествата се изваждат от склада. Документът остава в справката като анулиран.",
    deliveryAnnulOwnLines_one: "Собственият {{count}} ред се изважда от склада",
    deliveryAnnulOwnLines_other: "Собствените {{count}} реда се изваждат от склада",
    deliveryAnnulNoOwnLines: "Собствени редове няма — от склада не се изважда нищо",
    deliveryAnnulNotesStay_one: "{{count}} стокова остава заприходена и се връща в „Стокови без фактура“",
    deliveryAnnulNotesStay_other: "{{count}} стокови остават заприходени и се връщат в „Стокови без фактура“",
    deliveryAnnulStays: "Документът остава в справката като анулиран.",
    deliverySavedToast: "Доставка {{number}} е записана",
    docHeadingNote: "Стокова разписка",
    docTypeInvoice: "Фактура",
    docTypeNote: "Стокова",
    draftStatusDraft: "Чернова",
    draftStatusHeld: "Задържана",
    draftStatusBusy: "Редактира се",
    draftStatusUnfinished: "Незавършена",
    enteredBy: "въведена от {{name}}",
    filterEnteredBy: "Въвел",
    homeAllDeliveries: "Всички доставки →",
    homeColleagues: "Колеги в процес",
    homeContinueDelivery: "Продължи доставката",
    homeContinueDraft: "Продължи незавършената",
    homeDiscardAndNew: "Изтрий и започни нова",
    homeDraftLines_one: "{{count}} продукт",
    homeDraftLines_other: "{{count}} продукта",
    homeDraftModalTitle: "Имате незавършена доставка",
    homeDraftModalText: "Продължете нея или я изтрийте, за да започнете нова.",
    homeDraftUpdated: "последна промяна {{when}}",
    homeEnterInvoice: "Въведи фактура",
    homeHasDraft: "Имате незавършена доставка",
    homeMyDraftTitle: "Незавършена доставка",
    homeMyDraftHint: "Всеки потребител може да има само една незавършена доставка.",
    homeNoDraft: "Нямате незавършена доставка.",
    homeNoSupplier: "Без доставчик",
    homeNotesInfo_one: "{{count}} стокова · {{from}}",
    homeNotesInfo_other: "{{count}} стокови · {{from}} – {{to}}",
    homeTodayTitle: "Въведени днес",
    homeTodayCount_one: "{{count}} доставка",
    homeTodayCount_other: "{{count}} доставки",
    homeTodayNone: "Днес още няма въведени доставки.",
    homeUninvoicedTitle: "Стокови без фактура",
    homeUninvoicedHint: "Когато доставчикът издаде обобщаваща фактура, въведете я оттук.",
    homeUnpaidCount_one: "{{count}} неплатен документ",
    homeUnpaidCount_other: "{{count}} неплатени документа",
    internalNo: "вътр. №{{id}}",
    invoiceLinksNotes_one: "Фактурата обобщава {{count}} стокова:",
    invoiceLinksNotes_other: "Фактурата обобщава {{count}} стокови:",
    kpiUninvoicedNotes: "Стокови без фактура",
    kpiUnpaid: "Неплатени",
    linkInvoice: "Фактура · вътр. №{{id}}",
    linkWaitingInvoice: "чака фактура",
    linkClosedNoInvoice: "приключена без фактура",
    filterInvoiceState: "Фактура",
    invoiceState_waiting: "Чака фактура",
    invoiceState_closed: "Приключена без фактура",
    invoiceState_inInvoice: "Във фактура",
    linkNote: "СР · вътр. №{{id}}",
    newDeliveryPlus: "+ Нова доставка",
    noDocNumber: "б/н",
    noteInInvoiceBanner: "Стоковата е включена във фактура — там се плаща и коригира.",
    openInvoice: "Отвори фактурата",
    optional: "незадължително",
    payAge_one: "преди {{count}} ден",
    payAge_other: "преди {{count}} дни",
    payAllPaid: "Всички доставки са платени.",
    payPaid: "Платена",
    payUnpaid: "Неплатена",
    payByInvoice: "По фактура",
    payAnnulled: "Анулирана",
    payPaidMany: "Платени",
    payUnpaidMany: "Неплатени",
    payAnnulledMany: "Анулирани",
    payUntracked: "Без данни за плащане",
    payMethod_cash: "В брой",
    payMethod_bank: "Банков превод",
    payMethod_card: "Карта",
    payModalTitle: "Плащане",
    payDate: "Дата на плащане",
    payMethod: "Начин",
    payReference: "Основание / референция",
    payConfirm: "Потвърди плащането",
    payDocsCount_one: "{{count}} документ",
    payDocsCount_other: "{{count}} документа",
    paySelected_one: "Избран {{count}} документ",
    paySelected_other: "Избрани {{count}} документа",
    payMarkPaid: "Отбележи като платени",
    payPickFirst: "Отметнете поне един документ",
    payDoneToast_one: "{{count}} документ е отбелязан като платен",
    payDoneToast_other: "{{count}} документа са отбелязани като платени",
    payError: "Плащането не беше записано",
    payNeedsServerTitle: "Плащането още не е включено на сървъра",
    payNeedsServerText: "Екранът работи след обновяване на бекенда до версията с плащане на доставки.",
    docLabelInvoice: "Фактура {{number}}",
    docLabelNote: "Стокова {{number}}",
    payPanelPaid: "Платена на {{date}}",
    payPanelReference: "осн. {{reference}}",
    payPanelMarkedBy: "отбеляза {{name}}",
    payPanelUnpaidToday: "Неплатена · от днес",
    payPanelUnpaid_one: "Неплатена · от {{count}} ден",
    payPanelUnpaid_other: "Неплатена · от {{count}} дни",
    payPanelByInvoice: "Плаща се през фактурата",
    payPanelPaidSeparately: "платена отделно на {{date}}",
    payPanelAnnulled: "Документът е анулиран",
    payChange: "Промени",
    payMarkPaidOne: "Отбележи като платена",
    payMarkUnpaid: "Отбележи като неплатена",
    payUnpayTitle: "{{doc}} да стане неплатена?",
    payUnpayText: "{{doc}} става неплатена и се връща в „Плащане на доставки“.",
    payUnpayTextNotes_one: "{{doc}} става неплатена и се връща в „Плащане на доставки“ заедно с {{count}} стокова към нея — тя се плаща през фактурата. Стокова, платена отделно преди фактурата, остава платена.",
    payUnpayTextNotes_other: "{{doc}} става неплатена и се връща в „Плащане на доставки“ заедно с {{count}} стокови към нея — те се плащат през фактурата. Стоковите, платени отделно преди фактурата, остават платени.",
    payUnpaidToast: "{{doc}} е отбелязана като неплатена",
    payUnpayError: "Отмяната на плащането не беше записана",
    payUndo: "Отмени",
    payUndoneToast_one: "Плащането на {{count}} документ е отменено",
    payUndoneToast_other: "Плащането на {{count}} документа е отменено",
    payNotesPaidSeparately_one: "{{count}} стокова е платена отделно — не е в сумата",
    payNotesPaidSeparately_other: "{{count}} стокови са платени отделно — не са в сумата",
    noteDetach: "Извади от фактурата",
    noteDetachTitle: "Да се извади ли стоковата от фактурата?",
    noteDetachText: "{{doc}} излиза от фактурата и се връща в „Стокови без фактура“. Стоката ѝ остава заприходена. Ако фактурата е платена, стоковата остава платена със същото плащане.",
    noteDetachConfirm: "Извади",
    noteDetachedToast: "{{doc}} е извадена от фактурата",
    noteDetachError: "Изваждането не беше записано",
    noteClose: "Приключи без фактура",
    noteCloseTitle: "Приключване без фактура",
    noteCloseText: "Стоковата излиза от „Стокови без фактура“ — фактура за нея няма да се чака. Ако все пак дойде, „Върни за фактуриране“ я връща.",
    noteCloseReason: "Причина",
    noteCloseReasonPh: "напр. Доставчикът не издава фактура",
    noteCloseMarkPaid_one: "и я отбележи като платена",
    noteCloseMarkPaid_other: "и ги отбележи като платени",
    noteCloseStaysUnpaid: "Без отметката неплатената стокова остава в „Плащане на доставки“, докато не я платите.",
    noteCloseConfirm: "Приключи",
    noteClosePick: "Отметнете поне една стокова",
    noteClosedToast_one: "{{count}} стокова е приключена без фактура",
    noteClosedToast_other: "{{count}} стокови са приключени без фактура",
    noteCloseError: "Приключването не беше записано",
    noteClosedBanner: "Приключена без фактура на {{date}}",
    noteReopen: "Върни за фактуриране",
    noteReopenedToast: "{{doc}} отново чака фактура",
    noteReopenError: "Връщането не беше записано",
    revClosedWithoutInvoice: "Приключена без фактура",
    alreadyInDelivery: "„{{name}}“ вече е в доставката",
    catalogOpen: "Целият списък",
    catalogTitle: "Целият списък с продукти",
    catalogHint: "Кликнете ред и въведете количество и цена — Enter минава на следващия, Ctrl+Enter добавя всички в доставката",
    catalogFilterPh: "Филтър по име",
    catalogAllGroups: "Всички",
    catalogInDocument: "в документа",
    catalogPicked_one: "Избран {{count}} продукт",
    catalogPicked_other: "Избрани {{count}} продукта",
    catalogHintToggle: "отмята",
    catalogHintAdd: "добавя",
    catalogAdd: "Добави избраните",
    colVat: "ДДС",
    deleteDraft: "Изтрий черновата",
    deleteDraftTitle: "Изтриване на черновата",
    deleteDraftBody: "Незавършената доставка ще се изтрие. Нищо не е заприходено.",
    fieldDocType: "Тип документ",
    fieldNoteNo: "Стокова №",
    heldToast: "Доставката е задържана — нищо не е заприходено",
    lockLost: "{{name}} пое редакцията — промените ви вече не се пазят",
    notesOffer_one: "Доставчикът има {{count}} стокова без фактура. Ако фактурата я обобщава, изберете я.",
    notesOffer_other: "Доставчикът има {{count}} стокови без фактура. Ако фактурата ги обобщава, изберете ги.",
    notesPick: "Избери стокови",
    notesLinked_one: "Фактурата обобщава {{count}} стокова · {{total}}",
    notesLinked_other: "Фактурата обобщава {{count}} стокови · {{total}}",
    notesLinkedHint: "Стоката им вече е заприходена — фактурата само ги свързва и се плаща вместо тях. Нови редове добавяте отдолу.",
    notesChange: "Промени избора",
    notesModalTitle: "Кои стокови обобщава фактурата?",
    notesModalSub: "Стоковите на доставчика без фактура",
    notesModalHint: "Стоковите не се заприходяват втори път. Свързана стокова не се редактира и не се анулира самостоятелно.",
    notesMoreLines: "… и още {{count}} реда",
    notesPicked_one: "{{count}} стокова · {{total}}",
    notesPicked_other: "{{count}} стокови · {{total}}",
    notesApply: "Свържи с фактурата",
    payMethodLong: "Начин на плащане",
    presenceOnlyYou: "Само вие редактирате",
    probSaveTitle: "Има продукти с проблем",
    probSaveSub: "Изберете как да продължите",
    probSaveHold: "Задръж доставката",
    probSaveHoldHint: "Нищо не се заприходява, докато проблемът не се реши.",
    probSaveWithout: "Запиши без проблемните",
    probSaveWithoutHint: "Останалите продукти се заприходяват сега.",
    problemTitle: "Проблем с продукт",
    problemHint: "Маркираният продукт не блокира работата. При запис ще изберете дали да задържите цялата доставка или да я запишете без него.",
    problemNotePh: "напр. 3 бутилки счупени, чакаме кредитно известие",
    problemDescription: "Описание на проблема",
    problemMark: "Маркирай",
    problemClear: "Премахни маркировката",
    problemFlagHint: "Маркирай проблем",
    problemReason_damaged: "Повредена",
    problemReason_short: "Липсва количество",
    problemReason_wrong: "Грешен продукт",
    problemReason_expired: "Изтекъл срок",
    problemReason_other: "Друго",
    productsTitle: "Продукти",
    saveModalTitle: "Запис на доставката",
    saveModalSave: "Запиши",
    saveDateLabel: "За коя дата е документът?",
    saveNumberRequired: "Номерът на фактурата е задължителен",
    saveTypeHintInvoice: "Фактура — номерът е задължителен",
    saveTypeHintNote: "Стокова разписка — по-късно може да влезе във фактура",
    saveDelivery: "Запиши доставката",
    saveTemp: "Запази временно",
    savedTemp: "Черновата е запазена",
    homeLockTitle: "Доставката се редактира в момента",
    homeLockText: "{{name}} работи по тази доставка ({{supplier}}, {{lines}}, последна промяна {{when}}). Ако я поемете, промените на {{first}} спират да се пазят и {{first}} ще види, че сте поели редакцията.",
    homeTakeOver: "Поеми редакцията",
    homeTakeOverToast: "Поехте доставката на {{name}}",
    homeTakeOverFailed: "Доставката не можа да бъде поета — опитайте пак",
    homeDeleteDraftLocked: "{{name}} редактира черновата в момента — не може да бъде изтрита",
    shortageSubtitle: "Непокритият излишък по склад · покрива се с доставка със задна дата",
    shortageSortName: "По продукт",
    shortageSortValue: "По стойност",
    shortagePickFirst: "Отметнете поне един продукт",
    shortageSelectedGross_one: "Избран {{count}} продукт · бруто",
    shortageSelectedGross_other: "Избрани {{count}} продукта · бруто",
    shortageBackdatedTo: "доставка със задна дата {{date}}",
    shortageCompensate: "Компенсирай с доставка",
    shortageReportsInfo_one: "{{count}} отчет · от {{date}}",
    shortageReportsInfo_other: "{{count}} отчета · от {{date}}",
    shortageBreakdownOpen: "Разбивка по отчети",
    shortageCompensateOneHint: "Доставка само за този продукт",
    interchangeRulesCount_one: "{{count}} правило",
    interchangeRulesCount_other: "{{count}} правила",
    interchangeMembersCount_one: "{{count}} продукт в групата",
    interchangeMembersCount_other: "{{count}} продукта в групата",
    interchangeCatalogHint: "Отметнете продуктите, които се заместват взаимно, и ги добавете наведнъж",
    reportResult_one: "{{count}} резултат",
    reportResult_other: "{{count}} резултата",
    stockSubtitle_one: "{{count}} продукт · {{inStock}} с наличност",
    stockSubtitle_other: "{{count}} продукта · {{inStock}} с наличност",
    stockPickWarehouse: "Изберете склад, за да видите наличностите.",
    stockMinLine: "мин. {{qty}}",
    stockLastPriceLine: "посл. {{price}}",
    soldSubtitleProduct_one: "{{count}} продукт за периода",
    soldSubtitleProduct_other: "{{count}} продукта за периода",
    soldSubtitleRecipe_one: "{{count}} рецепта за периода",
    soldSubtitleRecipe_other: "{{count}} рецепти за периода",
    soldAvgLine: "ср. цена {{price}}",
    soldIngredientsLine_one: "{{count}} съставка",
    soldIngredientsLine_other: "{{count}} съставки",
    subSubtitle_one: "{{count}} замяна за периода · от всички складове",
    subSubtitle_other: "{{count}} замени за периода · от всички складове",
    deletedSubtitle_one: "{{count}} анулиран запис · периодът е по датата на анулиране",
    deletedSubtitle_other: "{{count}} анулирани записа · периодът е по датата на анулиране",
    newTransferPlus: "+ Ново прехвърляне",
    homeAllTransfers: "Всички прехвърляния →",
    trxHomeSubtitle: "Стоката минава от склад в склад по себестойност — FIFO или избрана партида.",
    trxHomeTodayTitle: "Прехвърлени днес",
    trxHomeTodayCount_one: "{{count}} прехвърляне",
    trxHomeTodayCount_other: "{{count}} прехвърляния",
    trxHomeTodayNone: "Днес още няма прехвърляния.",
    trxSavedToast: "Прехвърляне №{{number}} е записано",
    trxEnteredBy: "въведено от {{name}}",
    trxAnnulTitle: "Анулиране на прехвърляне №{{number}}",
    trxAnnulText: "Количествата се връщат в склада-източник. Документът остава в справката като анулиран.",
    trxCatalogTitle: "Наличните в {{warehouse}}",
    trxCatalogHint: "Само продуктите с наличност в склада-източник към датата — кликнете ред и въведете количеството",
    trxSegActive: "Активни",
    transfersSearchPh: "Търсене по №, склад, продукт, потребител, коментар…",
    transfersResult_one: "{{count}} прехвърляне",
    transfersResult_other: "{{count}} прехвърляния",
    transfersNone: "Няма прехвърляния за този филтър.",
    newStocktakePlus: "+ Нова инвентаризация",
    stocktakeHomeAll: "Всички инвентаризации →",
    stocktakeHomeHasDraft: "Имате незавършена инвентаризация",
    stocktakeHomeDraftHint: "Черновата се пази автоматично в този браузър, докато не запишете или изтриете инвентаризацията.",
    stocktakeHomeNoDraft: "Нямате незавършена инвентаризация.",
    stocktakeHomeContinue: "Продължи инвентаризацията",
    stocktakeHomeCounted_one: "{{count}} преброен продукт",
    stocktakeHomeCounted_other: "{{count}} преброени продукта",
    stocktakeCountedShort_one: "{{count}} преброен",
    stocktakeCountedShort_other: "{{count}} преброени",
    stocktakeDraftModalTitle: "Имате незавършена инвентаризация",
    stocktakeLatestTitle: "Последна инвентаризация по склад",
    stocktakeLatestHint: "„Започни“ отваря нова инвентаризация направо за склада.",
    stocktakeLatestNever: "Още няма инвентаризация",
    stocktakeStart: "Започни",
    stkUnfinished: "Незавършена",
    stkUnfinishedYours: "вашата",
    stkCountingNow: "в момента брои {{name}}",
    stkWhenToday: "днес {{time}}",
    stkWhenYesterday: "вчера {{time}}",
    stkRowContinue: "Продължи",
    stkRowTakeOver: "Поеми",
    stkColleagueAskTitle: "{{name}} вече брои {{warehouse}}",
    stkColleagueAskText: "Продължете започнатото броене или започнете отделно — двете се записват като отделни инвентаризации.",
    stkColleagueAskCaption: "Започнатото броене",
    stkColleagueContinue: "Продължи броенето на {{first}}",
    stkColleagueContinueHint: "Отваря листа с преброеното досега — нищо не се брои два пъти",
    stkColleagueSeparate: "Започни отделна",
    stkColleagueSeparateHint: "Нова инвентаризация на {{warehouse}} до тази на {{first}}",
    stocktakeAgoToday: "днес",
    stocktakeAgoDays_one: "преди {{count}} ден",
    stocktakeAgoDays_other: "преди {{count}} дни",
    stocktakeSavedToast: "Инвентаризация №{{number}} е записана",
    stocktakeAnnulTitle: "Анулиране на инвентаризация №{{number}}",
    stocktakeAnnulText: "Излишъците и липсите ѝ се отменят — наличността се преизчислява без нея. Документът остава в справката като анулиран.",
    stocktakesSearchPh: "Търсене по №, склад, потребител, причина, продукт…",
    stocktakeStatusActive: "Активна",
    stocktakeStatusAnnulled: "Анулирана",
    stocktakeNoGroup: "Без група",
    woCatalogTitle: "Целият списък с продукти и рецепти",
    woCatalogHint: "Кликнете ред и въведете количеството — Enter минава на следващия, Ctrl+Enter добавя всички наведнъж",
    woCatalogRecipes: "Рецепти",
    woLinesCount_one: "{{count}} ред",
    woLinesCount_other: "{{count}} реда",
    newWriteoffPlus: "+ Ново изписване",
    woHomeAll: "Всички изписвания →",
    woHomeSubtitle: "Изписване и бракуване · склад {{warehouse}}",
    woQuickTitle: "Бързо начало",
    woQuickHint: "Видът и причината се попълват в листа",
    woTodayTitle: "Изписани днес",
    woTodayNone: "Днес още няма изписвания в този склад.",
    woDocsCount_one: "{{count}} документ",
    woDocsCount_other: "{{count}} документа",
    woNoReason: "Без причина",
    woProductsCount_one: "{{count}} продукт",
    woProductsCount_other: "{{count}} продукта",
    woSavedToast: "Изписване №{{number}} е записано",
    woScrapSavedToast: "Бракуване №{{number}} е записано",
    woAnnulTitle: "Анулиране на изписване №{{number}}",
    woAnnulText: "Изписаните количества се връщат в склада. Документът остава в справката като анулиран.",
    woReportSearchPh: "Търсене по №, причина, коментар, продукт, потребител…",
    woReportNone: "Няма изписвания за този филтър.",
    woStatusActive: "Активни",
    wsCreateNamed: "Нов продукт „{{name}}“",
    stoCatalogTitle: "Целият списък — какво броите",
    stoCatalogHint: "Отметнете продуктите, които ще броите сега — те застават най-отгоре в таблицата, в реда на избора, и ги броите един след друг със ↓.",
    // „Целият списък" (components/search/CatalogPickerModal) — колони, групи, лента с избраните
    catAllVisible: "Всички видими",
    catColPrice: "Цена",
    catEmpty: "Каталогът е празен",
    catNoMatchInGroup: "Няма съвпадения в „{{group}}“",
    catShowAllGroups_one: "Покажи от всички групи · {{count}} съвпадение",
    catShowAllGroups_other: "Покажи от всички групи · {{count}} съвпадения",
    catCreateNamed: "Нов продукт „{{name}}“",
    catGroups: "Групи",
    catOnlyInStock: "Само с наличност",
    catHideAdded: "Скрий добавените",
    catSelected_one: "Избран {{count}}",
    catSelected_other: "Избрани {{count}}",
    catNothingSelected: "Нищо не е отметнато — Enter или клик по реда",
    catUnpick: "Махни „{{name}}“ от избраните",
    catAddCount_one: "Добави {{count}} избран",
    catAddCount_other: "Добави {{count}} избрани",
    catShownOf: "{{shown}} от {{total}}",
    catKeyRow: "ред",
    catKeyGroup: "група",
    catKeyEscClear: "изчиства филтъра",
    catKeyEscClose: "затваря",
    catMore: "+ още {{count}}",
    // въвеждане в реда, „Мин.", сумата, чиповете „Под минимума" / „От този доставчик", презаписът
    catColMin: "Мин.",
    catColSum: "Сума",
    catFieldPrice: "Ед. цена нето",
    catFieldPriceHint: "В отметнат ред — ед. цена нето за базова единица, попълнена с последната доставна; в останалите — последната доставна цена",
    catSelectedSum: "сума",
    catBelowMinimum: "Под минимума",
    catBelowMinimumHint: "Продуктите с наличност под минималното количество — за поръчка",
    catFromSupplier: "От този доставчик",
    catFromSupplierHint: "Продуктите с доставна цена от „{{name}}“",
    catKeyEdit: "отмята и въвежда",
    catKeyPrice: "към цената",
    catOverwriteTitle_one: "Да се презапише ли {{count}} ред в листа?",
    catOverwriteTitle_other: "Да се презапишат ли {{count}} реда в листа?",
    catOverwriteText: "Вече попълнените в листа редове получават въведеното тук; останалите избрани се добавят както са.",
    catOverwriteCaption: "В листа → ново",
    catOverwriteConfirm: "Презапиши и добави",
    catOverwriteBack: "Назад",
    ichGroupTitle: "Кои продукти се заместват взаимно",
    ichGroupLead: "Въведете количествата, които са равностойни. Когато някой продукт липсва при разнасяне на отчет или при инвентаризация, системата предлага да се изпише друг от групата в същото съотношение.",
    ichOrderLabel: "Кой се изписва пръв",
    ichOrderOldest: "Най-старата доставка",
    ichOrderManual: "По реда тук",
    ichOrderOldestHelp: "От заместителите първо се изписва този с най-старата доставка — изчерпва се по-старата наличност.",
    ichOrderManualHelp: "Първо се изписва №1, после №2… — подредете със стрелките, Alt+↑/↓ или с плъзгане на номера.",
    ichSlotLabel: "Продукт {{index}}",
    ichSlotFirstHint: "напишете името му или изберете от целия списък",
    ichSlotSecondHint: "…и продукт, който може да го замести",
    ichSlotMoreLabel: "Още продукт",
    ichSlotMoreHint: "по желание — всички в групата се заместват взаимно",
    ichKeysAmounts: "между количествата",
    ichKeysMove: "мести продукта",
    ichDragHandle: "Плъзнете, за да смените реда",
    ichPriorityAria: "Приоритет {{index}}",
    ichPriorityNone: "Без приоритет — по най-стара доставка",
    ichAmountAria: "Количество от {{name}}",
    ichMoveUp: "Премести нагоре",
    ichMoveDown: "Премести надолу",
    ichRemove: "Махни {{name}} от групата",
    ichUnitFallback: "ед.",
    ichReady: "Готово за запис",
    ichMissingAmount: "Въведете количество за: {{names}}",
    ichExampleLabel: "Пример",
    ichExampleA: "Кафе A",
    ichExampleB: "Кафе B",
    ichExampleUnit: "кг",
    ichExampleScenario: "Ако липсват 10 {{unit}} {{a}}, системата предлага да се изпишат 7 {{unit}} {{b}} — и обратно: при липса на {{b}} се предлага {{a}}.",
    ichPreviewTitle: "Как ще работи",
    ichPreviewPick: "Ако липсва",
    ichPreviewShortage: "Липсват",
    ichPreviewOffer: "системата предлага да се изпише:",
    ichPreviewOr: "или",
    ichPreviewNeedAmount: "(въведете количество)",
    ichPreviewOldestNote: "първо от този с най-старата доставка",
    ichPreviewNextNote: "Следващият се ползва, ако предишният не стига.",
    ichPreviewNeedRecipient: "Въведете количество за {{name}}, за да видите примера.",
    ichPreviewWhere: "Прилага се при разнасяне на отчет и при инвентаризация. Замяната се предлага — потвърждавате я вие.",
    ichPriorityOldest: "Първо се изписва този с най-старата доставка",
    ichPriorityOrder: "Първо се изписва: {{names}}",
    ichPriorityRest: "останалите — по най-стара доставка",
    ichEmptyTitle: "Още няма правила за заместване",
    ichEmptyText: "Правилото казва кои продукти могат да се заместват взаимно и в какво количество. Когато някой липсва при разнасяне на отчет или при инвентаризация, системата предлага да се изпише друг от същото правило.",
    ichNoMatch: "Няма правило с „{{query}}“",
    ichClearSearch: "Изчисти търсенето",
    ichListKeys: "избор и отваряне на правило",
    // Подсказките на „Причина" в листа „Изписване" (writeoff/components/WriteoffReasonField)
    wrPreviousReasons: "Предишни причини",
    wrReasonUsed_one: "Ползвана {{count}} път",
    wrReasonUsed_other: "Ползвана {{count}} пъти",
    wrKeyPick: "избира",
    // История на промените на документ (components/revisions/)
    revTitle: "История на промените",
    revNone: "Без промени след създаването",
    revEdits_one: "{{count}} редакция",
    revEdits_other: "{{count}} редакции",
    revLast: "последна {{when}} · {{name}}",
    revChanges_one: "{{count}} промяна",
    revChanges_other: "{{count}} промени",
    revNoValueChanges: "записан без промени в стойностите",
    revCreated_delivery: "създадена",
    revCreated_writeoff: "създадено",
    revCreated_stocktake: "създадена",
    revCreated_transfer: "създадено",
    revAdded: "добавен",
    revRemoved: "премахнат",
    revLinkedNotes: "Обобщени стокови",
    revTotalNet: "Общо нето",
    revTotalGross: "Общо бруто",
    revSubstitution: "Замяна",
    revAutoPrice: "автоматична",
    revUnknownUser: "неизвестен потребител",
    revLoadError: "Историята на промените не може да се зареди",
    revShowHistory: "Покажи историята на промените",
    revHideHistory: "Скрий историята на промените",
    // Потвърждения (components/confirm): въпрос с обекта, какво ще стане, преглед, конкретен глагол
    cfmMore: "+ още {{count}}",
    cfmFinal: "Действието не може да се отмени.",
    cfmPortions_one: "{{value}} порция",
    cfmPortions_other: "{{value}} порции",
    cfmLeaveTitle: "Излизане от {{document}} без запис?",
    cfmLeaveDraftTitle: "Излизане от {{document}}?",
    cfmLeaveText: "Незаписаните промени се губят — в склада нищо не се променя.",
    cfmLeaveDraftText: "Преброеното остава като чернова в този браузър и при следващо отваряне ще ви предложим да продължите. В склада още нищо не е записано.",
    cfmLeavePostingText: "Избраните замени за Отчет №{{number}} се губят. Отчетът остава неразнесен в списъка — нищо не се изписва.",
    cfmLeaveCaption: "Незаписани редове",
    cfmLeaveSheetCaption: "Редове в листа",
    cfmLeaveDraftCaption: "Остават в черновата",
    cfmLeaveFinal: "Изгубените промени не могат да се върнат.",
    cfmLeaveConfirm: "Излез без запис",
    cfmLeaveDraftConfirm: "Излез, черновата остава",
    cfmLeaveStay: "Остани",
    cfmDocNewWriteoff: "новото изписване",
    cfmDocNewScrap: "новото бракуване",
    cfmDocEditWriteoff: "редакцията на изписване №{{number}}",
    cfmDocEditScrap: "редакцията на бракуване №{{number}}",
    cfmDocNewTransfer: "новото прехвърляне",
    cfmDocEditTransfer: "редакцията на прехвърляне №{{number}}",
    cfmDocNewStocktake: "новата инвентаризация",
    cfmDocEditStocktake: "редакцията на инвентаризация №{{number}}",
    cfmDocEditDelivery: "редакцията на доставка №{{number}}",
    cfmDocPosting: "разнасянето на Отчет №{{number}}",
    cfmRemoveRowTitle: "Премахване на „{{name}}“ от листа?",
    cfmRemoveRowTitlePlain: "Премахване на реда от листа?",
    cfmRemoveRowText: "Редът с {{qty}} се маха от листа. В склада нищо не се променя, докато не запишете.",
    cfmRemoveRowTextEmpty: "Редът се маха от листа. В склада нищо не се променя, докато не запишете.",
    cfmRemoveRowUndo: "Можете да го добавите пак от търсачката.",
    cfmRemoveRowConfirm: "Премахни реда",
    cfmSplitRecipeTitle: "Разделяне на рецептата „{{name}}“?",
    cfmSplitRecipeText_one: "Редът се заменя с {{count}} продуктов ред — съставката на рецептата за {{portions}}, с количество и партида, които можете да променяте.",
    cfmSplitRecipeText_other: "Редът се заменя с {{count}} продуктови реда — съставките на рецептата за {{portions}}, всяка с количество и партида, които можете да променяте поотделно.",
    cfmSplitRecipeCaption: "Ще се появят",
    cfmSplitRecipeDefaultPortions: "Порциите не са попълнени — количествата са за 1 порция.",
    cfmSplitRecipeUndo: "Можете да ги съберете обратно с „{{action}}“.",
    cfmSplitRecipeConfirm_one: "Раздели на {{count}} ред",
    cfmSplitRecipeConfirm_other: "Раздели на {{count}} реда",
    cfmRevertTitle: "Връщане в рецептата „{{name}}“?",
    cfmRevertText_one: "{{count}} продуктов ред се събира обратно в един ред „{{name}}“ за {{portions}} — промените по количеството и партидата му се губят.",
    cfmRevertText_other: "{{count}} продуктови реда се събират обратно в един ред „{{name}}“ за {{portions}} — промените по количествата и партидите им се губят.",
    cfmRevertCaption: "Ще се съберат",
    cfmRevertUndo: "Можете да я разделите пак с „{{action}}“.",
    cfmRevertConfirm: "Събери в рецептата",
    cfmDeleteDraftTitle: "Изтриване на незавършената доставка?",
    cfmDeleteDraftTitleSupplier: "Изтриване на незавършената доставка от „{{supplier}}“?",
    cfmDeleteDraftText: "Черновата и всичките ѝ редове се изтриват. Нищо не е заприходено, затова складът не се променя.",
    cfmDeleteDraftCaption: "Изтриват се",
    cfmDraftDeliveryTitle: "Да продължите ли незавършената доставка?",
    cfmDraftDeliveryTitleBy: "Да продължите ли незавършената доставка на {{name}}?",
    cfmDraftStocktakeTitle: "Да продължите ли незавършената инвентаризация?",
    cfmDraftStocktakeTitleBy: "Да продължите ли незавършената инвентаризация на {{name}}?",
    cfmDraftSavedAt: "Черновата е запазена автоматично на {{when}}. Продължете от нея или започнете на чисто.",
    cfmDraftCaption: "В черновата",
    cfmDraftContinue: "Продължи черновата",
    cfmDraftContinueHint: "Редовете ѝ се зареждат в листа и продължавате оттам.",
    cfmDraftStocktakeContinueHint: "Преброеното се зарежда в листа и продължавате да броите оттам.",
    cfmDraftDiscard: "Изтрий и започни наново",
    cfmDraftDiscardHint: "Черновата се изтрива безвъзвратно, листът започва празен.",
    cfmDraftAskDeliveryTitle: "Да продължите ли доставката от „{{supplier}}“?",
    cfmDraftAskDeliveryTitlePlain: "Да продължите ли незавършената доставка?",
    cfmDraftAskDeliveryText: "Всеки потребител има само една незавършена доставка — за да започнете нова, тази трябва да се запише или изтрие.",
    cfmDraftAskStocktakeTitle: "Да продължите ли инвентаризацията на „{{warehouse}}“?",
    cfmDraftAskStocktakeTitlePlain: "Да продължите ли незавършената инвентаризация?",
    cfmDraftAskStocktakeText: "В този браузър вече има започната инвентаризация — за да започнете нова, тази трябва да се запише или изтрие.",
    cfmDraftAskCaption: "Незавършената",
    cfmDraftAskContinueHint: "Отваря листа с нейните редове.",
    cfmDraftAskStocktakeContinueHint: "Отваря листа с преброеното досега.",
    cfmDraftAskDiscardHint: "Черновата се изтрива безвъзвратно и се отваря празен лист.",
    cfmLockTitle: "Да поемете ли доставката на {{name}}?",
    cfmLockText: "{{name}} я редактира в момента. Ако я поемете, промените на {{first}} спират да се пазят, а {{first}} ще види, че сте поели редакцията.",
    cfmLockCaption: "Черновата",
    cfmLockConfirm: "Поеми от {{first}}",
    cfmProblemTitle_one: "{{count}} продукт с проблем — как да запишем доставката?",
    cfmProblemTitle_other: "{{count}} продукта с проблем — как да запишем доставката?",
    cfmProblemText: "Продукт с проблем не се заприходява, докато проблемът не се реши. Изберете какво да стане с останалите.",
    cfmProblemCaption: "С проблем",
    cfmProblemHoldHint: "Нищо не се заприходява — доставката остава чернова със статус „Задържана“, докато проблемът се реши.",
    cfmProblemWithoutHint_one: "{{count}} продукт се заприходява сега, проблемните остават в задържана чернова.",
    cfmProblemWithoutHint_other: "{{count}} продукта се заприходяват сега, проблемните остават в задържана чернова.",
    cfmShortageTitle_one: "Разнасяне на Отчет №{{number}} с недостиг при {{count}} продукт?",
    cfmShortageTitle_other: "Разнасяне на Отчет №{{number}} с недостиг при {{count}} продукта?",
    cfmShortageText: "Тези продукти не достигат в склада и ще се изпишат с отрицателна наличност, докато следваща доставка или инвентаризация не я изравни.",
    cfmShortageCaption: "Не достигат",
    cfmShortageUndo: "Ако се окаже грешка, разнасянето може да се анулира от „{{report}}“.",
    cfmShortageConfirm: "Разнеси с недостиг",
    cfmAnnulDeliveryTitle: "Анулиране на доставка №{{number}}?",
    cfmAnnulDeliveryTitleSupplier: "Анулиране на доставка №{{number}} от „{{supplier}}“?",
    cfmAnnulDeliveryCaption: "Излизат от склада",
    cfmAnnulDeliveryConfirm: "Анулирай доставката",
    cfmAnnulWriteoffTitle: "Анулиране на изписване №{{number}}?",
    cfmAnnulScrapTitle: "Анулиране на бракуване №{{number}}?",
    cfmAnnulWriteoffCaption: "Връщат се в склада",
    cfmAnnulWriteoffConfirm: "Анулирай изписването",
    cfmAnnulScrapConfirm: "Анулирай бракуването",
    cfmAnnulTransferTitle: "Анулиране на прехвърляне №{{number}}?",
    cfmAnnulTransferCaption: "Връщат се в „{{warehouse}}“",
    cfmAnnulTransferConfirm: "Анулирай прехвърлянето",
    cfmAnnulStocktakeTitle: "Анулиране на инвентаризация №{{number}}?",
    cfmAnnulStocktakeCaption: "Отменят се разликите",
    cfmAnnulStocktakeConfirm: "Анулирай инвентаризацията",
    cfmAnnulUndo: "Документът може да се възстанови от справката „{{report}}“.",
    cfmRestoreTitle: "Възстановяване на {{document}}?",
    cfmRestoreDoc_delivery: "доставка №{{number}}",
    cfmRestoreDoc_writeoff: "изписване №{{number}}",
    cfmRestoreDoc_scrap: "бракуване №{{number}}",
    cfmRestoreDoc_stocktake: "инвентаризация №{{number}}",
    cfmRestoreDoc_transfer: "прехвърляне №{{number}}",
    cfmRestoreDoc_substitution: "замяна №{{number}}",
    cfmRestoreDoc_report: "разнасяне №{{number}}",
    cfmRestoreDocOther: "запис №{{number}}",
    cfmRestoreCaption: "Прилагат се отново",
    cfmRestoreUndo: "Документът може да се анулира пак от прегледа му.",
    cfmRestoreVerb_delivery: "Възстанови доставката",
    cfmRestoreVerb_writeoff: "Възстанови изписването",
    cfmRestoreVerb_scrap: "Възстанови бракуването",
    cfmRestoreVerb_stocktake: "Възстанови инвентаризацията",
    cfmRestoreVerb_transfer: "Възстанови прехвърлянето",
    cfmRestoreVerb_substitution: "Възстанови замяната",
    cfmRestoreVerb_report: "Възстанови разнасянето",
    cfmRestoreVerbOther: "Възстанови записа",
    // Филтри в заглавията на колоните на справките (components/filters/ColumnHeader, ColumnFilterPanel, FilterSummaryLine)
    cfFilters: "Филтри",
    cfSelectAll: "Всички",
    cfOnly: "Само това",
    cfFrom: "от",
    cfTo: "до",
    cfFilterAria: "Филтър по „{{column}}“",
    cfRemove: "Махни филтъра „{{filter}}“",
    cfKeyToggle: "отмята",
    cfKeyOnly: "само това",
    cfKind: "Вид",
    cfKindReason: "Вид и причина",
    cfNoMatch: "Нищо не отговаря на търсенето и филтрите",
    cfClearFilters: "Изчисти филтрите",
    cfWithSurplus: "С излишък",
    cfNoSurplus: "Без излишък",
    cfWithShortage: "С липси",
    cfNoShortage: "Без липси",
    scTitle: "Складова карта",
    scCardAria: "Складова карта на {{name}}",
    scClose: "Затвори картата",
    scInStock: "Налично",
    scInStockAsOf: "Налично към {{date}}",
    scTabMovements: "Движения",
    scTabLots: "Партиди",
    scTabSubstitutions: "Замени",
    scOpening: "Начално салдо",
    scClosing: "Крайно салдо",
    scColIn: "Приход",
    scColOut: "Разход",
    scColPrice: "Цена",
    scColUser: "Въвел",
    scColNote: "Бележка",
    scTypeAll: "Всички",
    scTypeFilterAria: "Вид движение",
    scDoc_delivery: "Доставка",
    scDoc_report: "Отчет",
    scDoc_writeoff: "Изписване",
    scDoc_scrap: "Бракуване",
    scDoc_stocktake: "Инвентаризация",
    scDoc_transfer: "Прехвърляне",
    scDoc_substitution: "Замяна",
    scDocNumber: "{{label}} №{{number}}",
    scCoveredBy: "⇄ покрито от {{name}}",
    scBatchNote: "партида {{batch}}",
    scExpiryNote: "до {{date}}",
    scEmptyPeriod: "Няма движения в периода.",
    scEmptyFiltered: "Няма движения от този вид в периода.",
    scExcel: "Excel",
    scInconsistent: "Сборът на движенията не съвпада с крайното салдо — проверете историята на продукта.",
    scNegativeHint: "Под нулата — изписано е повече, отколкото е имало",
    scSoldWithoutStock: "⚠ {{qty}} продадени без наличност",
    scWrittenOffWithoutStock: "⚠ {{qty}} изписани без наличност",
    scCoveredNegative: "({{qty}} покриват продаденото без наличност)",
    scColReceived: "Приета",
    scColRemaining: "Остатък",
    scLotsHint: "Отворените партиди към момента — по реда, в който ще се изписват (най-старата първа).",
    scLotsEmpty: "Няма отворени партиди.",
    scColSubstitution: "Замяна",
    scSubsEmpty: "Няма замени в периода.",
    scSubsCovered: "покрити {{qty}}",
    scSubsTaken: "изписани {{qty}}",
    scSubsCountReplaced_one: "заместил друг продукт 1 път",
    scSubsCountReplaced_other: "заместил друг продукт {{count}} пъти",
    scSubsCountReplacedBy_one: "заместен 1 път",
    scSubsCountReplacedBy_other: "заместен {{count}} пъти",
    scBadgeReplaced: "⇄ заместил {{name}}",
    scBadgeReplacedBy: "⇄ заместен с {{name}}",
    scBadgeTipTitle: "Замени за {{period}}",
    scBadgeTipReplaced_one: "Заместил {{name}} — 1 път, {{qty}}",
    scBadgeTipReplaced_other: "Заместил {{name}} — {{count}} пъти, {{qty}}",
    scBadgeTipReplacedBy_one: "Заместен с {{name}} — 1 път, {{qty}}",
    scBadgeTipReplacedBy_other: "Заместен с {{name}} — {{count}} пъти, {{qty}}",
    scMasterListAria: "Продукти в склада",
    scKeysSwitch: "продукт",
    scKeysClose: "затваря",
    ichDocNewRule: "новото правило",
    ichDocEditRule: "правилото „{{name}}“",
    ichDeleteTitle: "Изтриване на правилото „{{name}}“?",
    ichDeleteText: "Продуктите в него вече няма да се предлагат като взаимозаменяеми при разнасяне на отчет и при инвентаризация. Наличностите и вече записаните документи не се променят.",
    ichDeleteCaption: "Продукти в правилото",
    ichDeleteFinal: "Изтриването не може да се отмени — правилото се създава наново.",
    ichDeleteConfirm: "Изтрий правилото",
    cfmPostingAnnulTitle: "Анулиране на разнасянето на Отчет №{{report}}?",
    cfmPostingRepostTitle: "Корекция на разнасянето на Отчет №{{report}}?",
    cfmPostingAnnulNote: "Анулираното разнасяне остава в тази справка зачертано, с причината; отчетът може да се разнесе отново.",
    cfmPostingAnnulConfirm: "Анулирай разнасянето",
    cfmPostingRepostConfirm: "Анулирай и разнеси повторно",
    upPriceFromSum: "Изчислена от въведената сума на реда — сумата се записва точно",
    // Общата лента на справките и изборът на период (кръг 4)
    tbPeriodPickRange: "изберете първия и последния ден",
    tbPeriodPickEnd: "изберете последния ден",
    tbToolbarAria: "Лента на справката",
    tbColAnnulReason: "Причина за анулиране",
    tbColAgeDays: "Дни от доставката",
    tbColReports: "Отчети",
    tbColOldestReport: "Най-стар отчет",
    stkStatusAll: "Всички",
    stkStatusCounted: "Преброени",
    stkStatusUncounted: "Непреброени",
    stkStatusDiff: "С разлика",
    stkAllGroups: "Всички групи",
    stkGroupsAria: "Групи продукти",
    stkBandProgress: "{{counted}} от {{total}}",
    stkBandPinned_one: "{{count}} избран за броене",
    stkBandPinned_other: "{{count}} избрани за броене",
    stkBandRestHint: "не се променят; напишете 0, ако продуктът липсва",
    stkEmptyCounted: "Още няма преброени продукти.",
    stkEmptyUncounted: "Всички продукти са преброени.",
    stkEmptyDiff: "Няма разлики — преброеното съвпада с търсеното.",
    stkTotalsSurplus: "Излишъци",
    stkTotalsShortage: "Липси",
    stkTotalsNetCaption: "Нетно",
    stkIssuePrice: "Въведете ед. цена за: {{products}}",
    stkIssueMore_one: "и още {{count}}",
    stkIssueMore_other: "и още {{count}}",
    stkPricePh: "цена *",
    stkPriceRequiredHint: "Няма доставна цена в този склад — въведете ед. цената на излишъка, иначе ще влезе на 0.",
    sdGroupRecipe: "По рецепта",
    sdGroupRecipeTip: "Текущите рецепти × продаденото от сметките, затворени в периода, по текущата средна себестойност.",
    sdGroupPosted: "Разнесено",
    sdGroupPostedTip: "Изписаното от склада при разнасянето на отчетите с дата в периода, по FIFO себестойност — заедно с изписаното вместо друг продукт (замяна).",
    sdGroupDiff: "Разлика",
    sdGroupDiffTip: "Разнесено − по рецепта. „+“ — изписано е повече, отколкото казват рецептите; „−“ — по-малко.",
    sdColQty: "К-во",
    sdDatesHint: "По рецепта — по датата на затваряне на сметките; Разнесено — по датата на отчета.",
    sdDatesHintTip: "Двете се разминават, когато рецептата е сменена след разнасянето, цената е друга (текуща средна срещу FIFO), продукт е заменен с друг, количество е коригирано ръчно при разнасянето или отчетът е с дата извън периода (например пуснат след полунощ).",
    sdDonorLine: "{{qty}} изписани вместо друг продукт",
    sdCoveredLine: "{{qty}} покрити от друг продукт",
    sdKeysSwitch: "ред",
    sdPostedByWarehouse: "Разнесено по складове: {{list}}",
    sdCardPeriodNote: "Картата е за периода на справката ({{period}}) и тръгва от разнасянията — чипът „Всички“ показва всички движения.",
    sdRecipeKicker: "Продадена рецепта",
    sdRecipePanelAria: "Продадена рецепта {{name}}",
    sdClosePanel: "Затвори панела",
    sdSoldLabel: "Продадено",
    sdTabDays: "По дни",
    sdTabReports: "Отчети",
    sdTabIngredients: "Съставки",
    sdDaysHint: "Продажбите по деня на затваряне на сметката — само дните с продажби.",
    sdDaysHoursHint: "По часове — в Справки → „Продажби по периоди“ (филтър „Артикули“).",
    sdReportsHint: "Сметките от периода по разнесения отчет, в който са влезли. Клик или Enter отваря разнасянето.",
    sdReportsEmpty: "Няма разнесени отчети с тази рецепта за периода.",
    sdIngredientsNote: "По ТЕКУЩАТА рецепта × {{sold}} продадени — теоретичен разход, не изписаното от склада. Изписаното е в „Продадени продукти“ → „Разнесено“.",
    sdIngredientsEmpty: "Рецептата няма съставки.",
    sdColPerPortion: "На порция",
    sdColTotalQty: "Общо",
    sdPerPortionLine: "{{qty}} на порция",
    sdIngredientsTotal: "Себестойност по рецепта",
    sdXlsDonor: "Разнесено · в т.ч. вместо друг продукт",
    sdXlsCovered: "Покрито от друг продукт",
    stqStatusPinned: "За броене",
    stqBandPinnedHint: "(избрани от списъка)",
    stqBandRestHint: "остават както са; напишете 0, ако липсва",
    stqEmptyPinned: "Няма продукти за броене — изберете ги от „Целият списък“.",
    stqBatchLink: "+ партида / срок",
    stqTotalsWithVat: "(с ДДС {{value}})",
    // „Занули склада" на листа на нова инвентаризация (useStocktakeZeroing)
    stqZeroButton: "Занули склада",
    stqZeroNeedsWarehouse: "Първо изберете склад",
    stqZeroNothing: "Няма продукти с наличност в склада „{{warehouse}}“ към {{date}}.",
    stqZeroTitle: "Да занулим ли склада „{{warehouse}}“ към {{date}}?",
    stqZeroText_one: "{{count}} продукт получава „Намерено“ 0.",
    stqZeroText_other: "{{count}} продукта получават „Намерено“ 0.",
    stqZeroTextNegative_one: "{{count}} от тях е на минус и също става 0.",
    stqZeroTextNegative_other: "{{count}} от тях са на минус и също стават 0.",
    stqZeroTextCounted_one: "Вече преброеният {{count}} продукт остава както е.",
    stqZeroTextCounted_other: "Вече преброените {{count}} продукта остават както са.",
    stqZeroTextWhole: "Важи за целия склад — филтрите над таблицата не го ограничават.",
    stqZeroCaption: "Наличност към {{date}}",
    stqZeroNegativeTag: "на минус",
    stqZeroAll: "Занули всички ({{count}})",
    stqZeroAllHint: "Всички стават 0. Липса за около {{value}} (по средната цена; точната се смята при записа).",
    stqZeroAllHintNoPrice: "Всички стават 0. Стойността на липсата се смята при записа.",
    stqZeroNegative: "Само минусите ({{count}})",
    stqZeroNegativeHint: "Само продуктите на минус стават 0, без стойност. Останалите чакат да ги преброите.",
    stqZeroNegativeNone: "Няма продукти на минус.",
    stqZeroNoteDraft: "Нищо не се записва, докато не потвърдите инвентаризацията — можете да поправите отделни редове.",
    stqZeroNoteUndo: "Записаната инвентаризация се анулира от Справки → Инвентаризации и наличностите се връщат.",
    stqZeroReason: "Зануляване на склада",
    stqZeroApplied_one: "„Намерено“ 0 за {{count}} продукт — прегледайте и потвърдете инвентаризацията.",
    stqZeroApplied_other: "„Намерено“ 0 за {{count}} продукта — прегледайте и потвърдете инвентаризацията.",
    dashNav: "Табло",
    dashTitle: "Склад",
    dashGroupShow: "Разгъни „{{name}}“",
    dashGroupHide: "Свий „{{name}}“",
    dashGridAria: "Операциите на склада",
    dashLoadFailed: "Не се зареди",
    dashOpenAria: "Отвори „{{name}}“",
    dashAttention: "иска внимание",
    dashLocalOff: "Локален режим — таблото не показва състоянието на склада, докато няма връзка с облака.",
    dashKeysOpen: "отваря операцията",
    dashKeysMove: "между кутиите",
    dashKeysEnter: "отваря избраната",
    dashBoxPosting: "Разнасяне",
    dashBoxDelivery: "Доставка",
    dashBoxPayments: "Плащане",
    dashBoxWriteoff: "Изписване",
    dashBoxStocktake: "Инвентаризация",
    dashBoxTransfer: "Прехвърляне",
    dashBoxShortage: "Излишък",
    dashBoxInterchange: "Взаимозаменяеми",
    dashNewFem: "+ Нова",
    dashNewNeut: "+ Ново",
    dashContinue: "Продължи",
    dashPay: "Плати",
    dashPostingNone: "Всички отчети са разнесени",
    dashPendingLabel_one: "чакащ отчет",
    dashPendingLabel_other: "чакащи отчета",
    dashOverdue_one: "{{count}} закъснял",
    dashOverdue_other: "{{count}} закъснели",
    dashOldestReport: "най-старият — №{{number}} от {{date}}",
    dashPostOldest: "Разнеси най-стария",
    dashDraftsNone: "Няма незавършени доставки",
    dashDraftsLabel_one: "незавършена доставка",
    dashDraftsLabel_other: "незавършени доставки",
    dashDraftHeld_one: "{{count}} задържана",
    dashDraftHeld_other: "{{count}} задържани",
    dashDraftMine: "Вашата: {{supplier}}",
    dashDraftColleagues: "Колеги: {{names}}",
    dashAllPaid: "Всички доставки са платени",
    dashUnpaidLabel_one: "неплатена доставка",
    dashUnpaidLabel_other: "неплатени доставки",
    dashOldestWaits_one: "най-старата чака {{count}} ден",
    dashOldestWaits_other: "най-старата чака {{count}} дни",
    dashWriteoffsNone: "Днес няма изписвания",
    dashWriteoffsToday_one: "изписване днес",
    dashWriteoffsToday_other: "изписвания днес",
    dashTransfersNone: "Днес няма прехвърляния",
    dashTransfersToday_one: "прехвърляне днес",
    dashTransfersToday_other: "прехвърляния днес",
    dashAllWarehouses: "всички складове",
    dashNoWarehouses: "Няма складове",
    dashNeverCounted: "{{warehouse}} още не е броен",
    dashCountedToday_one: "Броено днес",
    dashCountedToday_other: "Всички складове са броени днес",
    dashDaysSinceCount_one: "ден от последната",
    dashDaysSinceCount_other: "дни от последната",
    dashStalestOf: "{{warehouse}} · най-отдавна от {{total}} склада",
    dashNewStocktakeFor: "Нова инвентаризация · {{warehouse}}",
    dashShortageNone: "Няма излишък от продажби",
    dashShortageLabel_one: "продукт с излишък",
    dashShortageLabel_other: "продукта с излишък",
    dashInWarehouses: "в {{total}} склада",
    dashRulesNone: "Няма правила за заместване",
    dashRulesLabel_one: "правило за заместване",
    dashRulesLabel_other: "правила за заместване",
    dashRulesHint: "при разнасяне и инвентаризация",
    dashCritical: "спешно",
    dashBannerLabel: "Спешно — чака действие",
    dashStkUnfinished_one: "незавършена инвентаризация",
    dashStkUnfinished_other: "незавършени инвентаризации",
    dashStkMore: "+ още {{count}}",
    dashTakeOver: "Поеми",
    dashAlertOpen: "Отвори",
    dashPayOverdue_one: "{{count}} над 14 дни",
    dashPayOverdue_other: "{{count}} над 14 дни",
    dashAlertStocktake: "Незавършена инвентаризация: {{line}}",
    dashAlertOverdue_one: "{{count}} отчет чака над 2 дни — най-старият №{{number}} от {{date}}",
    dashAlertOverdue_other: "{{count}} отчета чакат над 2 дни — най-старият №{{number}} от {{date}}",
    dashAlertHeld_one: "{{count}} задържана доставка — проблем със стоката",
    dashAlertHeld_other: "{{count}} задържани доставки — проблем със стоката",
    dashAlertOverduePay_one: "{{count}} доставка е неплатена над 14 дни",
    dashAlertOverduePay_other: "{{count}} доставки са неплатени над 14 дни",
    // Фактура над стокови: редовете на стоковите в листа и в документа
    notesRowsBand: "Стокова {{number}} · {{date}} · вътр. №{{id}}",
    notesRowsHint: "вече е заприходена — фактурата само я обобщава",
    notesRowsCount_one: "{{count}} продукт от стоковата",
    notesRowsCount_other: "{{count}} продукта от стоковите",
    docNoteSection: "От стокова разписка {{number}} · {{date}} · вътр. №{{id}}",
    docNotesLoading: "Зареждане на редовете на стоковите…",
    // Нова доставка без доставчик
    issueSupplier: "Изберете доставчик",
    saveDateFuture: "Доставка не може да е с бъдеща дата — изберете днес или по-ранен ден",
    saveNegTitle: "Продадено без наличност",
    saveNegHead: "{{name}}: {{qty}} продадени без наличност на {{days}}.",
    saveNegWrittenOff: "С дата {{date}} те се отписват и влизат всичките {{incoming}}.",
    saveNegCovered: "С дата {{date}} доставката ще покрие {{covered}} и ще влязат {{rest}}.",
    saveNegMixed: "С дата {{date}} {{writtenOff}} се отписват, доставката ще покрие {{covered}} и ще влязат {{rest}}.",
    saveNegMoveDate: "Ако стоката е дошла на {{day}} — сложи тази дата, тогава ще покрие продаденото.",
    postingZeroHint: "Нищо не се изписва от склада. Разнесете го, за да излезе от чакащите — в „Разнесени отчети“ остава с 0.00.",
    sdDaysEmpty: "Няма продажби на рецептата в периода",
    // „Коригирай общото" в доставката
    tadjNetLabel: "Общо нето — напишете сумата от документа; разликата отива в реда с най-голяма сума",
    tadjGrossLabel: "Общо бруто — напишете сумата от документа; разликата отива в реда с най-голяма сума",
    tadjNoRows: "Няма ред с количество и сума, който да поеме разликата",
    tadjTooLarge: "Разликата {{delta}} е по-голяма от реда „{{product}}“ — проверете редовете",
    tadjApplied: "{{delta}} от общото отидоха в „{{product}}“",
    tadjConfirmTitle: "Разлика {{delta}} спрямо редовете?",
    tadjConfirmText: "Това е повече от закръгляне. Сумата на „{{product}}“ става {{value}}, а цената му се изчислява от нея.",
    tadjConfirmUndo: "Поправя се, като въведете сумата на реда ръчно",
    tadjConfirmOk: "Сложи я в „{{product}}“",
    tadjRowNote: "{{delta}} от корекцията на общото",
    // Изписване: стойността на рецептата и недостигът по съставки (wr6)
    wr6IssueShort: "Недостатъчна наличност: {{items}}",
    wr6ShortItem: "{{name}} — нужни {{needed}}, налични {{available}}",
    wr6ShortItemFrom: "{{name}} — нужни {{needed}}, налични {{available}} (за {{recipes}})",
    wr6ShortMore_one: "и още {{count}}",
    wr6ShortMore_other: "и още {{count}}",
    wr6Needed: "нужни",
    wr6Available: "налични",
    wr6OwnShare: "тук {{value}}",
    wr6NeededTotal: "нужни общо {{value}}",
    wr6FitsLabel: "Стига за",
    wr6BandTitle: "Не стига за {{portions}}:",
    wr6FitAction: "Намали на {{portions}}",
    wr6DialogTitle: "Не стига наличност за „{{name}}“",
    wr6DialogText_one: "За {{portions}} не стига {{count}} съставка — наличността е към {{date}} в склад „{{warehouse}}“.",
    wr6DialogText_other: "За {{portions}} не стигат {{count}} съставки — наличността е към {{date}} в склад „{{warehouse}}“.",
    wr6DialogCaption: "Не стигат",
    wr6DialogFitHint: "Толкова стигат наличните съставки при останалите редове. После запишете отново.",
    wr6DialogSplitHint_one: "Рецептата става {{count}} продуктов ред — поправете количеството му или го махнете.",
    wr6DialogSplitHint_other: "Рецептата става {{count}} продуктови реда — поправете количествата на липсващите или ги махнете.",
    wr6DialogNoFit: "Съставките не стигат и за 1 порция при останалите редове.",
    // Приготвени рецепти при инвентаризация (sr6)
    sr6SectionTitle: "Приготвени рецепти",
    sr6SectionHint: "съставките им се прибавят към преброеното",
    sr6PortionsUnit: "порц.",
    sr6PerPortion: "за 1 порция:",
    sr6ContentsLoading: "Зареждане на съставките…",
    sr6ContentsError: "Съставките не се заредиха",
    sr6ContentsEmpty: "Няма складови съставки — махнете рецептата",
    sr6RemoveRecipe: "Премахни „{{name}}“",
    sr6RemoveCaption: "Излизат от преброеното",
    sr6InRecipesChip: "+{{qty}} в рецепти",
    sr6InRecipesTitle: "В приготвени рецепти",
    sr6InRecipesPart: "{{recipe}} × {{portions}} — {{qty}}",
    sr6InRecipesTotal: "общо намерено {{total}}",
    sr6CountLooseHint: "преброй и извън рецептата (или 0)",
    sr6IssueCountLoose: "Преброй и извън рецептата (или 0): {{products}}",
    sr6IssuePortions: "Въведете порции за: {{recipes}}",
    sr6IssueEmptyRecipe: "Рецептата „{{name}}“ няма складови съставки — махнете я",
    sr6BandPinnedRecipes: "(съставки на приготвените рецепти)",
    sr6BandPinnedBoth: "(избрани от списъка и съставки на рецептите)",
    sr6SearchPh: "Търси продукт или рецепта за преброяване…",
    sr6SearchAdded: "добавена",
    sr6CatalogHint: "Отметнете продуктите, които ще броите сега — застават най-отгоре в таблицата, в реда на избора. Кликнете ред, за да въведете „Намерено“ направо тук — Enter минава на следващия. Групата „Рецепти“ са приготвени ястия — отиват в „Приготвени рецепти“ и съставките им се прибавят към преброеното.",
    sr6DocRecipes: "Приготвени рецепти",
    sr6DocInRecipes: "от тях {{qty}} в рецепти",
    // Черновите на изписване, прехвърляне и инвентаризация (кръг 6)
    dr6ContinueDraftNeut: "Продължи незавършеното",
    dr6DiscardAndNewNeut: "Изтрий и започни ново",
    dr6AskCaptionNeut: "Незавършеното",
    dr6AskContinueHintNeut: "Отваря листа с неговите редове.",
    dr6LockTextNeut: "{{name}} го редактира в момента. Ако го поемете, промените на {{first}} спират да се пазят, а {{first}} ще види, че сте поели редакцията.",
    dr6TakeOverFailed: "Черновата не можа да бъде поета — опитайте пак",
    dr6DeleteDraftText: "Черновата и всичките ѝ редове се изтриват. В склада още нищо не е записано, затова наличностите не се променят.",
    dr6NoWarehouse: "Без склад",
    dr6WoDraftTitle: "Незавършено изписване",
    dr6WoDraftHint: "Пази се автоматично и на сървъра — виждат го колегите и друго устройство. Всеки има по едно незавършено изписване.",
    dr6WoContinue: "Продължи изписването",
    dr6WoHasDraft: "Имате незавършено изписване",
    dr6WoAskTitle: "Да продължите ли незавършеното изписване?",
    dr6WoAskText: "Всеки потребител има само едно незавършено изписване — за да започнете ново, това трябва да се запише или изтрие.",
    dr6WoLockTitle: "Да поемете ли изписването на {{name}}?",
    dr6WoTakeOverToast: "Поехте изписването на {{name}}",
    dr6WoDeleteTitle: "Изтриване на незавършеното изписване?",
    dr6WoPromptTitleBy: "Да продължите ли незавършеното изписване на {{name}}?",
    dr6TrxDraftTitle: "Незавършено прехвърляне",
    dr6TrxDraftHint: "Пази се автоматично и на сървъра — виждат го колегите и друго устройство. Всеки има по едно незавършено прехвърляне.",
    dr6TrxContinue: "Продължи прехвърлянето",
    dr6TrxHasDraft: "Имате незавършено прехвърляне",
    dr6TrxAskTitle: "Да продължите ли незавършеното прехвърляне?",
    dr6TrxAskText: "Всеки потребител има само едно незавършено прехвърляне — за да започнете ново, това трябва да се запише или изтрие.",
    dr6TrxLockTitle: "Да поемете ли прехвърлянето на {{name}}?",
    dr6TrxTakeOverToast: "Поехте прехвърлянето на {{name}}",
    dr6TrxDeleteTitle: "Изтриване на незавършеното прехвърляне?",
    dr6TrxPromptTitleBy: "Да продължите ли незавършеното прехвърляне на {{name}}?",
    dr6StkDraftHint: "Пази се автоматично и на сървъра — виждат я колегите и друго устройство, докато не запишете или изтриете инвентаризацията.",
    dr6StkAskText: "Всеки потребител има само една незавършена инвентаризация — за да започнете нова, тази трябва да се запише или изтрие.",
    dr6StkLockTitle: "Да поемете ли инвентаризацията на {{name}}?",
    dr6StkTakeOverToast: "Поехте инвентаризацията на {{name}}",
    dr6StkDeleteTitle: "Изтриване на незавършената инвентаризация?",
    dr6StkDeleteTitleLabel: "Изтриване на незавършената инвентаризация на „{{label}}“?",
    dr6DashDraftMine: "Вашата чернова: {{label}}",
    // Черновата на инвентаризацията: продукти + приготвени рецепти
    dr6StkCountedLines_one: "{{count}} преброен ред",
    dr6StkCountedLines_other: "{{count}} преброени реда",
    sd6DeletedChip: "изтрит",
    sd6DeletedHint: "Продуктът е изтрит в организацията. Историята му остава, но не се предлага за нови документи.",
  },

  // Споделената таблица на справките (src/components/dataTable) — общи низове
  // за менюто на колоната, панела с колоните, пагинацията и реда „Общо".
  dataTable: {
    hourShort: "ч",
    minuteShort: "мин",
    sortAsc: "Сортирай възходящо",
    sortDesc: "Сортирай низходящо",
    hideColumn: "Скрий колоната",
    clearColumnFilter: "Изчисти филтъра",
    columnMenuFor: "Меню на колона {{column}}",
    filterTextHint: "Съдържа…",
    filterFrom: "от",
    filterTo: "до",
    filterSearch: "Търси стойност",
    filterSelectAll: "Всички",
    filterClear: "Изчисти",
    filterNoValues: "Няма стойности",
    columns: "Колони",
    density: "Плътност",
    density_compact: "Сбита",
    density_normal: "Нормална",
    density_roomy: "Широка",
    resetLayout: "Върни подредбата по подразбиране",
    pageRange: "{{from}}–{{to}} от {{total}}",
    goToPage: "Отиди на страница {{page}}",
    perPage: "{{count}} на страница",
    prev: "Назад",
    next: "Напред",
    emptyTitle: "Няма редове",
    emptyHint: "Изчисти филтрите или разшири периода.",
    totalsLabel: "Общо · {{count}}",
    mobileControls: "Подредба",
    mobileSortSection: "Подреди по",
    mobileFilterSection: "Филтри",
    clearAllFilters: "Изчисти всички филтри",
    columnMenuHint: "Подредба, филтър, скриване на колоната",
    resizeColumn: "Оразмери колона {{column}} (двоен клик връща ширината)",
  },

  reportsPage: {
    kitchenMonitors: "Монитори",
    kmListKicker: "Редове по статуси",
    kmAvgKicker: "Средно време",
    kmTable: "Маса",
    kmStation: "Станция",
    kmQty: "Кол.",
    kmEnteredAt: "Влязла",
    kmStatusInProgress: "В процес",
    kmStatusCooked: "Сготвено",
    kmStatusIssued: "Издадено",
    kmStatusServed: "Сервирано",
    kmType: "Тип",
    kmStartedBy: "Започнал",
    kmCookedBy: "Сготвил",
    kmIssuedBy: "Издал",
    kmServedBy: "Сервирал",
    kmResultOne: "{{count}} ред",
    kmResults: "{{count}} реда",
    kmNoData: "Няма статус преходи в избрания период",
    // Sidebar
    reports: "Отчети",
    exportExcel: "Експорт в Excel",
    exportPreparing: "Подготовка на файла...",
    exportFailed: "Неуспешен експорт",
    tableReports: "Контрол",
    generalReports: "Продажби",
    reportsManagement: "Отчети",
    fiscalReports: "Фискални",
    categoriesReport: "По групи",
    collapse: "Свий",
    billsHistory: "Справка сметки",
    billsSplits: "Разделени маси",
    cancellations: "Сторно",
    invoices: "Фактури",
    personalReports: "Персонални отчети",
    establishmentReports: "Отчети на заведението",
    assortmentReport: "По артикули",
    // В режим „със склад" продаваемото е рецепта → същата справка, друго име.
    recipesReport: "По рецепти",
    discountsReport: "Отстъпки",
    // Справката „Клиенти" (клиентски отстъпки и надбавки) — sidebar и заглавие
    clientsReport: "Клиенти",
    priceChanges: "Променени цени",
    priceChangesTitle: "Променени цени",
    cardPayments: "Картови плащания",
    cardPaymentsTitle: "Картови плащания",
    cardPaymentsConsumedKicker: "С БОН",
    cardPaymentsUnresolvedKicker: "ВИСЯЩИ",
    cardPaymentsVoidedKicker: "ВЪРНАТИ",
    cardPaymentsResults: "{{count}} тегления",
    cardPaymentsResultOne: "1 теглене",
    cardPaymentsNoData: "Няма картови тегления за периода",
    cardPaymentsListKicker: "ДВИЖЕНИЯ ПО ТЕРМИНАЛА",
    cardPaymentsColTime: "Час",
    cardPaymentsColBill: "Сметка",
    cardPaymentsColAmount: "Сума",
    cardPaymentsColStatus: "Статус",
    cardPaymentsColPan: "Карта",
    cardPaymentsColAuth: "Код",
    cardPaymentsColReceipt: "Бон №",
    cardPaymentsColMount: "Терминал",
    cardPaymentsColRefund: "Върнато (сторно)",
    cardPaymentsTerminal: "Каса",
    cardPaymentsStatus_consumed: "С бон",
    cardPaymentsStatus_voided: "Върнато",
    cardPaymentsStatus_unknown: "Неясно",
    cardPaymentsStatus_void_failed: "Без бон!",
    cardPaymentsMount_pc: "терминал на касата",
    cardPaymentsMount_fiscal: "терминал на принтера",
    fiscalCardPending: "Платена с карта — не теглете повторно",
    priceChangesColKind: "Вид",
    priceChangesKindProduct: "Продукт",
    priceChangesKindAddition: "Добавка",
    priceChangesOldPrice: "Стара цена",
    priceChangesNewPrice: "Нова цена",
    priceChangesDelta: "Разлика",
    priceChangesLineEffect: "Разлика общо",
    priceChangesActive: "Активна",
    priceChangesReverted: "Върната",
    priceChangesDirection: "Вид промяна",
    priceChangesDown: "Намалена цена",
    priceChangesUp: "Увеличена цена",
    priceChangesCountKicker: "Промени в периода",
    priceChangesCountTitle: "Сменени цени",
    priceChangesDownTitle: "Общо намалена сума",
    priceChangesUpTitle: "Общо увеличена сума",
    priceChangesListKicker: "Списък променени цени",
    priceChangesResults: "{{count}} промени",
    priceChangesResultOne: "{{count}} промяна",
    priceChangesNoData: "Няма променени цени за избрания период.",
    waitersReport: "По сервитьори",
    stationsReport: "По станции",
    dashboard: "Дашборд",
    dashboardSection: "Дашборд",
    dashboardTitle: "Дашборд",
    dashboardOpenTables: "Отворени маси",
    dashboardOpenCount: "Брой маси",
    dashboardOpenAmount: "Обща сума",
    dashboardClosedToday: "Затворени сметки днес",
    dashboardClosedCount: "Брой сметки",
    dashboardCash: "В брой",
    dashboardCard: "С карта",
    dashboardMixed: "Смесени",
    dashboardBills: "сметки",
    dashboardDailyReports: "Дневни обороти (последни 7 дни)",
    dashboardNoReport: "Няма отчет",
    dashboardToday: "Днес",
    expandMenu: "Разгъни меню",
    collapseMenu: "Свий меню",
    dashboardBackToModules: "Към модулите",
    dashboardModuleLabel: "Модул Справки",
    dashboardAdminRole: "Администратор",
    dashboardRevenueByDays: "Оборот по дни",
    dashboardLast7Days: "Последните 7 дни",
    dashboardDailyRevenue: "Дневен оборот",
    dashboardAverage: "Средно",
    dashboardNoRevenue: "Няма оборот",
    dashboardOpen: "Отворени",
    dashboardClosedTodayShort: "Затворени днес",
    dashboardTotalAmountLabel: "Обща сума",
    dashboardBill: "сметка",
    dashboardBillsMany: "сметки",
    dashboardTableOne: "маса",
    dashboardTableMany: "маси",
    dashboardTablesOpenNow: "Отворени сега",
    dashboardTablesClosedToday: "Затворени днес",
    dashboardTablesOccupancy: "Дял отворени",
    dashboardTablesNone: "Няма активност днес",
    dashboardTotalShort: "Общо",
    dashboardLogout: "Изход",
    dashboardSameTimeHint: "Сравнение до същия час на деня",
    dashboardAvgCheck: "Среден бон",
    dashboardAvgTableTime: "Средно време на маса",
    dashboardVoidsToday: "Сторнирания днес",
    dashboardDiscountsToday: "Отстъпки днес",
    dashboardMinShort: "мин",
    dashboardHourShort: "ч",
    dashboardPcs: "бр.",
    dashboardTopKicker: "Топ 5 днес",
    dashboardTopSubtitle: "Най-продавани по оборот",
    dashboardTopEmpty: "Няма продажби днес",
    dashboardHeatKicker: "Натовареност",
    dashboardHeatSubtitle: "Закрити сметки по час — последните 8 дни",
    dashboardHeatEmpty: "Няма данни за периода",
    dashboardVsDay: "спрямо {{day}} {{date}}",
    dashboardVoidsHint:
      "Обща стойност на сторнираните продукти днес (по момент на сторниране)",
    dashboardDiscountsHint:
      "Обща стойност на всички отстъпки — на цяла сметка и на отделни артикули — от закритите днес сметки",
    dashboardBillWithDiscount: "в 1 сметка",
    dashboardBillsWithDiscount: "в {{count}} сметки",
    dashboardStationsKicker: "Оборот по обекти",
    dashboardStationsSubtitle: "Разпределение за днес",

    // Common
    refresh: "Обнови",
    filters: "Филтри",
    clear: "Изчисти",
    apply: "Приложи",
    fromDate: "От дата",
    toDate: "До дата",
    totalRecords: "Общо {{count}} записа",
    totalReports: "Общо {{count}} отчета",
    totalLabel: "Общо:",
    totalAmount: "Обща сума",
    view: "Виж",
    noData: "Няма данни",
    waiter: "Сервитьор",
    date: "Дата",
    reportDate: "Дата на отчета",
    createdAt: "Дата на създаване",
    amount: "Сума",
    fiscalAmount: "Сума ФП",
    productName: "Продукт",
    category: "Категория",
    station: "Станция",
    quantity: "Количество",
    averagePrice: "Средна цена",
    totalProducts: "Общо продукти",
    totalQuantity: "Общо количество",
    dateRange: "Период",
    total: "Общо",

    // BillsHistory
    billsHistoryTitle: "Справка сметки",
    tables: "Маси",
    table: "Маса",
    status: "Статус",
    statusOpen: "Отворени",
    // Единствено число — статусът на ЕДНА сметка (точката в реда, картата
    // на телефон). Множественото се ползва за филтъра, където се избират групи.
    statusOpenOne: "Отворена",
    statusClosedOne: "Затворена",
    statusClosed: "Затворени",
    opened: "Отворена",
    closed: "Затворена",
    duration: "Продължителност",
    orders: "Поръчки",
    cancelledItems: "Сторнирани",
    cancelledLabel: "Сторно: {{count}}",
    payment: "Плащане",
    paymentMethod: "Метод на плащане",
    noTableData: "Няма данни за маси",
    hours: "ч",
    minutes: "мин",
    cash: "Брой",
    card: "Карта",
    billsHistoryActivityEmpty: "Няма активност в избрания период",
    billsHistoryResults: "{{count}} резултата",
    billsHistoryResultOne: "{{count}} резултат",
    billsHistoryNoResults: "Няма сметки за избраните филтри",
    billsHistoryReceiptNumber: "Фискален бон",
    billsHistoryClearFilters: "Изчисти филтри",

    // Редизайн 0.0.218 — bento подредба + споделената таблица.
    openMenu: "Отвори менюто",
    durationShort: "Време",
    itemsShort: "Арт.",
    guestsCount: "Брой гости",
    billIdShort: "№ сметка",
    ordersShort: "Поръчки",
    cashShort: "В брой",
    cardShort: "С карта",
    cancelledCountShort: "Сторн. бр.",
    discount: "Отстъпка",
    receiptNumber: "Бон №",
    restored: "Възстановена",
    billsHistoryKpiBills: "Сметки",
    billsHistoryKpiBillsUnit: "сметки",
    billsHistoryKpiScopeNote:
      "Показателите горе са за целия период — филтърът по статус, плащане и търсенето менят само списъка и реда „Общо“.",
    billsHistoryIsolateMarked: "Покажи само сметките с този знак",
    billsHistoryKpiRevenue: "Оборот",
    billsHistoryKpiRevenueSub: "затворени сметки",
    billsHistoryKpiAvgTicket: "Средна сметка",
    billsHistoryKpiAvgTime: "Средно време на маса",
    billsHistoryKpiAvgTimeSub: "на закрита сметка",
    billsHistoryHourlyTitle: "Сметки по час",
    billsHistoryDailyTitle: "Сметки по ден",
    billsHistoryDailyPeak: "най-силен {{day}} · {{count}} сметки",
    billsHistoryByHour: "по час",
    billsHistoryByDay: "по ден",
    billsHistoryHourlyHint: "по час на затваряне",
    billsHistoryHourlyPeak: "по час на затваряне · пик {{from}}–{{to}} ч",
    billsHistoryHourlyBar: "{{hour}}:00 · {{count}} бр.",
    billsHistoryComparePrevious: "Δ спрямо предишния период",
    billsHistoryInvoicedOnly: "Само с фактура",
    billsHistoryTableKicker: "Сметки",
    billsHistoryTableCount: "{{count}} сметки",
    billsHistoryTableCountOne: "{{count}} сметка",
    billsHistoryTableHint: "Клик върху ред отваря историята на операциите",
    billsHistorySearchPlaceholder: "Търси маса",
    billsHistoryEmptyHint:
      "Изчисти филтрите, разшири периода или потърси друга маса.",

    // Дашборд 0.0.219 — периодна bento подредба.
    // Сторно 0.0.220 — три изгледа върху едни и същи редове.
    cardPaymentsRowOne: "{{count}} движение",
    cardPaymentsRowMany: "{{count}} движения",
    cardPaymentsListHint: "Клик върху ред отваря сметката",
    cardPaymentsEmptyHint: "Няма движения от картовия терминал за този период.",
    cardPaymentsReconcileHint:
      "Сверка в края на деня: „С бон“ трябва да съвпада с картата в отчета на заведението, „С бон + Висящи“ — с „край на деня“ на самия терминал, а банката вижда само „С бон“ (върнатите се нулират помежду си).",
    cardPaymentsTerminalsKicker: "Сверка по апарат",
    cardPaymentsTerminalsTitle: "{{count}} терминала",
    voidsViewList: "Списък",
    voidsByWaiter: "По сервитьор",
    voidsByProduct: "По продукт",
    voidsRowsKicker: "Сторнирани редове",
    voidsInBills: "в {{count}} сметки",
    voidsInBillsOne: "в {{count}} сметка",
    voidsValue: "Стойност",
    voidsShareOfGross: "{{share}} % от затворения оборот",
    voidsValueSub: "сторнирана стойност",
    voidsAfterKitchen: "След кухня",
    voidsRealLoss: "реална загуба на продукт",
    voidsPerRow: "Средно на ред",
    voidsPerRowSub: "на сторниран ред",
    voidsRows: "Сторно редове",
    voidsTime: "Час",
    voidsCancelledBy: "Сторнирал",
    voidsScrap: "Брак",
    voidsScrapShort: "Брак",
    voidsBillOpenFailed: "Сметката не може да се отвори",
    voidsScrapCount: "{{count}} брак",
    voidsPlain: "Сторно",
    voidsSearchPlaceholder: "Маса, продукт, сервитьор, причина…",
    voidsShareOfRevenue: "% от оборота му",
    voidsRowOne: "{{count}} ред",
    voidsRowMany: "{{count}} реда",
    voidsListHint: "Клик върху ред отваря сметката",
    voidsWaiterHint: "Кой колко отписва спрямо оборота си",
    voidsProductHint: "Кое отпада най-често",
    voidsEmptyTitle: "Няма сторно за периода",
    voidsEmptyHint: "Това е добра новина. Смени периода или провери филтрите.",
    voidsBatchHint: "Сторнирани заедно — {{count}} реда с едно действие",
    voidsBatchColumn: "Заедно",
    dashClosed: "Закрити",
    dashBillsCount: "{{count}} сметки",
    dashBillsCountOne: "{{count}} сметка",
    dashAvgCheck: "Средна сметка",
    dashItemsCount: "{{count}} артикула",
    dashItemsCountOne: "{{count}} артикул",
    dashCashCard: "В брой / карта",
    dashVoids: "Сторно",
    dashVoidsCount: "{{count}} бр.",
    dashDiscounts: "Отстъпки",
    dashDiscountsSub: "{{count}} сметки · {{share}} % от брутото",
    dashDiscountsSubOne: "{{count}} сметка · {{share}} % от брутото",
    dashOpen: "Открити",
    dashNoOpenTables: "няма отворени маси",
    dashWaitersTitle: "Оборот по сервитьори",
    dashStationsTitle: "По станции",
    dashTopTitle: "Топ 5 по оборот",
    dashFullReport: "Пълна справка",
    dashAllItems: "Всички артикули",
    dashPieces: "{{count}} бр.",
    dashNoData: "Няма данни за периода",
    dashAlertsTitle: "За внимание",
    dashAlertsNone: "нищо за проверка в този период",
    invoice: "Фактура",
    priceChangesSearchPlaceholder: "Търсене по продукт, маса или потребител",
    priceChangesTableHint: "Клик върху ред отваря историята на операциите",
    priceChangesEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    kmRowsKpi: "Редове",
    kmRowsKpiSub: "с проследени преходи",
    kmTableHint: "времената са до първия преход към статуса",
    kmSearchPlaceholder: "Търси маса, артикул, оператор…",
    kmEmptyHint:
      "Разшири периода или провери дали мониторите отчитат преходите.",
    billsSplitsWaitersSub: "участвали в разделянията",
    billsSplitsProductsSub: "{{count}} прехвърлени продукта",
    billsSplitsAvgSub: "стойност на едно разделяне",
    billsSplitsRowOne: "{{count}} разделяне",
    billsSplitsRowMany: "{{count}} разделяния",
    billsSplitsTableHint: "клик върху ред отваря прехвърлените продукти",
    billsSplitsSearchPlaceholder: "Търси маса, сервитьор или коментар",
    billsSplitsEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    billsSplitsComment: "Коментар",
    billsSplitsNoItems: "Няма записани продукти за това разделяне",
    categoriesOpenItems: "Отвори артикулите в {{name}}",
    itemDaysSubtitle: "Оборот по дни",
    itemDaysQuantity: "Количество",
    itemDaysAvgPrice: "Средна цена",
    itemDaysDayOne: "{{count}} ден с продажби",
    itemDaysDaysMany: "{{count}} дни с продажби",
    itemDaysEmpty: "Няма продажби в избрания период",
    itemDaysFailed: "Разбивката по дни не се зареди.",
    itemDaysClose: "Затвори",
    dashLoadFailed: "Данните не се заредиха.",
    dashPaymentMixTitle: "Как е платено",
    dashPaymentMixEmpty: "Няма закрити сметки за периода.",
    dashPaymentOther: "Друг метод",
    dashAlertOpenLong: "Маса {{table}} е отворена {{time}}",
    dashAlertBigDiscount: "Отстъпка {{percent}} % · маса {{table}}",
    dashDaysTitle: "Оборот по работни дни",
    dashDaysHint: "{{range}} · маркиран е избраният период",
    dashDaysAverage: "средно {{amount}}",
    dashThousandShort: "к",
    dashDaysEmpty: "Няма приключени сметки за {{range}}",
    periodYesterday: "Вчера",
    periodToday: "Днес",
    period7d: "7 дни",
    periodThisMonth: "Този месец",
    periodPrev: "Предишен период",
    periodNext: "Следващ период",

    // FiscalIssues
    fiscalIssues: "Фискални проблеми",
    fiscalIssuesTitle: "Фискални проблеми",
    fiscalIssuesSubtitle: "Сметки и сторна без потвърден фискален бон",
    fiscalIssuesListTitle: "Сметки без касова бележка",
    fiscalIssuesListSubtitle:
      "Затворени сметки, при които фискалният бон не е потвърден",
    fiscalIssuesTotal: "Общо проблеми",
    fiscalIssuesFailed: "Отказани от принтера",
    fiscalIssuesUnknown: "Неизвестен изход",
    fiscalIssuesClosedAt: "Затворена",
    fiscalIssuesStatus: "Статус",
    fiscalIssuesError: "Грешка от принтера",
    fiscalIssuesRetry: "Опитай пак",
    fiscalIssuesRetrySuccess: "Касовата бележка е издадена",
    fiscalIssuesStornoListTitle: "Сторно без документ",
    fiscalIssuesStornoListSubtitle:
      "Сметки с касова бележка, чието сторно не е потвърдено на хартия",
    fiscalIssuesStornoRetrySuccess: "Сторно документът е издаден",
    fiscalIssuesReceiptNo: "Бон №",
    fiscalIssuesRetryTimeout:
      "Принтерът не отговори навреме — проверете отново след минута",
    fiscalIssuesRetryError: "Принтерът върна грешка",
    fiscalIssuesEmpty: "Няма проблемни фискализации за избрания период.",
    fiscalIssuesDays1: "Последните 24 часа",
    fiscalIssuesDays7: "Последните 7 дни",
    fiscalIssuesDays30: "Последните 30 дни",
    fiscalStatus_failed: "Отказан",
    fiscalStatus_timeout: "Неизвестен",
    fiscalStatus_pending: "Изчаква",
    fiscalStatusFailedHint:
      "Принтерът отказа печата — бон не е излизал. Отстранете причината и опитайте пак.",
    fiscalStatusUnknownHint:
      "Резултатът не е стигнал до сървъра — документът може вече да е излязъл. Проверете лентата на апарата, преди да повторите; повторението е безопасно само от касата, от която е закрита сметката.",
    fiscalIssuesRetryUnknownTitle: "Документът може вече да е излязъл",
    fiscalIssuesRetryUnknownBody:
      "Изходът е неизвестен. Първо проверете лентата на апарата (КЛЕН) и „Бон №“ в „Справка сметки“ — ако документът е излязъл, не повтаряйте. „Опитай пак“ оттук печата на принтера на ВАШАТА сесия; ако той е друг апарат, ще излезе втори документ.",

    // BillsSplits
    billsSplitsTitle: "Разделени маси",
    totalSplits: "Общо разделяния",
    transferredProducts: "Прехвърлени продукти",
    fromTable: "От маса",
    toTable: "Към маса",
    fromTableId: "От маса (ID)",
    toTableId: "Към маса (ID)",
    products: "Продукти",
    noSplitsData: "Няма данни за разделени маси",
    billsSplitsSummaryKicker: "Разделяния в периода",
    billsSplitsSummaryTitle: "Общ брой",
    billsSplitsWaiters: "Сервитьори",
    billsSplitsAmountTitle: "Обща сума",
    billsSplitsAvg: "Средно на разделяне",
    billsSplitsActivityKicker: "Активност",
    billsSplitsActivityHourly: "Разделяния по час",
    billsSplitsActivityDaily: "Разделяния по ден",
    billsSplitsActivityEmpty: "Няма активност в избрания период",
    billsSplitsListKicker: "Списък разделяния",

    // Cancellations
    cancellationsTitle: "Сторно",
    totalCancelled: "Общо сторнирани",
    defectiveItems: "Бракувани артикули",
    billId: "ID на сметка",
    selectUsers: "Избери потребители",
    defectiveOnly: "Само бракувани продукти",
    noCancellations: "Няма сторнирани продукти",
    bill: "Сметка",
    product: "Продукт",
    qty: "Кол-во",
    unitPrice: "Цена (единична)",
    // Стойността идва от полето „Коментар:" на сторно модала (изпраща се като
    // `reason`) — затова колоната се казва „Коментар", не „Причина".
    comment: "Коментар",
    defective: "✓ Брак",
    cancelled: "Сторно",
    cancellationsSummaryKicker: "Сторнирания в периода",
    cancellationsSummaryTitle: "Общ брой",
    cancellationsAmountKicker: "Сума в периода",
    cancellationsAmountTitle: "Стойност на сторнираното",
    cancellationsAvgLabel: "Средно на артикул",
    cancellationsActivityKicker: "Активност",
    cancellationsActivityHourly: "Сторно по час",
    cancellationsActivityDaily: "Сторно по ден",
    cancellationsActivityEmpty: "Няма сторнирания в избрания период",
    cancellationsListKicker: "Списък сторно",
    cancellationsResults: "{{count}} записа",
    cancellationsResultOne: "{{count}} запис",
    cancellationsClearFilters: "Изчисти филтри",
    cancellationsDefectiveLabel: "Брак",
    cancellationsRegularLabel: "Сторно",

    // AssortmentReport
    assortmentProductsKicker: "Артикули в периода",
    assortmentProductsTitle: "Уникални продукти",
    assortmentQuantityKicker: "Продадено количество",
    assortmentQuantityTitle: "Сбор по всички артикули",
    assortmentAmountKicker: "Оборот в периода",
    assortmentAmountTitle: "Сума от продажби",
    assortmentAvgLabel: "Средно на артикул",
    assortmentListKicker: "Списък артикули",
    assortmentResults: "{{count}} артикула",
    assortmentResultOne: "{{count}} артикул",
    assortmentClearFilters: "Изчисти филтри",
    assortmentSearchPlaceholder: "Търси артикул",
    assortmentNoItems: "Няма артикули в избрания период",
    // Вид на реда: самостоятелна продажба или продадена добавка
    assortmentColKind: "Тип",
    assortmentKindAssortment: "Асортимент",
    assortmentKindRecipe: "Рецепта",
    assortmentKindAddon: "Добавка",
    assortmentKindLunch: "Обедно меню",
    lunchTag: "Обедно",
    lunchScopeAll: "Всички",
    lunchScopeRegular: "Без обедно",
    lunchScopeLunch: "Само обедно",
    lunchScopeLabel: "Обедно меню",
    categoriesKindRegular: "Основно меню",

    // PersonalReportsPage
    allUsers: "Всички потребители",
    noReportsFound: "Няма намерени отчети",
    reportNumber: "№",
    user: "Потребител",
    bills: "Сметки",
    cashAmount: "В брой",
    cardAmount: "Карта",
    details: "Детайли",

    // DiscountsReport
    clientsTitle: "Клиенти",
    discountsBillId: "Сметка",
    discountsClient: "Клиент",
    discountsColType: "Тип",
    discountTag: "Отстъпка",
    discountsType: "Вид отстъпка",
    discountsPercent: "Процент",
    discountsAmount: "Корекция",
    discountsPaid: "Платено",
    discountsBillsCount: "Сметки с отстъпка",
    discountsTotalDiscount: "Обща отстъпка",
    discountsTotalPaid: "Общо платено",
    discountsTotalOriginal: "Обща сума",
    discountsNoData: "Няма данни за отстъпки",
    discountTypeFixedPercent: "Фиксиран процент",
    discountTypeCashback: "Кешбек",
    surchargeTag: "Надбавка",
    discountsBillsKicker: "Сметки в периода",
    discountsBillsTitle: "С отстъпка или надбавка",
    discountsAmountKicker: "Отстъпки",
    discountsAmountTitle: "Общо дадени отстъпки",
    discountsAmountAvgLabel: "Средно на сметка",
    surchargesKicker: "Надбавки",
    surchargesTitle: "Общо добавени надбавки",
    surchargesCountLabel: "Брой сметки",
    discountsPaidKicker: "Платена сума",
    discountsPaidTitle: "След корекции",
    discountsPaidSharedLabel: "Дял от общото",
    discountsListKicker: "Списък отстъпки и надбавки",
    discountsResults: "{{count}} сметки",
    discountsResultOne: "{{count}} сметка",
    discountsClearFilters: "Изчисти филтри",

    // WaitersReport - Справка по сервитьори
    waitersTitle: "Справка по сервитьори",
    methodCountColumn: "{{method}} · бр.",
    waitersCashCount: "Бр. в брой",
    waitersCardCount: "Бр. с карта",
    waitersMixedCount: "Бр. смесени",
    waitersTotalCash: "Общо в брой",
    waitersTotalCard: "Общо с карта",
    waitersNoData: "Няма данни за сервитьори",
    waitersDetailTitle: "Детайли по дати",
    waitersRevenueKicker: "Оборот в периода",
    waitersRevenueTitle: "Обща сума",
    waitersRevenueAvgLabel: "Средно на сервитьор",
    waitersSplitKicker: "Разпределение",
    waitersSplitTitle: "По методи на плащане",
    waitersListKicker: "Списък сервитьори",
    waitersResults: "{{count}} сервитьори",
    waitersResultOne: "{{count}} сервитьор",
    waitersClearFilters: "Изчисти филтри",

    // StationsReport - Справка по обекти (станции)
    stationsTitle: "Справка по обекти",
    stationsName: "Станция",
    stationsCashCount: "Бр. в брой",
    stationsCardCount: "Бр. с карта",
    stationsMixedCount: "Бр. смесени",
    stationsTotalCash: "Общо в брой",
    stationsTotalCard: "Общо с карта",
    stationsRevenueKicker: "Оборот в периода",
    stationsRevenueTitle: "Обща сума",
    stationsRevenueAvgLabel: "Средно на обект",
    stationsSplitKicker: "Разпределение",
    stationsSplitTitle: "По методи на плащане",
    stationsListKicker: "Списък обекти",
    stationsResults: "{{count}} обекта",
    stationsResultOne: "{{count}} обект",
    stationsClearFilters: "Изчисти филтри",

    // Personal reports list
    personalTitle: "Персонални отчети",
    personalRevenueKicker: "Оборот в периода",
    personalRevenueTitle: "Обща сума",
    personalRevenueAvgLabel: "Средно на отчет",
    personalSplitKicker: "Разпределение",
    personalSplitTitle: "По методи на плащане",
    personalListKicker: "Списък отчети",
    personalResults: "{{count}} отчета",
    personalResultOne: "{{count}} отчет",
    personalClearFilters: "Изчисти филтри",
    personalBillsLabel: "Сметки",

    // EstablishmentReportsPage
    personalReportsCount: "Персонални отчети",
    establishmentTitle: "Отчет на заведението",
    establishmentRevenueKicker: "Оборот в периода",
    establishmentRevenueTitle: "Обща сума",
    establishmentRevenueAvgLabel: "Средно на отчет",
    establishmentSplitKicker: "Разпределение",
    establishmentSplitTitle: "По методи на плащане",
    establishmentListKicker: "Списък отчети",
    establishmentResults: "{{count}} отчета",
    establishmentResultOne: "{{count}} отчет",
    billOpsBillKicker: "Сметка",
    billOpsCardNoReceipt: "БЕЗ БОН — не теглете повторно",
    billOpsCardRefunded: "върнато при сторно:",
    billOpsCardSection: "Картови тегления",
    billOpsCardVoided: "върнато на картата",
    billOpsCardWithReceipt: "с бон",
    billOpsClient: "Клиент: {{name}}",
    billOpsClose: "Затвори",
    billOpsDefective: "брак",
    billOpsDuration: "Продължителност {{value}}",
    billOpsEmpty: "Няма операции",
    billOpsEventAddItems: "Добавени артикули",
    billOpsEventCancel: "Сторно",
    billOpsEventClose: "Затваряне",
    billOpsEventPreliminaryBill: "Предварителна сметка",
    billOpsEventDiscountBill: "Отстъпка върху сметката",
    billOpsEventDiscountBillRemoved: "Премахната отстъпка върху сметката",
    billOpsEventDiscountItem: "Отстъпка върху продукт",
    billOpsEventDiscountItemRemoved: "Премахната отстъпка върху продукт",
    billOpsEventOpen: "Отваряне",
    billOpsEventPayment: "Плащане",
    billOpsEventPriceChange: "Промяна на цена",
    billOpsEventPriceRestored: "Върната цена от менюто",
    billOpsEventRestore: "Възстановяване на сметката",
    billOpsRestoreReceipt: "Сторниран бон № {{number}}",
    billOpsRestoreReport: "Изключена от личен отчет № {{number}}",
    billOpsRestoreReportBoth:
      "Изключена от личен отчет № {{number}} и от отчет на заведението № {{establishment}}",
    billOpsRestoredTimes_one: "възстановена {{count}} път",
    billOpsRestoredTimes_other: "възстановена {{count}} пъти",
    billOpsEventSplitIn: "Получено от друга сметка",
    billOpsEventSplitOut: "Разделяне на сметка",
    billOpsEventSurchargeBill: "Надбавка върху сметката",
    billOpsEventSurchargeBillRemoved: "Премахната надбавка върху сметката",
    billOpsEventTransfer: "Преместване на гости",
    billOpsFullTransfer: "Цялата сметка #{{id}} е прехвърлена",
    billOpsPaidCard: "Карта",
    billOpsPaidCash: "В брой",
    billOpsReason: "Причина: {{reason}}",
    billOpsSectionOperations: "Операции",
    billOpsSector: "Сектор: {{name}}",
    billOpsStatusClosed: "затворена",
    billOpsStatusOpen: "отворена",
    billOpsTotalCancelled: "Сторно",
    billOpsTotalDiscount: "Отстъпка",
    billOpsTotalItems: "Артикули",
    billOpsTotalPaid: "Платено",
    billOpsTotalSurcharge: "Надбавка",
    billOpsTotalTransferred: "Прехвърлено",
    categoriesColDelta: "Δ пред. период",
    categoriesCountKicker: "Групи",
    categoriesItemsSub: "продадени бройки",
    categoriesTableCount: "{{count}} групи",
    categoriesTableCountOne: "{{count}} група",
    categoriesGroupColumn: "Група",
    categoriesTableHint: "клик върху името отваря артикулите",
    dailyBillsMany: "{{count}} сметки",
    dailyBillsOne: "{{count}} сметка",
    dailyColTotal: "Общо",
    dailyEmptyHint: "Смени периода или провери дали отчетите са пуснати.",
    dailyKpiReports: "Отчети",
    dailyKpiReportsSub: "персонални",
    dailyKpiRevenue: "Оборот",
    dailyListHint: "клик отваря отчета",
    dailyOther: "Друго",
    dailyReportsTitle: "Дневни отчети",
    dailySearchPlaceholder: "Търси номер или сервитьор",
    dailyTabEstablishment: "Заведение",
    dailyTabPersonal: "Персонални",
    dailyWorkDay: "Работен ден",
    discountsBefore: "Преди",
    discountsBillOpenFailed: "Сметката не може да се отвори",
    discountsEmptyHint: "Смени периода или изчисти филтрите в колоните.",
    discountsGiven: "Отстъпка",
    discountsAdjustmentColumn: "Отстъпка / надбавка",
    discountsKind: "Вид",
    discountsKpiAboveApproval: "Над {{percent}} %",
    discountsKpiAboveApprovalIsolated: "показани само те",
    discountsKpiAboveApprovalSub: "сметки · изискват одобрение",
    discountsKpiAverage: "Средна отстъпка",
    discountsKpiAverageSub: "на сметка",
    discountsKpiBills: "Сметки с отстъпка",
    discountsKpiBillsShare: "{{share}} % от всички",
    discountsKpiBillsUnit: "сметки в периода",
    discountsKpiGiven: "Дадени отстъпки",
    discountsKpiGivenShare: "{{share}} % от брутото",
    discountsKpiGivenSub: "за периода",
    discountsKpiSurcharges: "Надбавки",
    discountsKpiSurchargesNone: "няма за периода",
    discountsSearchPlaceholder: "Търсене по сметка, сервитьор или клиент",
    discountsTableHint: "Клик върху ред отваря историята на операциите",
    discountsTime: "Час",
    itemsAvgKicker: "Средно на артикул",
    itemsAvgSub: "оборот / бройки",
    itemsCategoryFilterChip: "Категория: {{name}}",
    itemsCategoryFilterClear: "Махни филтъра по категория",
    itemsColCount: "Бройки",
    itemsColPrice: "Цена",
    itemsColRevenue: "Оборот",
    itemsColShare: "Дял",
    itemsEmptyHint: "Смени периода или махни филтрите в колоните.",
    itemsRevenueKicker: "Оборот от артикули",
    itemsRevenueSub: "както е платено",
    itemsSoldKicker: "Продадени бройки",
    itemsTableHint: "клик върху ред отваря дните му",
    itemsTableKicker: "Артикули",
    itemsUniqueKicker: "Уникални артикули",
    itemsUniqueSub: "с продажби",
    stationsBillsColumn: "Сметки",
    stationsCountKpi: "Станции",
    stationsCountKpiSub: "с оборот в периода",
    stationsDeltaColumn: "Δ пред. период",
    stationsDetailClose: "Затвори",
    stationsEmptyHint: "В избрания период няма закрити сметки с артикули по станции.",
    stationsEmptyTitle: "Няма оборот по станции",
    stationsPageTitle: "Справка по станции",
    stationsRevenueColumn: "Оборот",
    stationsRevenueKpi: "Оборот от артикули",
    stationsRevenueKpiSub: "от закрити сметки, след отстъпки",
    stationsRowMany: "{{count}} станции",
    stationsRowOne: "{{count}} станция",
    stationsSearchPlaceholder: "Търси станция…",
    stationsShareColumn: "Дял",
    stationsWaiters: "Сервитьори",
    stationsAllWaiters: "Всички сервитьори",
    stationsVoidsColumn: "Сторно",
    stationsVoidsCount: "{{count}} бр.",
    stationsVoidsKpi: "Сторно по станции",
    voidsBatchChip: "×{{count}} заедно",
    waitersAvgBill: "Средна сметка",
    waitersBillsMany: "{{count}} сметки",
    waitersBillsOne: "{{count}} сметка",
    waitersDayMany: "{{count}} дни",
    waitersDayOne: "{{count}} ден",
    waitersDaysHint: "Разбивка по метод на плащане",
    waitersDaysKicker: "По дни",
    waitersDetailSubtitle: "Оборот по дни за избрания период",
    waitersEmptyHint: "Смени периода или провери дали сметките са закрити.",
    waitersEmptyTitle: "Няма закрити сметки в периода",
    waitersKicker: "Сервитьори",
    waitersOnShift: "{{count}} на смяна",
    waitersRevenue: "Оборот",
    waitersRowHint: "Клик отваря детайл по дни",
    waitersSearchPlaceholder: "Търси сервитьор…",
    waitersShare: "Дял",
    dailyKpiReportsEstablishmentSub: "на заведението",
    establishmentPreparedBy: "Съставил",
    establishmentSearchPlaceholder: "Търси номер или съставил",
    invoicesCancelledKpi: "Анулирани",
    invoicesCancelledKpiSub: "включени в сумите",
    invoicesColStatus: "Състояние",
    invoicesColType: "Вид",
    invoicesEmptyHint: "Смени периода или изчисти търсенето.",
    invoicesGrandKpi: "Общо",
    invoicesGrandKpiSub: "с ДДС",
    invoicesIssuedKpi: "Издадени",
    invoicesIssuedKpiSub: "фактури за периода",
    invoicesStatusCancelled: "Анулирана",
    invoicesStatusIssued: "Издадена",
    invoicesTableHint: "клик отваря фактурата",
    invoicesTaxableKpi: "Данъчна основа",
    invoicesTaxableKpiSub: "без ДДС",
    invoicesVatKpi: "ДДС",
    invoicesVatKpiSub: "начислен данък",
    salesPeriodsReport: "Продажби по периоди",
    salesPeriodsPageTitle: "Продажби по периоди",
    salesPeriodsMode_grouped: "Групирано",
    salesPeriodsMode_timeline: "Във времето",
    salesPeriodsUnit_hour: "Часове",
    salesPeriodsUnit_weekday: "Дни от седмицата",
    salesPeriodsUnit_month: "Месеци",
    salesPeriodsUnit_date: "Дати",
    salesPeriodsUnit_year: "Години",
    salesPeriodsAllUsers: "Всички потребители",
    salesPeriodsUsers: "Потребители",
    salesPeriodsAllClients: "Всички клиенти",
    salesPeriodsClients: "Клиенти",
    salesPeriodsWithoutClient: "Без клиент",
    salesPeriodsAllItems: "Всички артикули",
    salesPeriodsItems: "Артикули",
    salesPeriodsClearFilters: "Изчисти филтрите",
    salesPeriodsChartHint: "един стълб = един ред от таблицата",
    salesPeriodsTableKicker: "Периоди",
    salesPeriodsRowOne: "{{count}} период",
    salesPeriodsRowMany: "{{count}} периода",
    salesPeriodsTableHint: "клик върху ред отваря дните",
    salesPeriodsSearchPlaceholder: "Търси период…",
    salesPeriodsEmptyTitle: "Няма продажби за този период",
    salesPeriodsEmptyHint: "Промени периода или махни филтрите.",
    salesPeriodsPeriodColumn: "Период",
    salesPeriodsBillsColumn: "Сметки",
    salesPeriodsQuantityColumn: "Брой асортименти",
    salesPeriodsQuantityShort: "арт.",
    salesPeriodsRevenueColumn: "Сума",
    salesPeriodsVatColumn: "ДДС",
    salesPeriodsNetColumn: "Нето",
    salesPeriodsAvgPriceColumn: "Ср. цена",
    salesPeriodsAvgBillColumn: "Средна сметка",
    salesPeriodsAvgBillShort: "ср.",
    salesPeriodsClientsColumn: "Клиенти брой",
    salesPeriodsClientRevenueColumn: "Клиенти сума",
    salesPeriodsClientAvgColumn: "Клиенти средна сума",
    salesPeriodsFiscalizedColumn: "Сума ФП",
    salesPeriodsBaseColumn: "По базови цени",
    salesPeriodsDiscountColumn: "Отстъпки",
    salesPeriodsMarkupColumn: "Надбавки",
    salesPeriodsDetailSubtitle: "{{bills}} сметки · {{amount}}",
    methodAmountColumn: "{{method}} (както е платено)",

    // --- Справки за резервации (reservations/) ---
    reservationsReports: "Резервации",
    rvJournal: "Дневник на резервациите",
    rvOccupancy: "Натовареност",
    rvGuests: "Гости",
    rvStatus_upcoming: "Предстояща",
    rvStatus_seated: "Настанена",
    rvStatus_completed: "Приключила",
    rvStatus_cancelled: "Отказана",
    rvStatus_expired: "Неизпълнена",
    rvKpiReservations: "Резервации",
    rvKpiReservationsSub: "предстоящи {{upcoming}} · настанени {{seated}}",
    rvKpiGuests: "Гости",
    rvKpiGuestsSub: "без отказаните и неизпълнените",
    rvKpiAverageParty: "средно {{value}} на резервация",
    rvKpiCompletedSub: "гостите са дошли и са си тръгнали",
    rvKpiCancelledSub: "отказани преди часа",
    rvKpiNoShowNone: "няма неявявания",
    rvKpiNoShowRate: "{{value}} % неявяване",
    rvKpiRevenue: "Оборот",
    rvKpiRevenueSub: "по сметките на настанените",
    rvColumnTime: "Час",
    rvColumnPhone: "Телефон",
    rvColumnGuests: "Гости",
    rvColumnTables: "Маси",
    rvColumnStatus: "Статус",
    rvColumnName: "Име",
    rvColumnDuration: "Продължителност",
    rvColumnSeatedAt: "Настанени в",
    rvColumnReleasedAt: "Тръгнали в",
    rvColumnAvgDuration: "Средна продължителност",
    rvExportDurationMinutes: "Продължителност (мин)",
    rvExportAvgDurationMinutes: "Средна продължителност (мин)",
    rvAllStatuses: "Всички статуси",
    rvStatuses: "Статуси",
    rvAllTables: "Всички маси",
    rvChartTitle: "Резервации по периоди",
    rvChartAverage: "средно {{value}}",
    rvChartEmpty: "Няма резервации за избрания период и филтри.",
    rvKpiPerPeriod: "Средно на {{unit}}",
    rvKpiPerPeriodSub: "{{count}} периода в таблицата",
    rvPerUnit_hour: "час",
    rvPerUnit_weekday: "ден от седмицата",
    rvPerUnit_month: "месец",
    rvPerUnit_date: "ден",
    rvPerUnit_year: "година",
    rvColumnStay: "Реален престой",
    rvColumnBill: "Сметка",
    rvColumnCreatedBy: "Създадена от",
    rvColumnSeatedBy: "Настанена от",
    rvSeatedByNoOrder: "Още няма поръчка",
    rvSeatedByNoOrderClosed: "Без поръчка",
    rvColumnNote: "Забележка",
    rvColumnCreatedAt: "Създадена на",
    rvColumnAvgStay: "Среден реален престой",
    rvColumnNoShowRate: "Неявяване",
    rvColumnLastVisit: "Последно посещение",
    rvColumnLastReservation: "Последна резервация",
    rvColumnFirstReservation: "Първа резервация",
    rvExportEnd: "Край",
    rvExportStayMinutes: "Реален престой (мин)",
    rvExportBillName: "Маса на сметката",
    rvExportAvgStayMinutes: "Среден реален престой (мин)",
    rvJournalKicker: "Резервации по час",
    rvReservationOne: "{{count}} резервация",
    rvReservations: "{{count}} резервации",
    rvJournalHint: "периодът е по часа на резервацията",
    rvJournalSearchPlaceholder: "Търси гост, телефон, маса…",
    rvNoData: "Няма резервации в избрания период",
    rvEmptyHint: "Разшири периода или провери дали модулът „Резервации“ се ползва.",
    rvKpiGuestsCount: "Гости",
    rvKpiGuestsCountSub: "различни телефони",
    rvKpiReservationsOfGuestsSub: "общо в периода",
    rvKpiReturning: "Редовни",
    rvKpiReturningSub: "с повече от една резервация",
    rvKpiWithNoShow: "С неявяване",
    rvKpiWithNoShowSub: "поне една неизпълнена",
    rvGuestsKicker: "Гости по телефон",
    rvGuestOne: "{{count}} гост",
    rvGuestsMany: "{{count}} гости",
    rvGuestsHint: "името е от последната резервация на госта",
    rvGuestsSearchPlaceholder: "Търси име или телефон…",
    rvGuestVisitsPeriod: "период {{period}}",
    rvGuestVisitsKpiVisits: "Посещения",
    rvGuestVisitsOfReservationOne: "от {{count}} резервация",
    rvGuestVisitsOfReservationsMany: "от {{count}} резервации",
    rvGuestVisitsKpiAverageBill: "Средна сметка",
    rvGuestVisitsKpiAverageStay: "Среден престой",
    rvGuestVisitsKpiCompletedSub: "по приключилите посещения",
    rvGuestVisitsKpiRevenue: "Общо похарчено",
    rvGuestVisitsKpiRevenueSub: "всички сметки в периода",
    rvGuestVisitsKpiCancelled: "Отказани",
    rvGuestVisitsKpiNoShow: "Неизпълнени",
    rvGuestVisitsKpiNoShowSub: "резервирали, но не дошли",
    rvGuestVisitsListTitle: "Резервации в периода",
    rvGuestVisitsEmpty: "Няма резервации на този гост в избрания период.",
    rvGuestVisitsFailed: "Историята на госта не се зареди. Опитай пак.",
  },

  restoreBill: {
    title: "Възстановяване на сметка",
    total: "Общо: {{count}}",
    range30: "30 мин",
    range60: "60 мин",
    range120: "2 часа",
    noBills: "Няма закрити сметки за избрания период",
    restore: "Възстанови",
    fiscalize: "Фискализирай",
    changePaymentMethod: "Смяна на плащане",
    success: "Сметката е възстановена успешно",
    error: "Грешка при възстановяване на сметката",
    cardWarning:
      "Сметката е платена с карта (RRN {{rrn}}). Сторното излиза „В брой“ — върнете сумата на госта в брой от касата, не през терминала.",
    cardWarningNoRrn:
      "Сметката е платена с карта. Сторното излиза „В брой“ — върнете сумата на госта в брой от касата, не през терминала.",
    cardRefundPlaceholder: "RRN, ако по изключение е върнато през терминала (по избор)",
  },

  language: {
    bg: "Български",
    en: "English",
  },

  changelog: {
    kicker: "ВЕРСИИ",
    title: "История на промените",
    subtitle:
      "Всички версии, нови функции, поправки и подобрения на системата.",
    currentVersion: "Текуща версия",
    latest: "Последна",
    legend: "Типове промени",
    typeFeature: "Нова функция",
    typeFix: "Поправка",
    typeImprovement: "Подобрение",
    typeBreaking: "Промяна",
    typeSecurity: "Сигурност",
  },

  monitoring: {
    title: "Мониторинг",
    subtitle: "Служебен достъп — одит, фискални проблеми и AI помощник",
    auditLog: "Одит на действията",
    auditLogDesc:
      "Записи за всички операции в системата — кой, кога и какво е променил.",
    fiscalIssues: "Фискални проблеми",
    fiscalIssuesDesc:
      "Сметки и сторна без потвърден фискален бон — преглед и повторен опит.",
    assistant: "AI помощник",
    assistantDesc:
      "Въпроси за настройки и проблеми — отговорът е от базата знания и данните на този ресторант.",
    assistantSubtitle: "База знания и данни на живо на ресторанта",
    assistantPlaceholder: "Как да… / Защо не…  (Enter — питай, Shift+Enter — нов ред)",
    assistantPlaceholderShort: "Как да… / Защо не…",
    assistantSend: "Питай",
    assistantNewConversation: "Нов разговор",
    assistantThinking: "Търся в базата и в данните… {{seconds}} s",
    assistantEmptyTitle: "Какво да проверя?",
    assistantEmpty:
      "Питай за настройка, за симптом или за конкретен човек, продукт, станция, устройство.",
    assistantExample1: "Защо Иван не вижда „Сторниране“?",
    assistantExample2: "Защо не печата на станция Бар?",
    assistantExample3: "Кои сметки днес са без касов бон?",
    confidenceConfirmed: "Потвърдено",
    confidenceLikely: "Почти сигурно, непотвърдено",
    confidenceUnknown: "Не знам",
    confidenceClarify: "Нужно уточнение",
    assistantStatsSummary: "{{seconds}} s · {{rounds}} стъпки",
    assistantStatsCost: "~${{cost}}",
    assistantStatsTokens:
      "Вход {{tokensIn}} (кеш {{cacheRead}}) · изход {{tokensOut}} · {{model}}",
    assistantStatsTools: "Инструменти и раздели",
    assistantHelpful: "Полезно ли беше?",
    assistantVoteUp: "Полезно",
    assistantVoteDown: "Не е полезно",
    assistantCommentPlaceholder:
      "Какво не е наред / какъв е верният отговор? (по желание)",
    assistantCommentSend: "Изпрати",
    assistantFeedbackSaved: "Оценката е записана.",
    assistantFeedbackError: "Оценката не се записа.",
    assistantNotRecorded: "Отговорът не е записан — оценка не е възможна.",
    assistantErrNotConfigured:
      "AI помощникът не е конфигуриран на сървъра (липсва ключ за OpenAI).",
    assistantErrExpired: "Разговорът е изтекъл — започваме нов. Задайте въпроса отново.",
    assistantErrTimeout: "Отговорът отне твърде дълго — задайте по-конкретен въпрос.",
    assistantErrUpstream: "OpenAI не отговори — опитайте отново след малко.",
    assistantErrForbidden: "Само служебният акаунт на UnrealSoft има достъп.",
    assistantErrGeneric: "Въпросът не мина — опитайте отново.",
  },

  auditLog: {
    title: "Дневник на действията",
    subtitle: "Кой, кога и какво е направил — по всички модули.",
    searchPlaceholder: "Търси по всички полета…",
    noResults: "Няма намерени записи",
    emptyHint:
      "Разшири периода или махни някой от филтрите. Прегледите (GET) са скрити, докато не се включат.",
    tableKicker: "ДНЕВНИК",
    tableCount: "{{count}} записа",
    tableCountOne: "{{count}} запис",
    tableHint: "клик отваря пълния запис",
    statusClass: {
      "2xx": "Успешни (2xx)",
      "4xx": "Грешка на клиента (4xx)",
      "5xx": "Сървърна грешка (5xx)",
    },
    col: {
      timestamp: "Време",
      outcome: "Резултат",
      operation: "Действие",
      module: "Модул",
      impact: "Вид",
      table: "Маса",
      billId: "Сметка",
      user: "Потребител",
      userId: "Ид на потребител",
      method: "Метод",
      status: "Статус",
      duration: "Латентност",
      path: "URL",
      entryId: "Ид на запис",
    },
    module: {
      ordering: "Маркиране",
      cash: "Каса",
      reports: "Справки",
      invoicing: "Фактури",
      inventory: "Склад",
      configuration: "Конфигурация",
      access: "Достъп",
      system: "Системни",
    },
    impact: {
      money: "Пари",
      settings: "Настройки",
      data: "Данни",
      read: "Четене",
    },
    outcome: {
      ok: "Успешно",
      failed: "Бонът не е излязъл",
      rejected: "Отказано",
      error: "Сървърна грешка",
    },
    quick: {
      problems: "Само проблеми",
      money: "Пари",
      settings: "Настройки",
      slow: "Бавни над {{ms}} ms",
      reads: "С прегледите (GET)",
      live: "На живо",
    },
    stats: {
      actions: "ДЕЙСТВИЯ",
      actionsSub: "промени: {{writes}} · прегледи: {{reads}}",
      problems: "ПРОБЛЕМИ",
      problemsSub: "неуспели или отказани",
      fiscalFailedSub: "в т.ч. {{count}} непечатани бона",
      fiscalFailedSubOne: "в т.ч. 1 непечатан бон",
      money: "ПАРИ",
      moneySub: "плащане, сторно, отстъпка, каса",
      settings: "НАСТРОЙКИ",
      settingsSub: "конфигурация и устройства",
      people: "ХОРА",
      lastAt: "последно в {{when}}",
      slowest: "НАЙ-БАВНО",
      avg: "средно {{value}}",
      byHour: "ПО ЧАС",
      byDay: "ПО ДЕН",
      barsHint: "клик стеснява периода",
      barTitle: "{{when}} · действия: {{count}} · проблеми: {{problems}}",
    },
    breakdown: {
      byModule: "ПО МОДУЛ",
      byUser: "ПО ПОТРЕБИТЕЛ",
      clickHint: "клик стеснява списъка",
      anonymous: "Без потребител",
    },
    trace: {
      kicker: "ПРОСЛЕДЯВАНЕ",
      billTitle: "Сметка #{{id}} · маса {{table}}",
      tableTitle: "Маса {{name}}",
      billHint: "Проследи сметка #{{id}}",
      tableHint: "Проследи маса {{name}}",
      count: "{{count}} записа",
      countOne: "{{count}} запис",
      periodOff: "периодът е изключен — вижда се целият живот",
      exit: "Изход",
    },
  },

  auditLogDetail: {
    request: "Заявка",
    response: "Отговор",
    headers: "Headers",
    query: "Query string",
    body: "Body",
    empty: "Няма",
    getNoBody: "GET заявките нямат body — данните са в Query string",
    copy: "Копирай",
    copied: "Копирано!",
    togglePretty: "Форматирай",
    toggleRaw: "Без форматиране",
    loadError: "Грешка при зареждане на детайлите",
    truncatedTitle: "Данните бяха твърде големи",
    truncatedBody:
      "Тялото беше {{size}} KB. Не сме го запазили цялото, за да не натрупваме излишно в базата (лимит: 10 KB).",
    truncatedBodyUnknown:
      "Тялото надхвърли лимита (10 KB) и не е запазено цяло, за да не натрупваме излишно в базата.",
    human: {
      rawTitle: "Технически детайли (суров запис)",
      summaryKicker: "Какво се случи",
      who: "Потребител",
      when: "Време",
      table: "Маса",
      noDetails:
        "За тази операция няма подробен човешки преглед — виж техническите детайли по-долу.",
      total: "Общо",
      product: "Продукт",
      products: "Продукти",
      unknownProduct: "Непознат продукт",
      method: "Метод",
      modifier: "Модификатор",
      discount: "Отстъпка",
      percent: "Процент",
      client: "Клиент",
      discountType: "Тип отстъпка",
      removedDiscountNote: "Премахната е отстъпката от сметката.",
      cancelled: "Сторнирано",
      reason: "Причина",
      defective: "Брак",
      yes: "Да",
      no: "Не",
      cancelledAllNote: "Сторнирана е цялата сметка.",
      paymentMethod: "Начин на плащане",
      cash: "В брой",
      card: "С карта",
      paidTotal: "Платена сума",
      addedAmount: "Добавена сума",
      restoredNote: "Приключената сметка е отворена наново (същото id).",
      targetTable: "Към маса",
      movedItems: "Преместени продукта",
      movedProducts: "Преместени продукти",
      newName: "Ново име",
      waiter: "Сервитьор",
      cashIn: "Внесено",
      cashOut: "Изтеглено",
      successLabel: "Успешно",
      failedLabel: "Неуспешно",
      prevOp: "Предишна операция по сметката",
      nextOp: "Следваща операция по сметката",
      timelineTitle: "Хронология на сметката",
      billLabel: "Сметка",
      operationsWord: "операции",
      flagDiscountReverted: "Отстъпка приложена и след това премахната",
      flagCancelAfterClose: "Сторно след затваряне на сметката",
      flagFailed: "Операцията е неуспешна",
      // Сметка: премахната отстъпка на ред и промяна на цени
      removedItemDiscountNote: "Премахната е отстъпката от този продукт.",
      newPrices: "Нови цени",
      itemDiscounts: "Отстъпки по продукти",
      additionLine: "добавка",
      // Складова база
      recipe: "Рецепта",
      documentNo: "Документ",
      warehouse: "Склад",
      fromWarehouse: "От склад",
      toWarehouse: "Към склад",
      supplier: "Доставчик",
      invoiceNumber: "Фактура №",
      deliveryValue: "Стойност на доставката",
      writeoffKind: "Вид",
      writeoffKindScrap: "Бракуване",
      writeoffKindNormal: "Изписване",
      substitutions: "Замени",
      countedProducts: "Преброени продукти",
      postedProducts: "Разнесени продукти",
      reportNo: "Отчет",
      hint: "Подсказка",
      coefficient: "Коефициент",
      groupMembers: "Продукти в групата",
      vatRegistered: "Регистрация по ДДС",
      defaultWarehouse: "Склад по подразбиране",
      productWarehouse: "Свой склад на продукта",
      productWarehouseRemovedNote:
        "Своят склад на продукта е махнат — оттук нататък решава складът на станцията.",
      restoredDocument: "Възстановен документ",
      deliveryNotes: "Стокови разписки",
      closeReason: "Причина",
      markedPaid: "Отбелязани като платени",
      detachedNotesNote: "Стоковите са извадени от фактурата си; стоката им остава заприходена.",
      closedNotesNote: "Стоковите са приключени без фактура — вече не чакат фактура.",
      reopenedNotesNote: "Стоковите отново чакат фактура.",
      restoredDocumentNote: "Анулиран складов документ е върнат в действие.",
      cancelledDocumentNote: "Документът е анулиран.",
      deletedGroupNote: "Групата взаимозаменяеми продукти е изтрита окончателно.",
      truncatedBodyNote:
        "Тялото на заявката е било твърде голямо и не е запазено — виж документа в Складова база.",
      // Конфигурация, печат, устройства, глас
      newValue: "Нова стойност",
      turnedOn: "Включено",
      turnedOff: "Изключено",
      invoiceNo: "Фактура",
      result: "Резултат",
      errorLabel: "Грешка",
      requestId: "Ид на заявката",
      device: "Устройство",
      deviceUpdateNote:
        "Изпратена е команда касата да се обнови до последната версия на FiscalAPI.",
      fiscalRetryNote: "Повторен опит за издаване на касовата бележка.",
      stornoRetryNote: "Повторен опит за издаване на кредитното известие.",
      recognizedProducts: "Разпознати продукти",
      voiceAmbiguous: "двусмислено, кандидати",
      voiceNoMatch: "няма съвпадение в менюто",
      // Резервации
      reservationGuest: "Гост",
      reservationTables: "Маси",
      reservationTime: "Час",
      reservationGuests: "Гости",
      reservationDuration: "Продължителност",
      reservationBill: "Сметка",
      reservationBillNew: "№ {{id}} — нова празна сметка",
      reservationBillAttached: "№ {{id}} — закачена към отворена сметка",
      reservationBills: "Сметки",
      reservationBillsSeparate: "{{ids}} — отделна сметка за всяка маса",
      reservationReleasedNote:
        "Гостите си тръгнаха — резервацията е приключена; сметката остава отворена до закриване в Маркиране.",
      reservationUnseatedNote:
        "Настаняването е отменено — резервацията е отново предстояща; сметката не е пипана.",
      reservationUnseatedBillClosedNote:
        "Настаняването е отменено — резервацията е отново предстояща; празната сметка от настаняването (без поръчки) е премахната.",
      reservationCancelledNote: "Резервацията е отказана — масите са освободени.",
      reservationRestoredNote: "Резервацията е върната в предстоящи.",
      reservationOrigin: "Източник",
      reservationOriginEdge: "Касата, без интернет — качено при синхронизацията",
    },
  },

  push: {
    menuLabel: "Известия",
    settingsTitle: "Известия",
    settingsSubtitle: "Известия от кухнята при сготвени и издадени поръчки.",
    toggleLabel: "Получавай известия на това устройство",
    unsupportedHint:
      "Този браузър не поддържа известия. На iPhone приложението първо трябва да се инсталира на началния екран (Сподели → „Добави към началния екран“).",
    permissionDeniedHint:
      "Известията са забранени от браузъра за този сайт. Разрешете ги от настройките на сайта в браузъра и опитайте отново.",
    enableError: "Известията не се включиха. Опитайте отново.",
    disableError: "Известията не се изключиха. Опитайте отново.",
    deviceTitle: "Известия на устройството",
    deviceSubtitle: "Кой получава известия на този терминал.",
    deviceEmpty: "Никой не е абониран за известия на това устройство.",
    remove: "Премахни",
    removeError: "Премахването не успя. Опитайте отново.",
  },
  // Локален резерв — режим срещу главната каса без интернет (docs/edge.md)
  edge: {
    bannerTitle: "Локален режим",
    bannerText: "без интернет, работиш срещу касата",
    bannerSyncing:
      "интернетът се върна — изчаква се касата да изпрати направеното без връзка",
    bannerRestricted: "влез с код или парола",
    bannerUnresolved_one:
      "{{count}} действие не е стигнало до облака — вижте касата",
    bannerUnresolved_other:
      "{{count}} действия не са стигнали до облака — вижте касата",
    restrictedRequest: "Локален режим — влез с код или парола",
    // Връзката се върна, а локалният билет не можа да се размени за истински
    // токен — човекът пада на ПИН екрана и трябва да прочете ЗАЩО.
    returnedToPin:
      "Интернетът се върна и работата продължава срещу облака — влез отново с кода си.",
    // Ограничен локален режим: единственият път от ПИН екрана към вход с
    // потребител и парола (касата приема само двата входа).
    loginWithPassword: "Влез с потребител и парола",
    unavailableOffline: "Недостъпно без интернет",
    panelKicker: "Офлайн резерв",
    panelTitle: "Локален резерв",
    stateReady: "Готов",
    stateUnreachable: "Няма достъп",
    stateDisabled: "Изключен",
    stateUnknown: "Непроверен",
    stateNoMaster: "Касата не е на връзка",
    stateLocalNow: "В локален режим",
    // Панелът „Офлайн резерв" е на две части (Конфигурация → Устройства):
    // ключът е за ЦЕЛИЯ обект, подготовката — за всяко устройство поотделно.
    sectionSite: "Обектът",
    sectionDevice: "Това устройство",
    stateEnabled: "Включен",
    siteEnabledHint:
      "Загуби ли интернетът, всички подготвени терминали и монитори продължават срещу главната каса.",
    siteOnceHint:
      "Резервът е един за целия обект — включва се веднъж, от който и да е терминал. Изключването също важи за всички.",
    deviceNeedsSite:
      "Първо включи резерва за обекта — после подготви всяко устройство поотделно.",
    disableTitle: "Изключване на офлайн резерва",
    disableQuestion:
      "Резервът се изключва за ЦЕЛИЯ обект — при загуба на интернет спират всички терминали, не само този. Да го изключа ли?",
    disableConfirm: "Да, изключи за обекта",
    compactSummary: "Включен за обекта · това устройство е готово за работа без интернет",
    showDetails: "Подробно",
    hideDetails: "Скрий",
    hintReady:
      "Браузърът стига до главната каса на {{address}}. Загуби ли интернетът, маркирането, кухненските билети и закриването продължават срещу нея.",
    hintUnreachable:
      "Браузърът не стига до касата на {{address}}. Разреши достъпа до локалната мрежа (Chrome/Edge), провери, че FiscalAPI на главната каса е с включен резерв, и натисни „Провери“.",
    hintNoMaster:
      "Нито една инсталация на FiscalAPI не обявява резерв. Включи го в портала на главната каса и изчакай да се обяви.",
    hintDisabled:
      "При загуба на интернет терминалите спират. Включи резерва, за да продължи маркирането срещу главната каса.",
    hintUnknown:
      "Още не е проверено дали браузърът стига до касата — натисни „Провери“.",
    hintLocalNow:
      "Този терминал в момента работи срещу касата. Връщането към облака е автоматично, щом интернетът се върне и касата изпрати дневника си.",
    hintUnresolved_one:
      "Касата държи {{count}} действие, което облакът е отказал — качва се само след намеса на човек при нея („Опитай пак“ или „Отпиши“ в портала ѝ). Дотогава терминалите остават в локален режим, за да не изчезне направеното.",
    hintUnresolved_other:
      "Касата държи {{count}} действия, които облакът е отказал — качват се само след намеса на човек при нея („Опитай пак“ или „Отпиши“ в портала ѝ). Дотогава терминалите остават в локален режим, за да не изчезне направеното.",
    cloudModeLocal:
      "Облакът смята ресторанта за „в локален режим“ — закриването е възможно само от касата, докато тя не изпрати дневника си.",
    forceCloudHint:
      "„Върни към облака“ само ако касата е спряна и няма какво да изпрати — иначе направеното без връзка ще пристигне със закъснение.",
    // Готовността на ОБЕКТА, не на касата: резервът се пали веднъж, но
    // разрешението за локалната мрежа се дава на всяко устройство поотделно.
    clientsSeen_one: "{{count}} устройство я е ползвало през последните 24 ч",
    clientsSeen_other: "{{count}} устройства са я ползвали през последните 24 ч",
    clientsSeenNone:
      "Нито едно устройство не я е ползвало през последните 24 ч — спре ли интернетът, ще мълчат всички. Подготви всеки терминал и монитор от бутона на неговия екран.",
    presenceStale: "Касата мълчи — последно видяна в {{time}}.",
    pendingEvents_one:
      "Касата държи {{count}} събитие, което още не е качила — качва се само.",
    pendingEvents_other:
      "Касата държи {{count}} събития, които още не е качила — качват се сами.",
    // Бутонът, който вдига подканата на браузъра (тя идва само при действие на
    // човек) и сваля наведнъж това, което екранът ще иска без интернет.
    // Излиза заедно с подканата на браузъра, когато тя идва сама при първото
    // докосване (`lib/edge/edgePermission.ts`): отказът е окончателен, а
    // текстът на Chrome не казва защо това устройство има нужда от касата.
    lnaPrompt:
      "Браузърът пита за достъп до касата в локалната мрежа — натисни „Разреши“, за да работи това устройство и без интернет.",
    lnaDenied:
      "Достъпът до касата в локалната мрежа е отказан на това устройство — разреши го от иконата вляво на адреса, иначе без интернет екранът ще мълчи.",
    prepareDevice: "Подготви това устройство",
    prepareDeviceHint:
      "Иска разрешението за локалната мрежа и сваля данните, които този екран ще ползва без интернет.",
    preparing: "Подготвя…",
    prepareReady: "Готово — това устройство ще работи офлайн.",
    prepareBlocked:
      "Браузърът отказа достъп до локалната мрежа — разреши го от иконата вляво на адреса и натисни пак.",
    prepareDisabled:
      "Локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    prepareNoMaster:
      "Касата още не е обявила адрес — включи резерва в портала ѝ и опитай пак.",
    prepareLocalNow:
      "Този екран вече работи срещу касата — няма какво да се подготвя.",
    masterClientId: "Главна каса",
    address: "Адрес",
    check: "Провери",
    checking: "Проверява…",
    enable: "Включи",
    disable: "Изключи",
    forceCloud: "Върни към облака",
    updateError: "Настройката не се записа",
    // Шестте състояния на връзката (`lib/edge/edgeMode.ts`). Пишат се в
    // `edgeSlice.linkMessage` като КЛЮЧ и се превеждат при рендера.
    // Всяко изречение казва и какво да направи човекът — „грешка" без
    // следваща стъпка е причината сервитьорът да натисне пак и пак.
    // Заглавията („kicker") на лентата — по едно на състояние. Те СЪЩО са тук,
    // а не само като `defaultValue` в компонента: иначе на английски екран
    // човекът чете български в средата на изречението.
    linkTitleSlow: "Бавна връзка",
    linkTitleSuspect: "Проверявам връзката",
    linkTitleDeviceOffline: "Само това устройство",
    linkTitleAppDown: "Облакът се обновява",
    linkSlow: "Връзката е бавна — изчакай, заявката още върви.",
    linkSuspect: "Проверява се връзката с облака…",
    linkDeviceOffline:
      "Само това устройство е без интернет — касата е на линия. Провери Wi-Fi-а му; останалите работят нормално.",
    linkAppDown:
      "Облакът не отговаря, но мрежата е наред — най-вероятно се обновява. Изчакай малко.",
    linkLocal: "Локален режим — работи се срещу касата.",
    tillBackTerminalBlind:
      "Касата вече работи срещу облака, а това устройство още няма интернет — новите действия ще се отказват. Провери Wi-Fi-а на този терминал.",
    linkLostNoFallback:
      "Няма връзка с облака, а локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    // Ръчното превключване (бутонът е на друг екран; текстовете стоят тук,
    // за да са едни и същи, където и да се появи).
    forceLocal: "Включи локален режим",
    forceLocalHint:
      "Замразява ЦЕЛИЯ обект срещу касата — всички терминали започват да работят срещу нея. Използвай само когато обектът стои, а автоматиката не е превключила.",
    forceLocalQuestion:
      "Целият обект минава на работа срещу касата. Да превключа ли сега?",
    forceLocalConfirm: "Да, премини на локален режим",
    forceLocalEntered: "Готово — терминалите работят срещу касата.",
    forceLocalNoPermission:
      "Нямаш право да превключваш режима — извикай отговорника за касата.",
    forceLocalDisabled:
      "Локалният резерв е изключен за този обект — включи го от Конфигурация → Устройства.",
    forceLocalNoTill: "Касата не е обявила адрес — няма към кого да се превключи.",
    forceLocalFailed:
      "Касата не пое — провери, че FiscalAPI на главната каса работи, и опитай пак.",
    // Касата е задържана в локален режим по РЪЧНО решение (§19.5) — не „чака
    // да изпрати", а чака човек да я върне.
    bannerManualHold: "касата е в локален режим по ръчно решение",
    bannerManualHoldCloudBack:
      "интернетът се върна, но касата е задържана в локален режим ръчно — върни я към облака",
    releaseLocal: "Върни към облака",
    releaseLocalHint:
      "Касата изпраща направеното без интернет и целият обект се връща към облака. Направи го само ако интернетът работи на терминалите.",
    releaseLocalQuestion: "Да върна ли обекта към облака сега?",
    releaseLocalConfirm: "Да, върни към облака",
    releaseLocalFailed:
      "Връщането не стана. Опитай пак или го направи от касата.",
  },
  lunchMenu: {
    title: "Обедно меню",
    tag: "Обедно",
    backToTables: "Към масите",
    kickerToday: "Днес",
    kickerUpcoming: "Предстоящи",
    kickerPast: "Минали",
    statusLive: "Активно сега",
    statusToday: "По-късно днес",
    statusTomorrow: "Утре",
    statusUpcoming: "Предстои",
    statusRecurring: "Повтарящо се",
    statusPast: "Изтекло",
    newMenu: "Ново обедно меню",
    edit: "Редактирай",
    copy: "Копирай",
    print: "Печат",
    finishNow: "Приключи сега",
    delete: "Изтрий",
    colProduct: "Продукт",
    colSize: "Размер",
    colPortions: "Порции/ден",
    colMain: "Основна",
    colLunch: "Обедна",
    changedSizeHint: "Зачертано е стойността в асортимента, до нея — обедната. Асортиментът не се променя.",
    createdBy: "Създадено от {{name}}",
    productsCount_one: "{{count}} продукт",
    productsCount_other: "{{count}} продукта",
    pickMenu: "Избери меню от списъка.",
    missingProduct: "Продуктът вече не е в менюто",
    everyWeekdays: "всеки {{days}}",
    everyDay: "всеки ден",
    periodOpenEnded: "от {{from}}",
    defaultName: "Обяд · {{day}} · {{date}}",
    creatingTitle: "Създаване на обедно меню",
    editingTitle: "Редакция на обедно меню",
    emptyTitle: "Още няма обедни менюта",
    emptyText: "Създай първото — избери продукти от каталога, сложи им обедна цена и задай кога да се показва в Маркиране.",
    weekdayShort0: "нд",
    weekdayShort1: "пн",
    weekdayShort2: "вт",
    weekdayShort3: "ср",
    weekdayShort4: "чт",
    weekdayShort5: "пт",
    weekdayShort6: "сб",
    weekdayLong0: "неделя",
    weekdayLong1: "понеделник",
    weekdayLong2: "вторник",
    weekdayLong3: "сряда",
    weekdayLong4: "четвъртък",
    weekdayLong5: "петък",
    weekdayLong6: "събота",
    dayButton0: "Нд",
    dayButton1: "Пн",
    dayButton2: "Вт",
    dayButton3: "Ср",
    dayButton4: "Чт",
    dayButton5: "Пт",
    dayButton6: "Сб",
    confirmDeleteTitle: "Изтриване на обедно меню",
    confirmDeleteMessage: "„{{name}}“ ще изчезне от списъка. Продажбите от него остават в отчетите.",
    confirmFinishTitle: "Приключване на обедно меню",
    confirmFinishMessage: "„{{name}}“ спира веднага и отива в „Минали“.",
    confirmFinish: "Приключи",
    saved: "Обедното меню е запазено",
    deleted: "Обедното меню е изтрито",
    finished: "Обедното меню е приключено",
    loadError: "Обедното меню не можа да се зареди",
    editorKicker: "Обедно меню",
    products: "Продукти",
    priceColumnsHint: "обедна / основна цена",
    emptySelection: "Избери продукти от каталога вляво.",
    emptySelectionNarrow: "Избери продукти от каталога.",
    save: "Запази",
    reviewAndSave: "Преглед и запазване",
    scheduleChange: "Промени",
    scheduleSingleDate: "една дата",
    scheduleTitle: "Кога е активно",
    scheduleSubtitle: "Извън този период менюто не се показва в Маркиране.",
    name: "Име",
    modeSingle: "За една дата",
    modeRecurring: "Повтарящо се",
    date: "Дата",
    today: "Днес",
    tomorrow: "Утре",
    weekdays: "Дни от седмицата",
    period: "Период",
    periodFrom: "от",
    periodTo: "до",
    noEndDate: "без крайна дата",
    hours: "Часове",
    done: "Готово",
    errorName: "Въведи име на менюто.",
    errorItems: "Избери поне един продукт.",
    errorTime: "Началният час трябва да е преди крайния.",
    errorWeekdays: "Избери поне един ден от седмицата.",
    errorPeriod: "Крайната дата е преди началната.",
    errorPastDate: "Датата трябва да е днешна или бъдеща.",
    errorFarDate: "Датата може да е най-много 2 години напред.",
    priceTooHigh: "Най-много {{max}}",
    reorderEnded: "Обедното меню е приключило — този продукт не може да се поръча пак от него.",
    orderEnded: "Обедното меню е приключило — продуктите от него минаха на основната цена. Провери поръчката и я изпрати пак.",
    recipeSizeFixed: "Работите със склад — количеството е това на рецептата и не се сменя. В обедното меню се сменя само цената.",
    cartSwitchedToRegular_one: "Обедното меню приключи — 1 продукт в поръчката вече е с основната цена.",
    cartSwitchedToRegular_other: "Обедното меню приключи — {{count}} продукта в поръчката вече са с основната цена.",
    modalClosedEnded: "Обедното меню приключи — прозорецът на обедния продукт е затворен.",
    cartRemoved_one: "1 продукт от обедното меню вече не е в менюто и отпадна от поръчката.",
    cartRemoved_other: "{{count}} продукта от обедното меню вече не са в менюто и отпаднаха от поръчката.",
    errorPrice: "Провери цените — има празна или невалидна.",
    dailyLimitTitle: "Порции на ден",
    dailyLimitInvalid: "Цяло число от 0 до {{max}}",
    dailyLimitHint: "0 = без ограничение · напр. 20 → след 20 продадени за деня става „Изчерпано“",
    dailyLimitShort: "{{count}}/ден",
    dailyLimitUnlimited: "Без ограничение",
    errorDailyLimit: "Провери порциите на ден — цяло число от 0 до 9 999.",
    countLeft: "{{count}} бр",
    tagSoldOut: "Изчерпано",
    remainingTitle_one: "Остава {{count}} порция за днес",
    remainingTitle_other: "Остават {{count}} порции за днес",
    limitSoldOut: "„{{name}}“ от обедното меню е изчерпан за днес.",
    limitOnlyLeft_one: "„{{name}}“ — от обедното меню остава само {{count}} порция за днес.",
    limitOnlyLeft_other: "„{{name}}“ — от обедното меню остават само {{count}} порции за днес.",
    limitReachedOrder: "Порциите от обедното меню не стигат: {{items}}. Броят е обновен — намали количеството.",
    limitReachedItem: "„{{name}}“ (остават {{count}})",
    lunchPrice: "Обедна цена",
    mainPriceSubtitle: "основна цена {{price}}",
    resetPrice: "Върни основната цена",
    mainPriceShort: "основна",
    sizeTitle: "Единица и размер",
    byLanguage: "по езици",
    inAssortment: "в асортимента: {{value}}",
    fromAssortment: "празно → от асортимента",
    sizeScopeHint: "Промяната важи само за това обедно меню — асортиментът не се пипа.",
    remove: "Махни",
    apply: "Приложи",
    overlapTitle: "Има обедно меню за този период",
    overlapMessage: "„{{name}}“ ({{schedule}}) се застъпва с новото. В един момент може да е активно само едно обедно меню.",
    finishOld: "Приключи старото",
    finishOldHint: "Старото ще важи до {{endDate}} включително, защото новото започва на {{startDate}} и двете не могат да са активни едновременно. После остава в „Минали“.",
    finishOldNowHint: "Спира веднага и остава в „Минали“ — от този момент важи новото.",
    deleteOld: "Изтрий старото",
    deleteOldHint: "Изчезва от списъка. Продажбите от него остават в отчетите.",
    finishAndSave: "Приключи и запази",
    deleteAndSave: "Изтрий и запази",
    printPricesNote: "Цените са в евро с включен ДДС.",
    printAllergensTitle: "Алергени",
  },
  // „Настани" от Маркиране (src/pages/ordering/components/tables/seat/).
  seatReservation: {
    action: "Настани",
    title: "Настани резервация",
    lateShort: "−{{duration}}",
    soonShort: "след {{duration}}",
    now: "сега",
    tables_one: "Маса {{tables}}",
    tables_other: "Маси {{tables}}",
    emptyHint: "Резервациите за днес ще се появят тук.",
    noResults: "Няма резервации по търсенето",
    loadError: "Резервациите не се заредиха",
    retry: "Опитай пак",
    noTable: "Масите на резервацията са изтрити от схемата",
    expired: "Часът на резервацията изтече",
    notUpcoming: "Резервацията вече не е предстояща",
    seat: "Настани",
    takenBy: "Маса {{table}} е заета от {{waiter}}",
    takenByOther: "Маса {{table}} е заета от друг сервитьор",
    // Въпросът „къде да настаним" (SeatChoiceModal.tsx) — вляво резервацията,
    // вдясно изборът; целите — един шаблон за всички случаи (useSeatChoiceText.ts).
    choice: {
      title: "Настани {{guest}}?",
      pickBill: "Към коя сметка",
      pickBillOnTable: "Към коя сметка на маса {{table}}",
      outcome: "Какво ще стане",
      opens: "Ще се отвори",
      open: "Отворена",
      newTable: "Нова маса {{table}}",
      onWaiter: "на {{waiter}}",
      // Изключеният „Настани", докато при няколко възможности няма избрана.
      pickTable: "Избери сметка",
    },
    // Сметките при резервация с няколко маси (SeatBillsSection.tsx); другите
    // текстове са общите с „Резервации" (reservations.seatBills).
    bills: {
      label: "Как да се водят сметките",
      singleSummary: "Всички маси на една сметка",
    },
    success: "{{guest}} — настанени на маса {{table}}",
    successSeparate: "{{guest}} — настанени на маси {{tables}}, отделна сметка за всяка маса",
  },
  // Модул „Резервации" (src/pages/reservations/).
  reservations: {
    title: "Резервации",
    counts: {
      reservations_one: "{{count}} резервация",
      reservations_other: "{{count}} резервации",
      guests_one: "{{count}} гост",
      guests_other: "{{count}} гости",
      seats_one: "{{count}} място",
      seats_other: "{{count}} места",
    },
    duration: {
      minutes: "{{minutes}} мин",
      hours: "{{hours}} ч",
      hoursMinutes: "{{hours}} ч {{minutes}} мин",
    },
    day: {
      today: "Днес, {{date}}",
      tomorrow: "Утре, {{date}}",
      yesterday: "Вчера, {{date}}",
      previous: "Предишен ден",
      next: "Следващ ден",
      pick: "Избери дата",
    },
    newReservation: "Нова резервация",
    timeline: {
      now: "Сега",
      preview: "Преглед към",
      earlier: "По-рано",
      backToNow: "Сега",
      slider: "Час от деня",
      outside: "Извън {{from}}–{{to}}",
      inFuture: "след {{duration}}",
      inPast: "преди {{duration}}",
    },
    legend: {
      free: "Свободна",
      reserved: "Резервирана",
      occupied: "Заета",
      nextReservation: "Час на следващата резервация",
      fits: "Побира гостите",
      selected: "Избрана",
      blocked: "Заета в този час",
    },
    table: {
      name: "Маса {{name}}",
      hover: "Маса {{name}} · {{seats}}",
      hoverReserved: "резервирана {{time}} · {{guest}}",
      hoverOccupied: "заета {{duration}}",
      hoverNext: "следваща резервация {{time}}",
    },
    popover: {
      close: "Затвори",
      status: {
        free: "Свободна",
        reserved: "Резервирана",
        occupied: "Заета",
      },
      late: "Закъснява {{duration}}",
      arriving: "Пристига след {{duration}}",
      seatedAt: "Настанени в {{time}} · {{duration}}",
      finished: "Приключила резервация",
      reservedMeanwhile: "Резервация в този час",
      occupiedSince: "Заета · от {{time}} · {{duration}}",
      freeUntil: "Свободна до {{time}}",
      freeAllDay: "Свободна до края на деня",
      next: "Следваща резервация",
      nextDetails_one: "{{time}} · {{guest}}, {{count}} гост",
      nextDetails_other: "{{time}} · {{guest}}, {{count}} гости",
      seat: "Настани гостите",
      cancel: "Откажи резервацията",
      release: "Гостите си тръгнаха",
      reserveTable: "Резервирай тази маса",
      seatBlockedOccupied_one: "Маса {{tables}} е заета от настанена резервация",
      seatBlockedOccupied_other: "Масите {{tables}} са заети от настанена резервация",
      seatBlockedEarly: "Може да се настани след {{time}}",
      seatBlockedPreviousBill: "Сметката на предишната резервация на маса {{table}} ({{waiter}}) още не е закрита",
      seatBlockedPreviousBillNoWaiter: "Сметката на предишната резервация на маса {{table}} още не е закрита",
      seatAttachHint: "Ще се закачи към отворената сметка на {{waiter}}",
      seatAttachHintNoWaiter: "Ще се закачи към отворената сметка на масата",
      seatPickHint: "На масата има няколко отворени сметки — ще избереш при кой сервитьор",
      edit: "Редактирай",
      unseat: "Отмени настаняването",
      restore: "Върни в „Предстоящи“",
    },
    confirmCancel: {
      title: "Да откажем ли резервацията?",
      content_one: "{{guest}} · {{time}} · Маса {{tables}}. Масата се освобождава за този час.",
      content_other: "{{guest}} · {{time}} · Масите {{tables}}. Масите се освобождават за този час.",
      ok: "Откажи резервацията",
      back: "Назад",
    },
    confirmUnseat: {
      title: "Да отменим ли настаняването?",
      content_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Сметката остава в Маркиране.",
      content_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Сметката остава в Маркиране.",
      contentBillCloses_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Празната сметка на маса {{billTable}} ще бъде премахната — никой още не е поръчал.",
      contentBillCloses_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Празната сметка на маса {{billTable}} ще бъде премахната — никой още не е поръчал.",
      contentBillsClose_one: "{{guest}} · Маса {{tables}}. Резервацията се връща в „Предстоящи“. Празните сметки на маси {{billTables}} ще бъдат премахнати — никой още не е поръчал.",
      contentBillsClose_other: "{{guest}} · Масите {{tables}}. Резервацията се връща в „Предстоящи“. Празните сметки на маси {{billTables}} ще бъдат премахнати — никой още не е поръчал.",
      ok: "Отмени настаняването",
      back: "Назад",
    },
    seatBills: {
      group: "Сметките на резервацията",
      single: "Една сметка",
      singlePick: "На масите има няколко отворени сметки — избери към коя",
      separate: "Отделна сметка за всяка маса",
      separateSummary_one: "{{count}} сметка на резервацията",
      separateSummary_other: "{{count}} сметки на резервацията — по една на маса",
      separateLocalMode: "Само с интернет — касата отваря една сметка",
      // „Отделна…" при няколко сметки на маса (seatBills.ts `separatePlanOf`, orderingSeatBills.ts).
      pickOnTable: "На маса {{table}} има няколко отворени сметки — избери към коя",
      noBillOfWaiter: "На маса {{table}} има няколко отворени сметки и нито една не е на {{waiter}}",
      noOwnBill: "На маса {{table}} има няколко отворени сметки и нито една не е твоя",
      confirm: "Настани",
      back: "Назад",
    },
    seatPicker: {
      title: "При кой сервитьор да настаним?",
      subtitle_one: "{{guest}} · Маса {{tables}}. На масата има няколко отворени сметки — резервацията ще се закачи към избраната.",
      subtitle_other: "{{guest}} · Масите {{tables}}. На масите има няколко отворени сметки — резервацията ще се закачи към избраната.",
      unknownWaiter: "Неизвестен сервитьор",
      table: "Маса {{name}}",
      openedAgo: "отворена преди {{duration}}",
      openedJustNow: "отворена току-що",
      close: "Назад",
    },
    messages: {
      seated: "Гостите са настанени — сметката на масата е отворена",
      seatedNewBill: "Гостите са настанени. Масата ще е на сервитьора, който поръча първи",
      seatedAttached: "Гостите са настанени при {{waiter}}",
      seatedAttachedNoWaiter: "Гостите са настанени — резервацията е закачена към отворената сметка",
      seatedSeparate: "Гостите са настанени — отделна сметка за всяка маса ({{tables}})",
      unseated: "Настаняването е отменено",
      unseatedBillClosed: "Настаняването е отменено. Празната сметка на маса {{table}} е премахната",
      unseatedBillsClosed: "Настаняването е отменено. Празните сметки на маси {{tables}} са премахнати",
      unseatedBillClosedNoTable: "Настаняването е отменено. Празната сметка е премахната",
      restored: "Резервацията е върната в „Предстоящи“",
      restoredExpired: "Часът ѝ е минал — резервацията остава в „Минали“ като „Неизпълнена“",
      released: "Резервацията е приключена",
      releasedBillOpen: "Резервацията е приключена. Масата остава заета, докато сметката не се закрие в Маркиране",
      cancelled: "Резервацията е отказана",
      seatUnavailable: "Резервацията вече не може да бъде настанена",
      actionFailed: "Действието не беше изпълнено",
    },
    offlineHint: "Резервациите работят само с интернет — касата няма схемата и резервациите.",
    offlineStaleHint: "Касата няма пресни данни за този ден — избери ден около днешния или изчакай интернета.",
    dataAsOf: "данни към {{time}}",
    loadError: "Резервациите не се заредиха",
    loadErrorHint: "Провери връзката и опитай пак след малко.",
    noSchema: {
      title: "Няма схема на заведението",
      description: "Нарисувай районите и масите в Резервации → Схема на заведението — резервациите се правят върху нея.",
    },
    noTables: {
      title: "Още няма маси",
      description:
        "Резервациите се правят върху масите от схемата на заведението. Подреди там районите и масите — после ще ги виждаш и тук.",
      action: "Към схемата на заведението",
    },
    noTablesInRegion: {
      title: "В този район още няма маси",
      description: "Подреди масите му в схемата на заведението — после ще ги виждаш и тук.",
    },
    regionAll: "Всички",
    emptyRegion: "В този район още няма маси.",
    list: {
      tabs: {
        upcoming: "Предстоящи",
        seated: "Настанени",
        past: "Минали",
      },
      search: "Име, телефон или маса",
      clearSearch: "Изчисти търсенето",
      seat: "Настани",
      release: "Тръгнаха си",
      tableInRegion: "{{table}} · {{region}}",
      late: "Закъснява {{duration}}",
      soon: "След {{duration}}",
      seatedUntil: "Настанени {{time}} – {{until}}",
      completed: "Приключила",
      cancelled: "Отказана",
      expired: "Неизпълнена",
      empty: {
        upcoming: "Няма предстоящи резервации за деня",
        seated: "Няма настанени гости",
        past: "Още няма минали резервации",
      },
      noMatches: "Няма резервации по това търсене",
      noTable: "Без маса",
      cancel: "Откажи",
      restore: "Върни",
      edit: "Редактирай",
      unseat: "Отмени настаняването",
      moment: {
        tabHasActive: "Има резервации на масите към {{time}}",
      },
    },
    form: {
      title: "Нова резервация",
      editTitle: "Редакция на резервация",
      close: "Затвори",
      when: "Кога",
      today: "Днес",
      tomorrow: "Утре",
      otherDate: "Друга дата…",
      guests: "Гости",
      fewerGuests: "По-малко гости",
      moreGuests: "Повече гости",
      duration: "Продължителност",
      tables: "Маси",
      suggest: "Предложи маса",
      noSuggestion_one: "Няма свободна маса за {{count}} гост в този час",
      noSuggestion_other: "Няма свободна маса за {{count}} гости в този час",
      tablesEmpty: "Кликни свободна маса на схемата. Може да избереш няколко за по-голяма група.",
      tableChip: "Маса {{name}} · {{seats}}",
      removeTable: "Махни маса {{name}}",
      seatsEnough: "{{seats}} за {{guests}}",
      seatsShort: "Недостатъчно места: {{seats}} за {{guests}}",
      tablesBusy: "Заета в този час: {{names}} — избери друга маса",
      freeInRegion: "Свободни маси за {{guests}} в „{{region}}“ · {{time}}. Избери една или няколко.",
      noFreeInRegion: "Няма свободна маса за {{guests}} тук — виж друг район или покажи всички маси.",
      showAllTables: "Покажи всички маси ({{count}})",
      showOfferedOnly: "Покажи само свободните",
      regionHasSelected: "Има избрана маса",
      region: "Район",
      freeCount_one: "{{count}} свободна",
      freeCount_other: "{{count}} свободни",
      guest: "Гост",
      phone: "Телефон",
      name: "Име",
      note: "Забележка — повод, алергии, детско столче…",
      cancel: "Отказ",
      create: "Създай резервация",
      created: "Резервацията е създадена",
      createFailed: "Резервацията не беше създадена",
      save: "Запази промените",
      saved: "Промените са запазени",
      saveFailed: "Промените не бяха запазени",
      dayLoading: "Заетостта на масите за деня се зарежда…",
      dayError: "Заетостта на масите за деня не се зареди",
      retry: "Опитай пак",
      slotPast: "Избраният час мина — избери друг",
      dayClosed: "Почивен ден — не се приемат резервации",
      slotOutsideHours: "Часът е извън работното време — избери друг",
      afterMidnightHint: "Часовете след полунощ ({{from}}–{{to}}) са на {{day}}",
      errors: {
        startAt: "Невалиден ден или час на резервацията",
        durationMinutes: "Продължителността трябва да е между 30 и 480 минути",
        guests: "Броят гости трябва да е между 1 и 500",
        guestName: "Въведи име (до 100 знака)",
        phone: "Невалиден телефонен номер",
        nameRequired: "Въведи име",
        phoneInvalid: "Невалиден телефонен номер",
        note: "Невалидна забележка",
        tableIds: "Избери поне една маса",
      },
      // Познатият телефон: чипът в полето „Телефон" и картата с историята.
      guestHistory: {
        title: "История",
        show: "Покажи историята на госта",
        hide: "Скрий историята на госта",
        misses: "Има отказани или неизпълнени резервации",
        reservations_one: "{{count}} резервация",
        reservations_other: "{{count}} резервации",
        visits_one: "{{count}} посещение",
        visits_other: "{{count}} посещения",
        lastVisit: "Последно идване",
        averageBill: "Средна сметка",
        expired_one: "{{count}} неизпълнена",
        expired_other: "{{count}} неизпълнени",
        cancelled_one: "{{count}} отказана",
        cancelled_other: "{{count}} отказани",
        upcoming_one: "{{count}} предстояща",
        upcoming_other: "{{count}} предстоящи",
        seated_one: "{{count}} настанена сега",
        seated_other: "{{count}} настанени сега",
        lastNote: "Последна бележка",
      },
    },
    picker: {
      badgeSelected: "Избрана",
      badgeBusy: "Заета",
      hoverBusy: "заета в този час",
      hoverSelected: "избрана",
      hoverFits: "побира гостите",
    },
  },
  reservationsTable: {
    title: "Таблица на резервациите",
    table: "Маса",
    search: "Търсене по маса или гост…",
    noMatch: "Няма маси за това търсене.",
    hideUntil: "Скрий до 1-ва резервация",
    hideUntilHint: "Крие часовете преди първата предстояща или настанена резервация",
    showWholeDay: "Покажи целия ден",
    hourLoadHint: "Резервации | гости в този час",
    newAt: "Нова резервация — {{table}}, {{time}}",
    now: "сега {{time}}",
    onlyUpcomingEditable: "Може да се редактира само предстояща резервация",
    legend: {
      expired: "Неизпълнена",
      completed: "Приключила",
    },
  },
};

export default bg;
